import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Date custom scalar type */
  Date: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** Date custom object type */
  JSONObject: any;
  Upload: any;
};

/** About data */
export type About = {
  info?: Maybe<AboutInfo>;
  menu?: Maybe<Array<Maybe<MenuType>>>;
  relations?: Maybe<Array<Maybe<AboutRelation>>>;
  story?: Maybe<Scalars['String']>;
};

/** AboutInfo data */
export type AboutInfo = {
  /** The fileEntityData */
  aboutCover?: Maybe<FileDetail>;
  aboutCoverId?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  bannerLogo?: Maybe<FileDetail>;
  bannerLogoId?: Maybe<Scalars['String']>;
  /** The cityData */
  city?: Maybe<City>;
  cityId?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  /** The districtData */
  district?: Maybe<District>;
  districtId?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  /** The FullAddressData */
  fullAddress?: Maybe<Scalars['String']>;
  homeNumber?: Maybe<Scalars['String']>;
  /** The fileEntityData */
  logo?: Maybe<FileDetail>;
  logoId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  relations?: Maybe<Scalars['String']>;
  story?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  watermark?: Maybe<FileDetail>;
  watermarkId?: Maybe<Scalars['String']>;
};

/** AboutInfoInput data */
export type AboutInfoInput = {
  aboutCover?: InputMaybe<Scalars['Upload']>;
  address?: InputMaybe<Scalars['String']>;
  bannerLogo?: InputMaybe<Scalars['Upload']>;
  cityId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  districtId?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  homeNumber?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['Upload']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  relations?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  watermark?: InputMaybe<Scalars['Upload']>;
};

/** AboutInput data */
export type AboutInput = {
  info?: InputMaybe<AboutInfoInput>;
  relations?: InputMaybe<Array<InputMaybe<AboutRelationInput>>>;
  relationsWithImgs?: InputMaybe<Array<InputMaybe<AboutRelationInput>>>;
  story?: InputMaybe<Scalars['String']>;
};

/** AboutRelation data */
export type AboutRelation = {
  link?: Maybe<Scalars['String']>;
  /** The fileEntityData */
  logo?: Maybe<FileDetail>;
  logoId?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

/** AboutRelationInput data */
export type AboutRelationInput = {
  link?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['Upload']>;
  logoId?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

/** AgentDetailType data */
export type AgentDetail = {
  idNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

/** AgentDetail data */
export type AgentDetailInput = {
  idNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

/** announcement data */
export type Announcement = {
  body?: Maybe<Scalars['String']>;
  category?: Maybe<AnnouncementCategory>;
  categoryId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  enable?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  info?: Maybe<InfoType>;
  period?: Maybe<FromToDetail>;
  subject?: Maybe<Scalars['String']>;
  toDepartments?: Maybe<Array<Maybe<Department>>>;
  toUsers?: Maybe<Array<Maybe<User>>>;
};

/** announcementCategory data */
export type AnnouncementCategory = {
  announcements?: Maybe<Array<Maybe<Announcement>>>;
  color?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['Int']>;
};

/** PageInfo data */
export type AnnouncementCategoryEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AnnouncementCategory>;
};

/** AnnouncementCategory data */
export type AnnouncementCategoryInput = {
  announcements?: InputMaybe<Array<InputMaybe<AnnouncementInput>>>;
  color?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['Int']>;
};

/** Pagination data */
export type AnnouncementCategoryPagination = {
  edges?: Maybe<Array<Maybe<AnnouncementCategoryEdgeType>>>;
  nodes?: Maybe<Array<Maybe<AnnouncementCategory>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** AnnouncementCategory data */
export type AnnouncementCategorySearchInput = {
  type?: InputMaybe<Scalars['String']>;
};

/** PageInfo data */
export type AnnouncementEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Announcement>;
};

/** Announcement data */
export type AnnouncementInput = {
  body?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<BlogCategoryInput>;
  categoryId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  enable?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  period?: InputMaybe<FromToDetailInput>;
  subject?: InputMaybe<Scalars['String']>;
  toDepartments?: InputMaybe<Array<InputMaybe<DepartmentInput>>>;
  toUsers?: InputMaybe<Array<InputMaybe<UserInput>>>;
};

/** Pagination data */
export type AnnouncementPagination = {
  edges?: Maybe<Array<Maybe<AnnouncementEdgeType>>>;
  nodes?: Maybe<Array<Maybe<Announcement>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Announcement data */
export type AnnouncementSearchInput = {
  category?: InputMaybe<Scalars['String']>;
  creatorId?: InputMaybe<Scalars['String']>;
  creatorNotBeId?: InputMaybe<Scalars['String']>;
  departmentId?: InputMaybe<Scalars['String']>;
  period?: InputMaybe<FromToDetailInput>;
  subject?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Auth data */
export type Auth = {
  data?: Maybe<User>;
  token?: Maybe<Scalars['String']>;
  tokenExpiration?: Maybe<Scalars['String']>;
};

export type BasePriceData = {
  orderAttachment?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  rentAttachments?: Maybe<Array<Maybe<RentAttachment>>>;
  show?: Maybe<Scalars['Boolean']>;
};

/** blog data */
export type Blog = {
  body?: Maybe<Scalars['String']>;
  category?: Maybe<BlogCategory>;
  categoryId?: Maybe<Scalars['String']>;
  cover?: Maybe<FileDetail>;
  description?: Maybe<Scalars['String']>;
  enable?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  info?: Maybe<InfoType>;
  photos?: Maybe<Array<Maybe<InfoPhoto>>>;
  related?: Maybe<Array<Maybe<Blog>>>;
  sort?: Maybe<Scalars['Int']>;
  subject?: Maybe<Scalars['String']>;
};

/** blogCategory data */
export type BlogCategory = {
  blogs?: Maybe<Array<Maybe<Blog>>>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['Int']>;
};

/** PageInfo data */
export type BlogCategoryEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<BlogCategory>;
};

/** BlogCategory data */
export type BlogCategoryInput = {
  blogs?: InputMaybe<Array<InputMaybe<BlogInput>>>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['Int']>;
};

/** Pagination data */
export type BlogCategoryPagination = {
  edges?: Maybe<Array<Maybe<BlogCategoryEdgeType>>>;
  nodes?: Maybe<Array<Maybe<BlogCategory>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** BlogCategory data */
export type BlogCategorySearchInput = {
  blogs?: InputMaybe<Array<InputMaybe<BlogInput>>>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** PageInfo data */
export type BlogEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Blog>;
};

/** Blog data */
export type BlogInput = {
  body?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<BlogCategoryInput>;
  categoryId?: InputMaybe<Scalars['String']>;
  cover?: InputMaybe<Scalars['Upload']>;
  creatorId?: InputMaybe<Scalars['String']>;
  deletePhotos?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  enable?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  photos?: InputMaybe<Array<InputMaybe<InfoPhotoInput>>>;
  sort?: InputMaybe<Scalars['Int']>;
  subject?: InputMaybe<Scalars['String']>;
  updatePhotos?: InputMaybe<Array<InputMaybe<InfoPhotoInput>>>;
};

/** Pagination data */
export type BlogPagination = {
  edges?: Maybe<Array<Maybe<BlogEdgeType>>>;
  nodes?: Maybe<Array<Maybe<Blog>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Blog data */
export type BlogSearchInput = {
  category?: InputMaybe<Scalars['String']>;
  creatorId?: InputMaybe<Scalars['String']>;
  departmentId?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** blogTag data */
export type BlogTag = {
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** PageInfo data */
export type BlogTagEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<BlogTag>;
};

/** BlogTag data */
export type BlogTagInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Pagination data */
export type BlogTagPagination = {
  edges?: Maybe<Array<Maybe<BlogTagEdgeType>>>;
  nodes?: Maybe<Array<Maybe<BlogTag>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** BlogTag data */
export type BlogTagSearchInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type BreadCrumb = {
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** city data */
export type City = {
  districts?: Maybe<Array<Maybe<District>>>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Int']>;
};

/** PageInfo data */
export type CityEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<City>;
};

/** City data */
export type CityInput = {
  districts?: InputMaybe<Array<InputMaybe<DistrictInput>>>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['Int']>;
};

/** Pagination data */
export type CityPagination = {
  edges?: Maybe<Array<Maybe<CityEdgeType>>>;
  nodes?: Maybe<Array<Maybe<City>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** City data */
export type CitySearchInput = {
  districts?: InputMaybe<Array<InputMaybe<DistrictInput>>>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['Int']>;
};

/** community data */
export type Community = {
  address?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  builderName?: Maybe<Scalars['String']>;
  city?: Maybe<City>;
  cityId?: Maybe<Scalars['Int']>;
  completeDate?: Maybe<Scalars['Date']>;
  district?: Maybe<District>;
  districtId?: Maybe<Scalars['Int']>;
  doorNumber?: Maybe<Scalars['Int']>;
  educationSchools?: Maybe<Array<Maybe<LifeFunction>>>;
  elevatorsNumber?: Maybe<Scalars['Int']>;
  fullAddress?: Maybe<Scalars['String']>;
  geopoint?: Maybe<GeoPointDetail>;
  id?: Maybe<Scalars['Int']>;
  info?: Maybe<InfoType>;
  lifeFunctions?: Maybe<Array<Maybe<LifeFunction>>>;
  liveAreas?: Maybe<Array<Maybe<LiveArea>>>;
  mainStructure?: Maybe<Scalars['Int']>;
  managementPhoneNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  otherData?: Maybe<CommunityOtherData>;
  overrideLiveAreaId?: Maybe<Scalars['Int']>;
  photos?: Maybe<Array<Maybe<InfoPhoto>>>;
  properties?: Maybe<Array<Maybe<Property>>>;
  publicUtilities?: Maybe<Array<Maybe<PropertyPublicUtility>>>;
  publicUtilitiesComment?: Maybe<Scalars['String']>;
  securityGuard?: Maybe<Scalars['Int']>;
  takeViewComment?: Maybe<Scalars['String']>;
  takeViewPrice?: Maybe<Scalars['Int']>;
  takeViewSpecialTime?: Maybe<Scalars['String']>;
  totalDoorNumber?: Maybe<Scalars['Int']>;
  totalFloorNumber?: Maybe<FloorDetail>;
  transportationFacilities?: Maybe<Array<Maybe<Mrt>>>;
};

/** PageInfo data */
export type CommunityEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Community>;
};

/** Community data */
export type CommunityInput = {
  address?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  builderName?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<CityInput>;
  cityId?: InputMaybe<Scalars['Int']>;
  completeDate?: InputMaybe<Scalars['Date']>;
  deletePhotos?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  district?: InputMaybe<DistrictInput>;
  districtId?: InputMaybe<Scalars['Int']>;
  doorNumber?: InputMaybe<Scalars['Int']>;
  educationSchools?: InputMaybe<Array<InputMaybe<LifeFunctionInput>>>;
  elevatorsNumber?: InputMaybe<Scalars['Int']>;
  geopoint?: InputMaybe<GeoPointDetailInput>;
  id?: InputMaybe<Scalars['Int']>;
  lifeFunctions?: InputMaybe<Array<InputMaybe<LifeFunctionInput>>>;
  liveAreas?: InputMaybe<Array<InputMaybe<LiveAreaInput>>>;
  mainStructure?: InputMaybe<Scalars['Int']>;
  managementPhoneNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  otherData?: InputMaybe<Scalars['String']>;
  overrideLiveAreaId?: InputMaybe<Scalars['Int']>;
  photos?: InputMaybe<Array<InputMaybe<InfoPhotoInput>>>;
  properties?: InputMaybe<Array<InputMaybe<PropertyInput>>>;
  publicUtilities?: InputMaybe<Array<InputMaybe<PropertyPublicUtilityInput>>>;
  publicUtilitiesComment?: InputMaybe<Scalars['String']>;
  securityGuard?: InputMaybe<Scalars['Int']>;
  takeViewComment?: InputMaybe<Scalars['String']>;
  takeViewPrice?: InputMaybe<Scalars['Int']>;
  takeViewSpecialTime?: InputMaybe<Scalars['String']>;
  totalDoorNumber?: InputMaybe<Scalars['Int']>;
  totalFloorNumber?: InputMaybe<FloorDetailInput>;
  transportationFacilities?: InputMaybe<Array<InputMaybe<MrtInput>>>;
  updatePhotos?: InputMaybe<Array<InputMaybe<InfoPhotoInput>>>;
};

export type CommunityOtherData = {
  education?: Maybe<Scalars['String']>;
  publicUtilities?: Maybe<Array<Maybe<PublicUtilityOtherData>>>;
};

/** Pagination data */
export type CommunityPagination = {
  edges?: Maybe<Array<Maybe<CommunityEdgeType>>>;
  nodes?: Maybe<Array<Maybe<Community>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Community data */
export type CommunitySearchInput = {
  liveAreas?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** company data */
export type Company = {
  body?: Maybe<Scalars['String']>;
  category?: Maybe<CompanyCategory>;
  categoryId?: Maybe<Scalars['String']>;
  cover?: Maybe<FileDetail>;
  description?: Maybe<Scalars['String']>;
  enable?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  info?: Maybe<InfoType>;
  location?: Maybe<Mrt>;
  name?: Maybe<Scalars['String']>;
  related?: Maybe<Array<Maybe<Company>>>;
  url?: Maybe<Scalars['String']>;
};

/** companyCategory data */
export type CompanyCategory = {
  companies?: Maybe<Array<Maybe<Company>>>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['Int']>;
};

/** PageInfo data */
export type CompanyCategoryEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<CompanyCategory>;
};

/** CompanyCategory data */
export type CompanyCategoryInput = {
  companies?: InputMaybe<Array<InputMaybe<CompanyInput>>>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['Int']>;
};

/** Pagination data */
export type CompanyCategoryPagination = {
  edges?: Maybe<Array<Maybe<CompanyCategoryEdgeType>>>;
  nodes?: Maybe<Array<Maybe<CompanyCategory>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** CompanyCategory data */
export type CompanyCategorySearchInput = {
  companies?: InputMaybe<Array<InputMaybe<CompanyInput>>>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['Int']>;
};

/** PageInfo data */
export type CompanyEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Company>;
};

/** Company data */
export type CompanyInput = {
  body?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<CompanyCategoryInput>;
  categoryId?: InputMaybe<Scalars['String']>;
  cover?: InputMaybe<Scalars['Upload']>;
  creatorId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  enable?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<MrtInput>;
  name?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** Pagination data */
export type CompanyPagination = {
  edges?: Maybe<Array<Maybe<CompanyEdgeType>>>;
  nodes?: Maybe<Array<Maybe<Company>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Company data */
export type CompanySearchInput = {
  category?: InputMaybe<Scalars['String']>;
  creatorId?: InputMaybe<Scalars['String']>;
  departmentId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** companyTag data */
export type CompanyTag = {
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** PageInfo data */
export type CompanyTagEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<CompanyTag>;
};

/** CompanyTag data */
export type CompanyTagInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Pagination data */
export type CompanyTagPagination = {
  edges?: Maybe<Array<Maybe<CompanyTagEdgeType>>>;
  nodes?: Maybe<Array<Maybe<CompanyTag>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** CompanyTag data */
export type CompanyTagSearchInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type ContractInfo = {
  agent?: Maybe<Scalars['String']>;
  agentPhoneNumber?: Maybe<Scalars['String']>;
  commission?: Maybe<ContractInfoCommission>;
  email?: Maybe<Scalars['String']>;
  emergencyContact?: Maybe<ContractInfoEmergencyContact>;
  invoice?: Maybe<ContractInfoInvoice>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
};

export type ContractInfoCommission = {
  comment?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Date']>;
  price?: Maybe<Scalars['Int']>;
  way?: Maybe<Scalars['Int']>;
};

export type ContractInfoCommissionInput = {
  comment?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['Date']>;
  price?: InputMaybe<Scalars['Int']>;
  way?: InputMaybe<Scalars['Int']>;
};

export type ContractInfoEmergencyContact = {
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  relationship?: Maybe<Scalars['String']>;
};

export type ContractInfoEmergencyContactInput = {
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  relationship?: InputMaybe<Scalars['String']>;
};

export type ContractInfoInput = {
  agent?: InputMaybe<Scalars['String']>;
  agentPhoneNumber?: InputMaybe<Scalars['String']>;
  commission?: InputMaybe<ContractInfoCommissionInput>;
  email?: InputMaybe<Scalars['String']>;
  emergencyContact?: InputMaybe<ContractInfoEmergencyContactInput>;
  invoice?: InputMaybe<ContractInfoInvoiceInput>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
};

export type ContractInfoInvoice = {
  address?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['Int']>;
  uniformNumber?: Maybe<Scalars['String']>;
};

export type ContractInfoInvoiceInput = {
  address?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['Int']>;
  uniformNumber?: InputMaybe<Scalars['String']>;
};

export type ContractInfos = {
  a?: Maybe<ContractInfo>;
  b?: Maybe<ContractInfo>;
  discountReason?: Maybe<Scalars['String']>;
  orderAttachment?: Maybe<Scalars['String']>;
};

export type ContractInfosInput = {
  a?: InputMaybe<ContractInfoInput>;
  b?: InputMaybe<ContractInfoInput>;
  discountReason?: InputMaybe<Scalars['String']>;
  orderAttachment?: InputMaybe<Scalars['String']>;
};

export type CreateImageOptionsInput = {
  mode?: InputMaybe<Scalars['String']>;
  thumbnail?: InputMaybe<Scalars['Boolean']>;
  watermark?: InputMaybe<Scalars['Boolean']>;
};

/** department data */
export type Department = {
  enable?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  info?: Maybe<DepartmentInfo>;
  level?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<Role>>>;
  type?: Maybe<Scalars['Int']>;
  users?: Maybe<Array<Maybe<User>>>;
};

/** PageInfo data */
export type DepartmentEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Department>;
};

/** departmentInfo data */
export type DepartmentInfo = {
  aboutCover?: Maybe<FileDetail>;
  aboutCoverId?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<City>;
  cityId?: Maybe<Scalars['Int']>;
  department?: Maybe<Department>;
  description?: Maybe<Scalars['String']>;
  district?: Maybe<District>;
  districtId?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  fullAddress?: Maybe<Scalars['String']>;
  homeNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  logo?: Maybe<FileDetail>;
  logoId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  story?: Maybe<Scalars['String']>;
  watermark?: Maybe<FileDetail>;
};

/** PageInfo data */
export type DepartmentInfoEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<DepartmentInfo>;
};

/** DepartmentInfo data */
export type DepartmentInfoInput = {
  aboutCover?: InputMaybe<Scalars['Upload']>;
  address?: InputMaybe<Scalars['String']>;
  cityId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  districtId?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  homeNumber?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['Upload']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  story?: InputMaybe<Scalars['String']>;
  watermark?: InputMaybe<Scalars['Upload']>;
};

/** Pagination data */
export type DepartmentInfoPagination = {
  edges?: Maybe<Array<Maybe<DepartmentInfoEdgeType>>>;
  nodes?: Maybe<Array<Maybe<DepartmentInfo>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** DepartmentInfo data */
export type DepartmentInfoSearchInput = {
  aboutCover?: InputMaybe<FileInput>;
  aboutCoverId?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<CityInput>;
  cityId?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<DepartmentInput>;
  description?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<DistrictInput>;
  districtId?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  homeNumber?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<FileInput>;
  logoId?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  story?: InputMaybe<Scalars['String']>;
};

/** Department data */
export type DepartmentInput = {
  enable?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  info?: InputMaybe<DepartmentInfoInput>;
  level?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<InputMaybe<RoleInput>>>;
  type?: InputMaybe<Scalars['Int']>;
  users?: InputMaybe<Array<InputMaybe<UserInput>>>;
};

/** Pagination data */
export type DepartmentPagination = {
  edges?: Maybe<Array<Maybe<DepartmentEdgeType>>>;
  nodes?: Maybe<Array<Maybe<Department>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Department data */
export type DepartmentSearchInput = {
  enable?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  info?: InputMaybe<DepartmentInfoInput>;
  level?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<InputMaybe<RoleInput>>>;
  type?: InputMaybe<Scalars['Int']>;
  users?: InputMaybe<Array<InputMaybe<UserInput>>>;
};

/** district data */
export type District = {
  city?: Maybe<City>;
  cityId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['Int']>;
};

/** PageInfo data */
export type DistrictEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<District>;
};

/** District data */
export type DistrictInput = {
  city?: InputMaybe<CityInput>;
  cityId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['Int']>;
};

/** Pagination data */
export type DistrictPagination = {
  edges?: Maybe<Array<Maybe<DistrictEdgeType>>>;
  nodes?: Maybe<Array<Maybe<District>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** District data */
export type DistrictSearchInput = {
  city?: InputMaybe<CityInput>;
  cityId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['Int']>;
};

/** expense data */
export type Expense = {
  comment?: Maybe<Scalars['String']>;
  completedDate?: Maybe<Scalars['Date']>;
  contract?: Maybe<PropertyContract>;
  contractId?: Maybe<Scalars['String']>;
  fillPrice?: Maybe<Scalars['Int']>;
  finalPrice?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  info?: Maybe<InfoType>;
  payslip?: Maybe<Payslip>;
  payslipId?: Maybe<Scalars['Int']>;
  rate?: Maybe<Scalars['Float']>;
  referralPrice?: Maybe<Scalars['Int']>;
  registrationDate?: Maybe<Scalars['Date']>;
  separate?: Maybe<Scalars['JSONObject']>;
  sourceExpenseId?: Maybe<Scalars['Int']>;
  sourcePrice?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  tax?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
};

/** PageInfo data */
export type ExpenseEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Expense>;
};

/** Expense data */
export type ExpenseInput = {
  comment?: InputMaybe<Scalars['String']>;
  completedDate?: InputMaybe<Scalars['Date']>;
  contract?: InputMaybe<PropertyContractInput>;
  contractId?: InputMaybe<Scalars['String']>;
  fillPrice?: InputMaybe<Scalars['Int']>;
  finalPrice?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  payslip?: InputMaybe<PayslipInput>;
  payslipId?: InputMaybe<Scalars['Int']>;
  rate?: InputMaybe<Scalars['Float']>;
  referralPrice?: InputMaybe<Scalars['Int']>;
  registrationDate?: InputMaybe<Scalars['Date']>;
  separate?: InputMaybe<Scalars['JSONObject']>;
  sourceExpenseId?: InputMaybe<Scalars['Int']>;
  sourcePrice?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['Int']>;
  tax?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<UserInput>;
  userId?: InputMaybe<Scalars['String']>;
};

/** Pagination data */
export type ExpensePagination = {
  edges?: Maybe<Array<Maybe<ExpenseEdgeType>>>;
  nodes?: Maybe<Array<Maybe<Expense>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Expense data */
export type ExpenseSearchInput = {
  comment?: InputMaybe<Scalars['String']>;
  departmentId?: InputMaybe<Scalars['String']>;
  registrationDateFrom?: InputMaybe<Scalars['Date']>;
  registrationDateTo?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** file data */
export type File = {
  contentType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  originalname?: Maybe<Scalars['String']>;
  path?: Maybe<ImageDetail>;
  targetPath?: Maybe<Scalars['String']>;
  watermark?: Maybe<Scalars['Boolean']>;
};

/** fileDetail data */
export type FileDetail = {
  contentType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  originalname?: Maybe<Scalars['String']>;
  path?: Maybe<ImageDetail>;
  targetPath?: Maybe<Scalars['String']>;
  watermark?: Maybe<Scalars['Boolean']>;
};

/** PageInfo data */
export type FileEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<File>;
};

/** File data */
export type FileInput = {
  contentType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  originalname?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<ImageDetailInput>;
  targetPath?: InputMaybe<Scalars['Upload']>;
  watermark?: InputMaybe<Scalars['Boolean']>;
};

/** Pagination data */
export type FilePagination = {
  edges?: Maybe<Array<Maybe<FileEdgeType>>>;
  nodes?: Maybe<Array<Maybe<File>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** File data */
export type FileSearchInput = {
  contentType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  originalname?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<ImageDetailInput>;
  targetPath?: InputMaybe<Scalars['String']>;
};

/** FloorDetail data */
export type FloorDetail = {
  down?: Maybe<Scalars['Int']>;
  up?: Maybe<Scalars['Int']>;
};

/** FloorDetail data */
export type FloorDetailInput = {
  down?: InputMaybe<Scalars['Int']>;
  up?: InputMaybe<Scalars['Int']>;
};

/** FromToDetailType data */
export type FromToDetail = {
  from?: Maybe<Scalars['Date']>;
  to?: Maybe<Scalars['Date']>;
};

/** FromToDetailInput data */
export type FromToDetailInput = {
  from?: InputMaybe<Scalars['Date']>;
  to?: InputMaybe<Scalars['Date']>;
};

/** GeoPoint data */
export type GeoPointDetail = {
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** GeoPoint data */
export type GeoPointDetailInput = {
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
};

/** imageDetail data */
export type ImageDetail = {
  default?: Maybe<Scalars['String']>;
  hq?: Maybe<Scalars['String']>;
  maxresde?: Maybe<Scalars['String']>;
  mq?: Maybe<Scalars['String']>;
  sd?: Maybe<Scalars['String']>;
};

/** imageDetail data */
export type ImageDetailInput = {
  default?: InputMaybe<Scalars['String']>;
  hq?: InputMaybe<Scalars['String']>;
  maxresde?: InputMaybe<Scalars['String']>;
  mq?: InputMaybe<Scalars['String']>;
  sd?: InputMaybe<Scalars['String']>;
};

/** infoPhoto data */
export type InfoPhoto = {
  body?: Maybe<Scalars['String']>;
  file?: Maybe<FileDetail>;
  fileId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
};

/** PageInfo data */
export type InfoPhotoEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<InfoPhoto>;
};

/** InfoPhoto data */
export type InfoPhotoInput = {
  body?: InputMaybe<Scalars['String']>;
  checked?: InputMaybe<Scalars['Boolean']>;
  file?: InputMaybe<FileInput>;
  fileId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['Int']>;
  subject?: InputMaybe<Scalars['String']>;
};

/** Pagination data */
export type InfoPhotoPagination = {
  edges?: Maybe<Array<Maybe<InfoPhotoEdgeType>>>;
  nodes?: Maybe<Array<Maybe<InfoPhoto>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** InfoPhoto data */
export type InfoPhotoSearchInput = {
  id?: InputMaybe<Scalars['String']>;
};

/** data update info */
export type InfoType = {
  createdAt?: Maybe<Scalars['Date']>;
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updater?: Maybe<User>;
  updaterId?: Maybe<Scalars['String']>;
};

/** InvoiceNumberDetailType data */
export type InvoiceNumberDetail = {
  firstParty?: Maybe<Scalars['String']>;
  secondParty?: Maybe<Scalars['String']>;
};

/** InvoiceNumberDetailInput data */
export type InvoiceNumberDetailInput = {
  firstParty?: InputMaybe<Scalars['String']>;
  secondParty?: InputMaybe<Scalars['String']>;
};

/** language data */
export type Language = {
  en?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  ja?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['Int']>;
  zh_tw?: Maybe<Scalars['String']>;
};

/** PageInfo data */
export type LanguageEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Language>;
};

/** Language data */
export type LanguageInput = {
  en?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  ja?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['Int']>;
  zh_tw?: InputMaybe<Scalars['String']>;
};

/** Pagination data */
export type LanguagePagination = {
  edges?: Maybe<Array<Maybe<LanguageEdgeType>>>;
  nodes?: Maybe<Array<Maybe<Language>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Language data */
export type LanguageSearchInput = {
  en?: InputMaybe<Scalars['String']>;
  fullText?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  ja?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['Int']>;
  zh_tw?: InputMaybe<Scalars['String']>;
};

/** languageType data */
export type LanguageType = {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

/** PageInfo data */
export type LanguageTypeEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<LanguageType>;
};

/** LanguageType data */
export type LanguageTypeInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Pagination data */
export type LanguageTypePagination = {
  edges?: Maybe<Array<Maybe<LanguageTypeEdgeType>>>;
  nodes?: Maybe<Array<Maybe<LanguageType>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** LanguageType data */
export type LanguageTypeSearchInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** LifeFunction data */
export type LifeFunction = {
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** PageInfo data */
export type LifeFunctionEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<LifeFunction>;
};

/** LifeFunction data */
export type LifeFunctionInput = {
  checked?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Pagination data */
export type LifeFunctionPagination = {
  edges?: Maybe<Array<Maybe<LifeFunctionEdgeType>>>;
  nodes?: Maybe<Array<Maybe<LifeFunction>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** LifeFunction data */
export type LifeFunctionSearchInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** liveArea data */
export type LiveArea = {
  address?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  city?: Maybe<City>;
  cityId?: Maybe<Scalars['Int']>;
  communities?: Maybe<Array<Maybe<Community>>>;
  district?: Maybe<District>;
  districtId?: Maybe<Scalars['Int']>;
  fullAddress?: Maybe<Scalars['String']>;
  fullAddressShort?: Maybe<Scalars['String']>;
  geopoint?: Maybe<GeoPointDetail>;
  id?: Maybe<Scalars['Int']>;
  info?: Maybe<InfoType>;
  name?: Maybe<Scalars['String']>;
  nearbyFacilities?: Maybe<NearbyFacilities>;
  photo?: Maybe<InfoPhoto>;
  photos?: Maybe<Array<Maybe<InfoPhoto>>>;
  properties?: Maybe<Array<Maybe<Property>>>;
  shortBody?: Maybe<Scalars['String']>;
};

/** PageInfo data */
export type LiveAreaEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<LiveArea>;
};

/** LiveArea data */
export type LiveAreaInput = {
  address?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<CityInput>;
  cityId?: InputMaybe<Scalars['Int']>;
  deletePhotos?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  district?: InputMaybe<DistrictInput>;
  districtId?: InputMaybe<Scalars['Int']>;
  geopoint?: InputMaybe<GeoPointDetailInput>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nearbyFacilities?: InputMaybe<NearbyFacilitiesInput>;
  photos?: InputMaybe<Array<InputMaybe<InfoPhotoInput>>>;
  updatePhotos?: InputMaybe<Array<InputMaybe<InfoPhotoInput>>>;
};

/** Pagination data */
export type LiveAreaPagination = {
  edges?: Maybe<Array<Maybe<LiveAreaEdgeType>>>;
  nodes?: Maybe<Array<Maybe<LiveArea>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** LiveArea data */
export type LiveAreaSearchInput = {
  name?: InputMaybe<Scalars['String']>;
};

/** mail data */
export type Mail = {
  attachments?: Maybe<Array<Maybe<File>>>;
  body?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  subject?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};

/** PageInfo data */
export type MailEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Mail>;
};

/** Mail data */
export type MailInput = {
  attachments?: InputMaybe<Array<InputMaybe<FileInput>>>;
  body?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};

/** Pagination data */
export type MailPagination = {
  edges?: Maybe<Array<Maybe<MailEdgeType>>>;
  nodes?: Maybe<Array<Maybe<Mail>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Mail data */
export type MailSearchInput = {
  attachments?: InputMaybe<Array<InputMaybe<FileInput>>>;
  body?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};

/** MenuType data */
export type MenuType = {
  children?: Maybe<Array<Maybe<MenuType>>>;
  queryParams?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** meta data */
export type Meta = {
  content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  page?: Maybe<Page>;
  pageId?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Int']>;
};

/** PageInfo data */
export type MetaEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Meta>;
};

/** Meta data */
export type MetaInput = {
  content?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<PageInput>;
  pageId?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['Int']>;
};

/** Pagination data */
export type MetaPagination = {
  edges?: Maybe<Array<Maybe<MetaEdgeType>>>;
  nodes?: Maybe<Array<Maybe<Meta>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Meta data */
export type MetaSearchInput = {
  content?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<PageInput>;
  pageId?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['Int']>;
};

export type MotorcycleParkingInfo = {
  comment?: Maybe<Scalars['String']>;
  parkNumber?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['Int']>;
};

export type MotorcycleParkingInfoInput = {
  comment?: InputMaybe<Scalars['String']>;
  parkNumber?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['Int']>;
};

/** mrt data */
export type Mrt = {
  address?: Maybe<Scalars['String']>;
  category?: Maybe<MrtCategory>;
  categoryId?: Maybe<Scalars['String']>;
  city?: Maybe<City>;
  cityId?: Maybe<Scalars['Int']>;
  district?: Maybe<District>;
  districtId?: Maybe<Scalars['Int']>;
  fullAddress?: Maybe<Scalars['String']>;
  geopoint?: Maybe<GeoPointDetail>;
  id?: Maybe<Scalars['ID']>;
  lifeFunction?: Maybe<LifeFunction>;
  lifeFunctionId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  overseas?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

/** mrtCategory data */
export type MrtCategory = {
  id?: Maybe<Scalars['ID']>;
  mrts?: Maybe<Array<Maybe<Mrt>>>;
  name?: Maybe<Scalars['String']>;
  system?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
};

/** PageInfo data */
export type MrtCategoryEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<MrtCategory>;
};

/** MrtCategory data */
export type MrtCategoryInput = {
  id?: InputMaybe<Scalars['String']>;
  mrts?: InputMaybe<Array<InputMaybe<MrtInput>>>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Pagination data */
export type MrtCategoryPagination = {
  edges?: Maybe<Array<Maybe<MrtCategoryEdgeType>>>;
  nodes?: Maybe<Array<Maybe<MrtCategory>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** MrtCategory data */
export type MrtCategorySearchInput = {
  id?: InputMaybe<Scalars['String']>;
  mrts?: InputMaybe<Array<InputMaybe<MrtInput>>>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** PageInfo data */
export type MrtEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Mrt>;
};

/** Mrt data */
export type MrtInput = {
  address?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<MrtCategoryInput>;
  categoryId?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<CityInput>;
  cityId?: InputMaybe<Scalars['Int']>;
  district?: InputMaybe<DistrictInput>;
  districtId?: InputMaybe<Scalars['Int']>;
  geopoint?: InputMaybe<GeoPointDetailInput>;
  id?: InputMaybe<Scalars['String']>;
  lifeFunction?: InputMaybe<LifeFunctionInput>;
  lifeFunctionId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  overseas?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
};

/** Pagination data */
export type MrtPagination = {
  edges?: Maybe<Array<Maybe<MrtEdgeType>>>;
  nodes?: Maybe<Array<Maybe<Mrt>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Mrt data */
export type MrtSearchInput = {
  address?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  categoryType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type MultiplePayslip = {
  expenses?: Maybe<Array<Maybe<Expense>>>;
  user?: Maybe<User>;
};

export type Mutation = {
  /** create announcement */
  createAnnouncement?: Maybe<Announcement>;
  /** create announcementCategory */
  createAnnouncementCategory?: Maybe<AnnouncementCategory>;
  /** create blog */
  createBlog?: Maybe<Blog>;
  /** create blogCategory */
  createBlogCategory?: Maybe<BlogCategory>;
  /** create blogTag */
  createBlogTag?: Maybe<BlogTag>;
  /** create city */
  createCity?: Maybe<City>;
  /** create community */
  createCommunity?: Maybe<Community>;
  /** create company */
  createCompany?: Maybe<Company>;
  /** create companyCategory */
  createCompanyCategory?: Maybe<CompanyCategory>;
  /** create companyTag */
  createCompanyTag?: Maybe<CompanyTag>;
  /** create department */
  createDepartment?: Maybe<Department>;
  /** create departmentInfo */
  createDepartmentInfo?: Maybe<DepartmentInfo>;
  /** create district */
  createDistrict?: Maybe<District>;
  /** create expense */
  createExpense?: Maybe<Expense>;
  /** create file */
  createFile?: Maybe<Array<Maybe<FileDetail>>>;
  /** create infoPhoto */
  createInfoPhoto?: Maybe<InfoPhoto>;
  /** create language */
  createLanguage?: Maybe<Language>;
  /** create languageType */
  createLanguageType?: Maybe<LanguageType>;
  /** create liveArea */
  createLiveArea?: Maybe<LiveArea>;
  /** create mail */
  createMail?: Maybe<Mail>;
  /** create meta */
  createMeta?: Maybe<Meta>;
  /** create mrt */
  createMrt?: Maybe<Mrt>;
  /** create mrtCategory */
  createMrtCategory?: Maybe<MrtCategory>;
  /** create payslip */
  createMultiplePayslip?: Maybe<Array<Maybe<MultiplePayslip>>>;
  /** create page */
  createPage?: Maybe<Page>;
  /** create payslip */
  createPayslip?: Maybe<Payslip>;
  /** create payslip */
  createPayslips?: Maybe<Array<Maybe<Payslip>>>;
  /** create property */
  createProperty?: Maybe<Property>;
  /** create propertyCategory */
  createPropertyCategory?: Maybe<PropertyCategory>;
  /** create propertyContract */
  createPropertyContract?: Maybe<PropertyContract>;
  /** create propertyDevice */
  createPropertyDevice?: Maybe<PropertyDevice>;
  /** create propertyFace */
  createPropertyFace?: Maybe<PropertyFace>;
  /** create propertyFurniture */
  createPropertyFurniture?: Maybe<PropertyFurniture>;
  /** create propertyKind */
  createPropertyKind?: Maybe<PropertyKind>;
  /** create propertyOrder */
  createPropertyOrder?: Maybe<PropertyOrder>;
  /** create propertyParking */
  createPropertyParking?: Maybe<PropertyParking>;
  /** create propertyPattern */
  createPropertyPattern?: Maybe<PropertyPattern>;
  /** create propertyPhoto */
  createPropertyPhoto?: Maybe<PropertyPhoto>;
  /** create propertyPublicUtility */
  createPropertyPublicUtility?: Maybe<PropertyPublicUtility>;
  /** create propertyReview */
  createPropertyReview?: Maybe<PropertyReview>;
  /** create propertyShape */
  createPropertyShape?: Maybe<PropertyShape>;
  /** create propertyUsage */
  createPropertyUsage?: Maybe<PropertyUsage>;
  /** create rentAttachment */
  createRentAttachment?: Maybe<RentAttachment>;
  /** create role */
  createRole?: Maybe<Role>;
  /** create system */
  createSystem?: Maybe<System>;
  /** create user */
  createUser?: Maybe<User>;
  /** create userPhoto */
  createUserPhoto?: Maybe<UserPhoto>;
  /** create userProfile */
  createUserProfile?: Maybe<UserProfile>;
  /** create userSocial */
  createUserSocial?: Maybe<UserSocial>;
  /** Delete announcement with email and id */
  deleteAnnouncement?: Maybe<Result>;
  /** Delete announcementCategory with email and id */
  deleteAnnouncementCategory?: Maybe<Result>;
  /** Delete blog with email and id */
  deleteBlog?: Maybe<Result>;
  /** Delete blogCategory with email and id */
  deleteBlogCategory?: Maybe<Result>;
  /** Delete blogTag with email and id */
  deleteBlogTag?: Maybe<Result>;
  /** Delete city with email and id */
  deleteCity?: Maybe<Result>;
  /** Delete community */
  deleteCommunity?: Maybe<Result>;
  /** Delete company with email and id */
  deleteCompany?: Maybe<Result>;
  /** Delete companyCategory with email and id */
  deleteCompanyCategory?: Maybe<Result>;
  /** Delete companyTag with email and id */
  deleteCompanyTag?: Maybe<Result>;
  /** Delete department with email and id */
  deleteDepartment?: Maybe<Result>;
  /** Delete departmentInfo with email and id */
  deleteDepartmentInfo?: Maybe<Result>;
  /** Delete district with email and id */
  deleteDistrict?: Maybe<Result>;
  /** Delete expense */
  deleteExpense?: Maybe<Result>;
  /** Delete file with email and id */
  deleteFile?: Maybe<Result>;
  /** Delete infoPhoto */
  deleteInfoPhoto?: Maybe<Result>;
  /** Delete language with email and id */
  deleteLanguage?: Maybe<Result>;
  /** Delete languageType with email and id */
  deleteLanguageType?: Maybe<Result>;
  /** Delete liveArea */
  deleteLiveArea?: Maybe<Result>;
  /** Delete mail with email and id */
  deleteMail?: Maybe<Result>;
  /** Delete meta with email and id */
  deleteMeta?: Maybe<Result>;
  /** Delete mrt with email and id */
  deleteMrt?: Maybe<Result>;
  /** Delete mrtCategory with email and id */
  deleteMrtCategory?: Maybe<Result>;
  /** Delete page with email and id */
  deletePage?: Maybe<Result>;
  /** Delete payslip */
  deletePayslip?: Maybe<Result>;
  /** Delete property with email and id */
  deleteProperty?: Maybe<Result>;
  /** Delete propertyCategory with email and id */
  deletePropertyCategory?: Maybe<Result>;
  /** Delete propertyContract */
  deletePropertyContract?: Maybe<Result>;
  /** Delete propertyDevice with email and id */
  deletePropertyDevice?: Maybe<Result>;
  /** Delete propertyFace with email and id */
  deletePropertyFace?: Maybe<Result>;
  /** Delete propertyFurniture with email and id */
  deletePropertyFurniture?: Maybe<Result>;
  /** Delete propertyKind with email and id */
  deletePropertyKind?: Maybe<Result>;
  /** Delete propertyOrder with email and id */
  deletePropertyOrder?: Maybe<Result>;
  /** Delete propertyParking with email and id */
  deletePropertyParking?: Maybe<Result>;
  /** Delete propertyPattern with email and id */
  deletePropertyPattern?: Maybe<Result>;
  /** Delete propertyPhoto with email and id */
  deletePropertyPhoto?: Maybe<Result>;
  /** Delete propertyPublicUtility with email and id */
  deletePropertyPublicUtility?: Maybe<Result>;
  /** Delete propertyReview */
  deletePropertyReview?: Maybe<Result>;
  /** Delete propertyShape with email and id */
  deletePropertyShape?: Maybe<Result>;
  /** Delete propertyUsage with email and id */
  deletePropertyUsage?: Maybe<Result>;
  /** Delete rentAttachment with email and id */
  deleteRentAttachment?: Maybe<Result>;
  /** Delete role with email and id */
  deleteRole?: Maybe<Result>;
  /** Delete system with email and id */
  deleteSystem?: Maybe<Result>;
  /** Delete user with email and id */
  deleteUser?: Maybe<Result>;
  /** Delete userPhoto with email and id */
  deleteUserPhoto?: Maybe<Result>;
  /** Delete userProfile with email and id */
  deleteUserProfile?: Maybe<Result>;
  /** Delete userSocial with email and id */
  deleteUserSocial?: Maybe<Result>;
  /** Import excel to property */
  importProperty?: Maybe<Result>;
  /** Delete file with email and id */
  processFiles?: Maybe<Array<Maybe<FileDetail>>>;
  /** Delete property with email and id */
  reLaunchProperty?: Maybe<Property>;
  /** Update user with email and password */
  sortUser?: Maybe<Result>;
  /** transfer user data */
  transferUser?: Maybe<Result>;
  /** save about */
  updateAbout?: Maybe<Result>;
  /** Update announcement with email and password */
  updateAnnouncement?: Maybe<Announcement>;
  /** Update announcementCategory with email and password */
  updateAnnouncementCategory?: Maybe<AnnouncementCategory>;
  /** Update blog with email and password */
  updateBlog?: Maybe<Blog>;
  /** Update blogCategory with email and password */
  updateBlogCategory?: Maybe<BlogCategory>;
  /** Update blogTag with email and password */
  updateBlogTag?: Maybe<BlogTag>;
  /** Update city with email and password */
  updateCity?: Maybe<City>;
  /** Update community */
  updateCommunity?: Maybe<Community>;
  /** Update company with email and password */
  updateCompany?: Maybe<Company>;
  /** Update companyCategory with email and password */
  updateCompanyCategory?: Maybe<CompanyCategory>;
  /** Update companyTag with email and password */
  updateCompanyTag?: Maybe<CompanyTag>;
  /** Update department with email and password */
  updateDepartment?: Maybe<Department>;
  /** Update departmentInfo with email and password */
  updateDepartmentInfo?: Maybe<DepartmentInfo>;
  /** Update district with email and password */
  updateDistrict?: Maybe<District>;
  /** Update expense */
  updateExpense?: Maybe<Expense>;
  /** Update file with email and password */
  updateFile?: Maybe<FileDetail>;
  /** Update infoPhoto */
  updateInfoPhoto?: Maybe<InfoPhoto>;
  /** Update language with email and password */
  updateLanguage?: Maybe<Language>;
  /** Update languageType with email and password */
  updateLanguageType?: Maybe<LanguageType>;
  /** Update liveArea */
  updateLiveArea?: Maybe<LiveArea>;
  /** Update mail with email and password */
  updateMail?: Maybe<Mail>;
  /** Update meta with email and password */
  updateMeta?: Maybe<Meta>;
  /** Update mrt with email and password */
  updateMrt?: Maybe<Mrt>;
  /** Update mrtCategory with email and password */
  updateMrtCategory?: Maybe<MrtCategory>;
  /** Update page with email and password */
  updatePage?: Maybe<Page>;
  /** Update payslip */
  updatePayslip?: Maybe<Payslip>;
  /** Update property with email and password */
  updateProperty?: Maybe<Property>;
  /** Update propertyCategory with email and password */
  updatePropertyCategory?: Maybe<PropertyCategory>;
  /** Update propertyContract */
  updatePropertyContract?: Maybe<PropertyContract>;
  /** Update propertyDevice with email and password */
  updatePropertyDevice?: Maybe<PropertyDevice>;
  /** Update propertyFace with email and password */
  updatePropertyFace?: Maybe<PropertyFace>;
  /** Update propertyFurniture with email and password */
  updatePropertyFurniture?: Maybe<PropertyFurniture>;
  /** Update propertyKind with email and password */
  updatePropertyKind?: Maybe<PropertyKind>;
  /** Update propertyOrder with email and password */
  updatePropertyOrder?: Maybe<PropertyOrder>;
  /** Update propertyParking with email and password */
  updatePropertyParking?: Maybe<PropertyParking>;
  /** Update propertyPattern with email and password */
  updatePropertyPattern?: Maybe<PropertyPattern>;
  /** Update propertyPhoto with email and password */
  updatePropertyPhoto?: Maybe<PropertyPhoto>;
  /** Update propertyPublicUtility with email and password */
  updatePropertyPublicUtility?: Maybe<PropertyPublicUtility>;
  /** Update propertyReview */
  updatePropertyReview?: Maybe<PropertyReview>;
  /** Update propertyShape with email and password */
  updatePropertyShape?: Maybe<PropertyShape>;
  /** Update propertyUsage with email and password */
  updatePropertyUsage?: Maybe<PropertyUsage>;
  /** Update rentAttachment with email and password */
  updateRentAttachment?: Maybe<RentAttachment>;
  /** Update role with email and password */
  updateRole?: Maybe<Role>;
  /** Update system with email and password */
  updateSystem?: Maybe<System>;
  /** Update user with email and password */
  updateUser?: Maybe<User>;
  /** Update userPhoto with email and password */
  updateUserPhoto?: Maybe<UserPhoto>;
  /** Update userProfile with email and password */
  updateUserProfile?: Maybe<UserProfile>;
  /** Update userSocial with email and password */
  updateUserSocial?: Maybe<UserSocial>;
};


export type MutationCreateAnnouncementArgs = {
  input?: InputMaybe<AnnouncementInput>;
};


export type MutationCreateAnnouncementCategoryArgs = {
  input?: InputMaybe<AnnouncementCategoryInput>;
};


export type MutationCreateBlogArgs = {
  input?: InputMaybe<BlogInput>;
};


export type MutationCreateBlogCategoryArgs = {
  input?: InputMaybe<BlogCategoryInput>;
};


export type MutationCreateBlogTagArgs = {
  input?: InputMaybe<BlogTagInput>;
};


export type MutationCreateCityArgs = {
  input?: InputMaybe<CityInput>;
};


export type MutationCreateCommunityArgs = {
  input?: InputMaybe<CommunityInput>;
};


export type MutationCreateCompanyArgs = {
  input?: InputMaybe<CompanyInput>;
};


export type MutationCreateCompanyCategoryArgs = {
  input?: InputMaybe<CompanyCategoryInput>;
};


export type MutationCreateCompanyTagArgs = {
  input?: InputMaybe<CompanyTagInput>;
};


export type MutationCreateDepartmentArgs = {
  input?: InputMaybe<DepartmentInput>;
};


export type MutationCreateDepartmentInfoArgs = {
  input?: InputMaybe<DepartmentInfoInput>;
};


export type MutationCreateDistrictArgs = {
  input?: InputMaybe<DistrictInput>;
};


export type MutationCreateExpenseArgs = {
  input?: InputMaybe<ExpenseInput>;
};


export type MutationCreateFileArgs = {
  files?: InputMaybe<Array<InputMaybe<FileInput>>>;
  options?: InputMaybe<CreateImageOptionsInput>;
  target?: InputMaybe<Scalars['String']>;
};


export type MutationCreateInfoPhotoArgs = {
  input?: InputMaybe<InfoPhotoInput>;
};


export type MutationCreateLanguageArgs = {
  input?: InputMaybe<LanguageInput>;
};


export type MutationCreateLanguageTypeArgs = {
  input?: InputMaybe<LanguageTypeInput>;
};


export type MutationCreateLiveAreaArgs = {
  input?: InputMaybe<LiveAreaInput>;
};


export type MutationCreateMailArgs = {
  input?: InputMaybe<MailInput>;
};


export type MutationCreateMetaArgs = {
  input?: InputMaybe<MetaInput>;
};


export type MutationCreateMrtArgs = {
  input?: InputMaybe<MrtInput>;
};


export type MutationCreateMrtCategoryArgs = {
  input?: InputMaybe<MrtCategoryInput>;
};


export type MutationCreateMultiplePayslipArgs = {
  input?: InputMaybe<PayslipSearchInput>;
};


export type MutationCreatePageArgs = {
  input?: InputMaybe<PageInput>;
};


export type MutationCreatePayslipArgs = {
  input?: InputMaybe<PayslipInput>;
};


export type MutationCreatePayslipsArgs = {
  input?: InputMaybe<Array<InputMaybe<PayslipInput>>>;
};


export type MutationCreatePropertyArgs = {
  input?: InputMaybe<PropertyInput>;
};


export type MutationCreatePropertyCategoryArgs = {
  input?: InputMaybe<PropertyCategoryInput>;
};


export type MutationCreatePropertyContractArgs = {
  input?: InputMaybe<PropertyContractInput>;
};


export type MutationCreatePropertyDeviceArgs = {
  input?: InputMaybe<PropertyDeviceInput>;
};


export type MutationCreatePropertyFaceArgs = {
  input?: InputMaybe<PropertyFaceInput>;
};


export type MutationCreatePropertyFurnitureArgs = {
  input?: InputMaybe<PropertyFurnitureInput>;
};


export type MutationCreatePropertyKindArgs = {
  input?: InputMaybe<PropertyKindInput>;
};


export type MutationCreatePropertyOrderArgs = {
  input?: InputMaybe<PropertyOrderInput>;
};


export type MutationCreatePropertyParkingArgs = {
  input?: InputMaybe<PropertyParkingInput>;
};


export type MutationCreatePropertyPatternArgs = {
  input?: InputMaybe<PropertyPatternInput>;
};


export type MutationCreatePropertyPhotoArgs = {
  input?: InputMaybe<PropertyPhotoInput>;
};


export type MutationCreatePropertyPublicUtilityArgs = {
  input?: InputMaybe<PropertyPublicUtilityInput>;
};


export type MutationCreatePropertyReviewArgs = {
  input?: InputMaybe<PropertyReviewInput>;
};


export type MutationCreatePropertyShapeArgs = {
  input?: InputMaybe<PropertyShapeInput>;
};


export type MutationCreatePropertyUsageArgs = {
  input?: InputMaybe<PropertyUsageInput>;
};


export type MutationCreateRentAttachmentArgs = {
  input?: InputMaybe<RentAttachmentInput>;
};


export type MutationCreateRoleArgs = {
  input?: InputMaybe<RoleInput>;
};


export type MutationCreateSystemArgs = {
  input?: InputMaybe<SystemInput>;
};


export type MutationCreateUserArgs = {
  input?: InputMaybe<UserInput>;
};


export type MutationCreateUserPhotoArgs = {
  input?: InputMaybe<UserPhotoInput>;
};


export type MutationCreateUserProfileArgs = {
  input?: InputMaybe<UserProfileInput>;
};


export type MutationCreateUserSocialArgs = {
  input?: InputMaybe<UserSocialInput>;
};


export type MutationDeleteAnnouncementArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteAnnouncementCategoryArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteBlogArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteBlogCategoryArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteBlogTagArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCityArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCommunityArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteCompanyArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteCompanyCategoryArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCompanyTagArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDepartmentArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDepartmentInfoArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDistrictArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteExpenseArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteFileArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteInfoPhotoArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteLanguageArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteLanguageTypeArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteLiveAreaArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteMailArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteMetaArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteMrtArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteMrtCategoryArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePageArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePayslipArgs = {
  id: Scalars['Int'];
};


export type MutationDeletePropertyArgs = {
  id: Scalars['Int'];
};


export type MutationDeletePropertyCategoryArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePropertyContractArgs = {
  id: Scalars['Int'];
};


export type MutationDeletePropertyDeviceArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePropertyFaceArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePropertyFurnitureArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePropertyKindArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePropertyOrderArgs = {
  id: Scalars['Int'];
};


export type MutationDeletePropertyParkingArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePropertyPatternArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePropertyPhotoArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePropertyPublicUtilityArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePropertyReviewArgs = {
  id: Scalars['Int'];
};


export type MutationDeletePropertyShapeArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePropertyUsageArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteRentAttachmentArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteRoleArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSystemArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserPhotoArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserProfileArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserSocialArgs = {
  id: Scalars['ID'];
};


export type MutationImportPropertyArgs = {
  file?: InputMaybe<Scalars['Upload']>;
};


export type MutationProcessFilesArgs = {
  filePaths?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MutationReLaunchPropertyArgs = {
  id: Scalars['Int'];
};


export type MutationSortUserArgs = {
  input?: InputMaybe<Array<InputMaybe<UserInput>>>;
};


export type MutationTransferUserArgs = {
  expenseIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  from: Scalars['ID'];
  propertyIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  to: Scalars['ID'];
  type: Array<InputMaybe<Scalars['String']>>;
};


export type MutationUpdateAboutArgs = {
  input?: InputMaybe<AboutInput>;
};


export type MutationUpdateAnnouncementArgs = {
  input?: InputMaybe<AnnouncementInput>;
};


export type MutationUpdateAnnouncementCategoryArgs = {
  input?: InputMaybe<AnnouncementCategoryInput>;
};


export type MutationUpdateBlogArgs = {
  input?: InputMaybe<BlogInput>;
};


export type MutationUpdateBlogCategoryArgs = {
  input?: InputMaybe<BlogCategoryInput>;
};


export type MutationUpdateBlogTagArgs = {
  input?: InputMaybe<BlogTagInput>;
};


export type MutationUpdateCityArgs = {
  input?: InputMaybe<CityInput>;
};


export type MutationUpdateCommunityArgs = {
  input?: InputMaybe<CommunityInput>;
  nameUpdate?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateCompanyArgs = {
  input?: InputMaybe<CompanyInput>;
  nameUpdate?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateCompanyCategoryArgs = {
  input?: InputMaybe<CompanyCategoryInput>;
};


export type MutationUpdateCompanyTagArgs = {
  input?: InputMaybe<CompanyTagInput>;
};


export type MutationUpdateDepartmentArgs = {
  input?: InputMaybe<DepartmentInput>;
};


export type MutationUpdateDepartmentInfoArgs = {
  input?: InputMaybe<DepartmentInfoInput>;
};


export type MutationUpdateDistrictArgs = {
  input?: InputMaybe<DistrictInput>;
};


export type MutationUpdateExpenseArgs = {
  input?: InputMaybe<ExpenseInput>;
  nameUpdate?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateFileArgs = {
  contentType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  originalname?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<ImageDetailInput>;
  targetPath?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateInfoPhotoArgs = {
  input?: InputMaybe<InfoPhotoInput>;
  nameUpdate?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateLanguageArgs = {
  input?: InputMaybe<LanguageInput>;
};


export type MutationUpdateLanguageTypeArgs = {
  input?: InputMaybe<LanguageTypeInput>;
};


export type MutationUpdateLiveAreaArgs = {
  input?: InputMaybe<LiveAreaInput>;
  nameUpdate?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateMailArgs = {
  input?: InputMaybe<MailInput>;
};


export type MutationUpdateMetaArgs = {
  input?: InputMaybe<MetaInput>;
};


export type MutationUpdateMrtArgs = {
  input?: InputMaybe<MrtInput>;
};


export type MutationUpdateMrtCategoryArgs = {
  input?: InputMaybe<MrtCategoryInput>;
};


export type MutationUpdatePageArgs = {
  input?: InputMaybe<PageInput>;
};


export type MutationUpdatePayslipArgs = {
  input?: InputMaybe<PayslipInput>;
  nameUpdate?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdatePropertyArgs = {
  enable?: InputMaybe<Scalars['Boolean']>;
  input?: InputMaybe<PropertyInput>;
};


export type MutationUpdatePropertyCategoryArgs = {
  input?: InputMaybe<PropertyCategoryInput>;
};


export type MutationUpdatePropertyContractArgs = {
  input?: InputMaybe<PropertyContractInput>;
  nameUpdate?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdatePropertyDeviceArgs = {
  input?: InputMaybe<PropertyDeviceInput>;
};


export type MutationUpdatePropertyFaceArgs = {
  input?: InputMaybe<PropertyFaceInput>;
};


export type MutationUpdatePropertyFurnitureArgs = {
  input?: InputMaybe<PropertyFurnitureInput>;
};


export type MutationUpdatePropertyKindArgs = {
  input?: InputMaybe<PropertyKindInput>;
};


export type MutationUpdatePropertyOrderArgs = {
  input?: InputMaybe<PropertyOrderInput>;
};


export type MutationUpdatePropertyParkingArgs = {
  input?: InputMaybe<PropertyParkingInput>;
};


export type MutationUpdatePropertyPatternArgs = {
  input?: InputMaybe<PropertyPatternInput>;
};


export type MutationUpdatePropertyPhotoArgs = {
  input?: InputMaybe<PropertyPhotoInput>;
};


export type MutationUpdatePropertyPublicUtilityArgs = {
  input?: InputMaybe<PropertyPublicUtilityInput>;
};


export type MutationUpdatePropertyReviewArgs = {
  input?: InputMaybe<PropertyReviewInput>;
  nameUpdate?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdatePropertyShapeArgs = {
  input?: InputMaybe<PropertyShapeInput>;
};


export type MutationUpdatePropertyUsageArgs = {
  input?: InputMaybe<PropertyUsageInput>;
};


export type MutationUpdateRentAttachmentArgs = {
  input?: InputMaybe<RentAttachmentInput>;
};


export type MutationUpdateRoleArgs = {
  input?: InputMaybe<RoleInput>;
};


export type MutationUpdateSystemArgs = {
  input?: InputMaybe<SystemInput>;
};


export type MutationUpdateUserArgs = {
  input?: InputMaybe<UserInput>;
};


export type MutationUpdateUserPhotoArgs = {
  input?: InputMaybe<UserPhotoInput>;
};


export type MutationUpdateUserProfileArgs = {
  input?: InputMaybe<UserProfileInput>;
};


export type MutationUpdateUserSocialArgs = {
  input?: InputMaybe<UserSocialInput>;
};

export type NearbyFacilities = {
  departmentStore?: Maybe<Array<Maybe<Mrt>>>;
  educationSchools?: Maybe<Array<Maybe<Mrt>>>;
  leisureFacilities?: Maybe<Array<Maybe<Mrt>>>;
  majorConstruction?: Maybe<Array<Maybe<Mrt>>>;
  massTransit?: Maybe<Array<Maybe<Mrt>>>;
  medicalInformation?: Maybe<Array<Maybe<Mrt>>>;
  shoppingDistrict?: Maybe<Array<Maybe<Mrt>>>;
  supermarket?: Maybe<Array<Maybe<Mrt>>>;
  traditionalMarket?: Maybe<Array<Maybe<Mrt>>>;
};

export type NearbyFacilitiesInput = {
  departmentStore?: InputMaybe<Array<InputMaybe<MrtInput>>>;
  educationSchools?: InputMaybe<Array<InputMaybe<MrtInput>>>;
  leisureFacilities?: InputMaybe<Array<InputMaybe<MrtInput>>>;
  majorConstruction?: InputMaybe<Array<InputMaybe<MrtInput>>>;
  massTransit?: InputMaybe<Array<InputMaybe<MrtInput>>>;
  medicalInformation?: InputMaybe<Array<InputMaybe<MrtInput>>>;
  shoppingDistrict?: InputMaybe<Array<InputMaybe<MrtInput>>>;
  supermarket?: InputMaybe<Array<InputMaybe<MrtInput>>>;
  traditionalMarket?: InputMaybe<Array<InputMaybe<MrtInput>>>;
};

/** page data */
export type Page = {
  body?: Maybe<Scalars['String']>;
  breadCrumb?: Maybe<Array<Maybe<BreadCrumb>>>;
  cover?: Maybe<FileDetail>;
  defaultPage?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  metas?: Maybe<Array<Maybe<Meta>>>;
  title?: Maybe<Scalars['String']>;
};

/** PageInfo data */
export type PageEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Page>;
};

/** PageInfo data */
export type PageInfo = {
  currentPageIndex?: Maybe<Scalars['Int']>;
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  startCursor?: Maybe<Scalars['String']>;
  totalPageCount?: Maybe<Scalars['Int']>;
};

/** Page data */
export type PageInput = {
  body?: InputMaybe<Scalars['String']>;
  cover?: InputMaybe<Scalars['Upload']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  metas?: InputMaybe<Array<InputMaybe<MetaInput>>>;
  title?: InputMaybe<Scalars['String']>;
};

/** Pagination data */
export type PagePagination = {
  edges?: Maybe<Array<Maybe<PageEdgeType>>>;
  nodes?: Maybe<Array<Maybe<Page>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Page data */
export type PageSearchInput = {
  body?: InputMaybe<Scalars['String']>;
  cover?: InputMaybe<FileInput>;
  coverId?: InputMaybe<Scalars['String']>;
  defaultPage?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  metas?: InputMaybe<Array<InputMaybe<MetaInput>>>;
  title?: InputMaybe<Scalars['String']>;
};

export type ParkingGarageInfo = {
  category?: Maybe<Scalars['Int']>;
  parkNumber?: Maybe<Array<Maybe<ParkingGarageInfoParkNumber>>>;
  type?: Maybe<Scalars['Int']>;
};

export type ParkingGarageInfoInput = {
  category?: InputMaybe<Scalars['Int']>;
  parkNumber?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['Int']>;
};

export type ParkingGarageInfoParkNumber = {
  value?: Maybe<Scalars['String']>;
};

export type ParkingLotInfo = {
  category?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['Int']>;
};

export type ParkingLotInfoInput = {
  category?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['Int']>;
};

export type ParkingOtherSpaceFloor = {
  name?: Maybe<Scalars['String']>;
  spaceNumber?: Maybe<Scalars['Float']>;
};

export type ParkingOtherSpaceNumber = {
  arcade?: Maybe<Scalars['Float']>;
  attached?: Maybe<Scalars['Float']>;
  floors?: Maybe<Array<Maybe<ParkingOtherSpaceFloor>>>;
  independentParking?: Maybe<Scalars['Float']>;
  publicUtilities?: Maybe<Scalars['Float']>;
  underground?: Maybe<Scalars['Float']>;
};

export type PaymentInfo = {
  healthInsurance?: Maybe<PaymentInfoDetail>;
  laborProtection?: Maybe<PaymentInfoDetail>;
  withholding?: Maybe<Scalars['Boolean']>;
};

export type PaymentInfoDetail = {
  checked?: Maybe<Scalars['Boolean']>;
  price?: Maybe<Scalars['Int']>;
};

/** payslip data */
export type Payslip = {
  comment?: Maybe<Scalars['String']>;
  completedDate?: Maybe<Scalars['Date']>;
  expenses?: Maybe<Array<Maybe<Expense>>>;
  id?: Maybe<Scalars['Int']>;
  period?: Maybe<FromToDetail>;
  snapshot?: Maybe<Scalars['JSONObject']>;
  status?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
};

/** PageInfo data */
export type PayslipEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Payslip>;
};

/** Payslip data */
export type PayslipInput = {
  comment?: InputMaybe<Scalars['String']>;
  completedDate?: InputMaybe<Scalars['Date']>;
  expenses?: InputMaybe<Array<InputMaybe<ExpenseInput>>>;
  id?: InputMaybe<Scalars['Int']>;
  period?: InputMaybe<FromToDetailInput>;
  snapshot?: InputMaybe<Scalars['JSONObject']>;
  status?: InputMaybe<Scalars['Int']>;
  user?: InputMaybe<UserInput>;
  userId?: InputMaybe<Scalars['String']>;
};

/** Pagination data */
export type PayslipPagination = {
  edges?: Maybe<Array<Maybe<PayslipEdgeType>>>;
  nodes?: Maybe<Array<Maybe<Payslip>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Payslip data */
export type PayslipSearchInput = {
  comment?: InputMaybe<Scalars['String']>;
  departmentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  period?: InputMaybe<FromToDetailInput>;
  status?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** property data */
export type Property = {
  address?: Maybe<Scalars['String']>;
  age?: Maybe<Scalars['String']>;
  ageNumber?: Maybe<Scalars['Int']>;
  agent?: Maybe<AgentDetail>;
  body?: Maybe<Scalars['String']>;
  bodyFullText?: Maybe<Scalars['String']>;
  body_short?: Maybe<Scalars['String']>;
  builderName?: Maybe<Scalars['String']>;
  buildingName?: Maybe<Scalars['String']>;
  businessRegistration?: Maybe<Scalars['Boolean']>;
  category?: Maybe<PropertyCategory>;
  categoryId?: Maybe<Scalars['String']>;
  city?: Maybe<City>;
  cityId?: Maybe<Scalars['Int']>;
  classification?: Maybe<Scalars['Int']>;
  community?: Maybe<Community>;
  communityId?: Maybe<Scalars['Int']>;
  completeDate?: Maybe<Scalars['Date']>;
  contractCount?: Maybe<Scalars['Int']>;
  contracts?: Maybe<Array<Maybe<PropertyContract>>>;
  createdAt?: Maybe<Scalars['Date']>;
  creatorId?: Maybe<Scalars['String']>;
  department?: Maybe<Department>;
  departmentId?: Maybe<Scalars['String']>;
  developers?: Maybe<Array<Maybe<User>>>;
  devices?: Maybe<Array<Maybe<PropertyDevice>>>;
  district?: Maybe<District>;
  districtId?: Maybe<Scalars['Int']>;
  doorNumber?: Maybe<Scalars['Int']>;
  educationSchools?: Maybe<Array<Maybe<LifeFunction>>>;
  elevatorsNumber?: Maybe<Scalars['Int']>;
  enable?: Maybe<Scalars['Boolean']>;
  expiredDate?: Maybe<Scalars['Date']>;
  face?: Maybe<PropertyFace>;
  faceId?: Maybe<Scalars['String']>;
  featured?: Maybe<Scalars['Boolean']>;
  floorNumber?: Maybe<Scalars['String']>;
  fullAddress?: Maybe<Scalars['String']>;
  fullAddressShort?: Maybe<Scalars['String']>;
  furnitures?: Maybe<Array<Maybe<PropertyFurniture>>>;
  geopoint?: Maybe<GeoPointDetail>;
  headline?: Maybe<Scalars['Boolean']>;
  histories?: Maybe<Array<Maybe<User>>>;
  id?: Maybe<Scalars['Int']>;
  includeTax?: Maybe<Scalars['Boolean']>;
  internalStates?: Maybe<Scalars['Int']>;
  isNew?: Maybe<Scalars['Boolean']>;
  keyBelong?: Maybe<Scalars['String']>;
  keyBelongType?: Maybe<Scalars['Int']>;
  kind?: Maybe<PropertyKind>;
  kindId?: Maybe<Scalars['Int']>;
  landSpaceNumber?: Maybe<Scalars['Float']>;
  launched?: Maybe<Scalars['Boolean']>;
  launchedDate?: Maybe<Scalars['Date']>;
  lifeFunctions?: Maybe<Array<Maybe<LifeFunction>>>;
  mainSpaceNumber?: Maybe<Scalars['Float']>;
  mainStructure?: Maybe<Scalars['Int']>;
  managementFee?: Maybe<Scalars['Int']>;
  managementFeePerUnit?: Maybe<Scalars['Int']>;
  managementPhoneNumber?: Maybe<Scalars['String']>;
  motorcycleParkingInfo?: Maybe<MotorcycleParkingInfo>;
  mrt?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nears?: Maybe<Array<Maybe<Property>>>;
  on591Id?: Maybe<Scalars['String']>;
  otherData?: Maybe<Scalars['String']>;
  otherData2?: Maybe<PropertyOtherData>;
  otherSpaceNumber?: Maybe<ParkingOtherSpaceNumber>;
  owner?: Maybe<User>;
  ownerId?: Maybe<Scalars['String']>;
  parkingGarageInfo?: Maybe<ParkingGarageInfo>;
  parkingLotInfo?: Maybe<ParkingLotInfo>;
  parkings?: Maybe<Array<Maybe<PropertyParking>>>;
  patternFeatures?: Maybe<Array<Maybe<LifeFunction>>>;
  patterns?: Maybe<Array<Maybe<PropertyPattern>>>;
  photo?: Maybe<PropertyPhoto>;
  photos?: Maybe<Array<Maybe<PropertyPhoto>>>;
  price?: Maybe<Scalars['String']>;
  priceNumber?: Maybe<Scalars['Int']>;
  publicRatio?: Maybe<Scalars['Float']>;
  publicUtilities?: Maybe<Array<Maybe<PropertyPublicUtility>>>;
  publicUtilitiesComment?: Maybe<Scalars['String']>;
  referralFee?: Maybe<Scalars['Float']>;
  removalDate?: Maybe<Scalars['Date']>;
  rentPrice?: Maybe<Scalars['Int']>;
  rent_attachments?: Maybe<Array<Maybe<RentAttachment>>>;
  securityGuard?: Maybe<Scalars['Int']>;
  sellPrice?: Maybe<Scalars['Int']>;
  seller?: Maybe<User>;
  sellerId?: Maybe<Scalars['String']>;
  shape?: Maybe<PropertyShape>;
  shapeId?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  sourceContractType?: Maybe<Scalars['Int']>;
  sourceId?: Maybe<Scalars['Int']>;
  spaceNumber?: Maybe<Scalars['Float']>;
  specialComment?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
  state?: Maybe<Scalars['Int']>;
  stations?: Maybe<Array<Maybe<Mrt>>>;
  styles?: Maybe<Array<Maybe<LifeFunction>>>;
  supportSetups?: Maybe<Array<Maybe<LifeFunction>>>;
  take?: Maybe<Scalars['Int']>;
  takeViewComment?: Maybe<Scalars['String']>;
  takeViewPrice?: Maybe<Scalars['Int']>;
  takeViewSpecialTime?: Maybe<Scalars['String']>;
  taxPercentage?: Maybe<Scalars['Float']>;
  threeDImage?: Maybe<Scalars['String']>;
  totalDoorNumber?: Maybe<Scalars['Int']>;
  totalFloorNumber?: Maybe<FloorDetail>;
  transportationFacilities?: Maybe<Array<Maybe<Mrt>>>;
  type?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updaterId?: Maybe<Scalars['String']>;
  usages?: Maybe<Array<Maybe<PropertyUsage>>>;
};

/** propertyCategory data */
export type PropertyCategory = {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  properties?: Maybe<Array<Maybe<Property>>>;
};

/** PageInfo data */
export type PropertyCategoryEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<PropertyCategory>;
};

/** PropertyCategory data */
export type PropertyCategoryInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  properties?: InputMaybe<Array<InputMaybe<PropertyInput>>>;
};

/** Pagination data */
export type PropertyCategoryPagination = {
  edges?: Maybe<Array<Maybe<PropertyCategoryEdgeType>>>;
  nodes?: Maybe<Array<Maybe<PropertyCategory>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** PropertyCategory data */
export type PropertyCategorySearchInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  properties?: InputMaybe<Array<InputMaybe<PropertyInput>>>;
};

/** propertyContract data */
export type PropertyContract = {
  announceLevel?: Maybe<Scalars['Int']>;
  basicInfo?: Maybe<InfoType>;
  commission?: Maybe<Scalars['Int']>;
  companySign?: Maybe<SignInfo>;
  completedDate?: Maybe<Scalars['Date']>;
  customerType?: Maybe<Scalars['Int']>;
  dealContract?: Maybe<Scalars['String']>;
  dealContractId?: Maybe<Scalars['String']>;
  department?: Maybe<Department>;
  departmentId?: Maybe<Scalars['String']>;
  developers?: Maybe<Array<Maybe<User>>>;
  diplomaticMediation?: Maybe<Scalars['String']>;
  documented?: Maybe<Scalars['Boolean']>;
  expenses?: Maybe<Array<Maybe<Expense>>>;
  hasTax?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  info?: Maybe<ContractInfos>;
  landlord?: Maybe<User>;
  landlords?: Maybe<Array<Maybe<User>>>;
  landlordsInfo?: Maybe<Array<Maybe<ContractInfo>>>;
  parentId?: Maybe<Scalars['Int']>;
  period?: Maybe<FromToDetail>;
  photos?: Maybe<Array<Maybe<InfoPhoto>>>;
  powerOfAttorney?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  priceCovers?: Maybe<Array<Maybe<RentAttachment>>>;
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['Int']>;
  propertySnapshot?: Maybe<Scalars['JSONObject']>;
  realPrice?: Maybe<RealPrice>;
  referral?: Maybe<Referral>;
  rentType?: Maybe<Scalars['Int']>;
  secretarySign?: Maybe<SignInfo>;
  sellers?: Maybe<Array<Maybe<User>>>;
  signDate?: Maybe<Scalars['Date']>;
  signatures?: Maybe<Signature>;
  status?: Maybe<Scalars['Int']>;
  tenants?: Maybe<Array<Maybe<User>>>;
  tenantsInfo?: Maybe<Array<Maybe<ContractInfo>>>;
  type?: Maybe<Scalars['Int']>;
  uploaded?: Maybe<Scalars['Boolean']>;
  uploadedInfo?: Maybe<Scalars['JSONObject']>;
  version?: Maybe<Scalars['Int']>;
};

/** PageInfo data */
export type PropertyContractEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<PropertyContract>;
};

/** PropertyContract data */
export type PropertyContractInput = {
  announceLevel?: InputMaybe<Scalars['Int']>;
  commission?: InputMaybe<Scalars['Int']>;
  companySign?: InputMaybe<SignInfoInput>;
  completedDate?: InputMaybe<Scalars['Date']>;
  customerType?: InputMaybe<Scalars['Int']>;
  dealContract?: InputMaybe<Scalars['String']>;
  dealContractId?: InputMaybe<Scalars['String']>;
  deletePhotos?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  department?: InputMaybe<DepartmentInput>;
  departmentId?: InputMaybe<Scalars['String']>;
  developers?: InputMaybe<Array<InputMaybe<UserInput>>>;
  diplomaticMediation?: InputMaybe<Scalars['String']>;
  documented?: InputMaybe<Scalars['Boolean']>;
  expenses?: InputMaybe<Array<InputMaybe<ExpenseInput>>>;
  hasTax?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  info?: InputMaybe<ContractInfosInput>;
  landlord?: InputMaybe<UserInput>;
  landlords?: InputMaybe<Array<InputMaybe<UserInput>>>;
  landlordsInfo?: InputMaybe<Array<InputMaybe<ContractInfoInput>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  period?: InputMaybe<FromToDetailInput>;
  photos?: InputMaybe<Array<InputMaybe<InfoPhotoInput>>>;
  powerOfAttorney?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  priceCovers?: InputMaybe<Array<InputMaybe<RentAttachmentInput>>>;
  property?: InputMaybe<PropertyInput>;
  propertyId?: InputMaybe<Scalars['Int']>;
  propertySnapshot?: InputMaybe<Scalars['JSONObject']>;
  realPrice?: InputMaybe<RealPriceInput>;
  referral?: InputMaybe<ReferralInput>;
  rentType?: InputMaybe<Scalars['Int']>;
  secretarySign?: InputMaybe<SignInfoInput>;
  sellers?: InputMaybe<Array<InputMaybe<UserInput>>>;
  signDate?: InputMaybe<Scalars['Date']>;
  signatures?: InputMaybe<SignatureInput>;
  status?: InputMaybe<Scalars['Int']>;
  tenants?: InputMaybe<Array<InputMaybe<UserInput>>>;
  tenantsInfo?: InputMaybe<Array<InputMaybe<ContractInfoInput>>>;
  type?: InputMaybe<Scalars['Int']>;
  updatePhotos?: InputMaybe<Array<InputMaybe<InfoPhotoInput>>>;
  uploaded?: InputMaybe<Scalars['Boolean']>;
  uploadedInfo?: InputMaybe<Scalars['JSONObject']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** Pagination data */
export type PropertyContractPagination = {
  edges?: Maybe<Array<Maybe<PropertyContractEdgeType>>>;
  nodes?: Maybe<Array<Maybe<PropertyContract>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** PropertyContract data */
export type PropertyContractSearchInput = {
  comment?: InputMaybe<Scalars['String']>;
  departmentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  landlord?: InputMaybe<Scalars['String']>;
  period?: InputMaybe<FromToDetailInput>;
  signDate?: InputMaybe<FromToDetailInput>;
  status?: InputMaybe<Scalars['Int']>;
  tenants?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** propertyDevice data */
export type PropertyDevice = {
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** PageInfo data */
export type PropertyDeviceEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<PropertyDevice>;
};

/** PropertyDevice data */
export type PropertyDeviceInput = {
  checked?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Pagination data */
export type PropertyDevicePagination = {
  edges?: Maybe<Array<Maybe<PropertyDeviceEdgeType>>>;
  nodes?: Maybe<Array<Maybe<PropertyDevice>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** PropertyDevice data */
export type PropertyDeviceSearchInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** PageInfo data */
export type PropertyEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Property>;
};

/** propertyFace data */
export type PropertyFace = {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  properties?: Maybe<Array<Maybe<Property>>>;
};

/** PageInfo data */
export type PropertyFaceEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<PropertyFace>;
};

/** PropertyFace data */
export type PropertyFaceInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  properties?: InputMaybe<Array<InputMaybe<PropertyInput>>>;
};

/** Pagination data */
export type PropertyFacePagination = {
  edges?: Maybe<Array<Maybe<PropertyFaceEdgeType>>>;
  nodes?: Maybe<Array<Maybe<PropertyFace>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** PropertyFace data */
export type PropertyFaceSearchInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  properties?: InputMaybe<Array<InputMaybe<PropertyInput>>>;
};

/** propertyFurniture data */
export type PropertyFurniture = {
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** PageInfo data */
export type PropertyFurnitureEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<PropertyFurniture>;
};

/** PropertyFurniture data */
export type PropertyFurnitureInput = {
  checked?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Pagination data */
export type PropertyFurniturePagination = {
  edges?: Maybe<Array<Maybe<PropertyFurnitureEdgeType>>>;
  nodes?: Maybe<Array<Maybe<PropertyFurniture>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** PropertyFurniture data */
export type PropertyFurnitureSearchInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type PropertyIdentity = {
  checked?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  initChecked?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

/** Property data */
export type PropertyInput = {
  address?: InputMaybe<Scalars['String']>;
  agent?: InputMaybe<AgentDetailInput>;
  body?: InputMaybe<Scalars['String']>;
  builderName?: InputMaybe<Scalars['String']>;
  buildingName?: InputMaybe<Scalars['String']>;
  businessRegistration?: InputMaybe<Scalars['Boolean']>;
  category?: InputMaybe<PropertyCategoryInput>;
  categoryId?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<CityInput>;
  cityId?: InputMaybe<Scalars['Int']>;
  community?: InputMaybe<CommunityInput>;
  communityId?: InputMaybe<Scalars['Int']>;
  completeDate?: InputMaybe<Scalars['Date']>;
  deletePhotos?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  departmentId?: InputMaybe<Scalars['String']>;
  developers?: InputMaybe<Array<InputMaybe<UserInput>>>;
  devices?: InputMaybe<Array<InputMaybe<PropertyDeviceInput>>>;
  district?: InputMaybe<DistrictInput>;
  districtId?: InputMaybe<Scalars['Int']>;
  doorNumber?: InputMaybe<Scalars['Int']>;
  educationSchools?: InputMaybe<Array<InputMaybe<LifeFunctionInput>>>;
  elevatorsNumber?: InputMaybe<Scalars['Int']>;
  enable?: InputMaybe<Scalars['Boolean']>;
  expiredDate?: InputMaybe<Scalars['Date']>;
  face?: InputMaybe<PropertyFaceInput>;
  faceId?: InputMaybe<Scalars['String']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  floorNumber?: InputMaybe<Scalars['String']>;
  furnitures?: InputMaybe<Array<InputMaybe<PropertyFurnitureInput>>>;
  geopoint?: InputMaybe<GeoPointDetailInput>;
  headline?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  includeTax?: InputMaybe<Scalars['Boolean']>;
  internalStates?: InputMaybe<Scalars['Int']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  keyBelong?: InputMaybe<Scalars['String']>;
  keyBelongType?: InputMaybe<Scalars['Int']>;
  kind?: InputMaybe<PropertyKindInput>;
  kindId?: InputMaybe<Scalars['Int']>;
  landSpaceNumber?: InputMaybe<Scalars['Float']>;
  launchedDate?: InputMaybe<Scalars['Date']>;
  lifeFunctions?: InputMaybe<Array<InputMaybe<LifeFunctionInput>>>;
  mainSpaceNumber?: InputMaybe<Scalars['Float']>;
  mainStructure?: InputMaybe<Scalars['Int']>;
  managementFee?: InputMaybe<Scalars['Int']>;
  managementFeePerUnit?: InputMaybe<Scalars['Int']>;
  managementPhoneNumber?: InputMaybe<Scalars['String']>;
  motorcycleParkingInfo?: InputMaybe<MotorcycleParkingInfoInput>;
  mrt?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  on591Id?: InputMaybe<Scalars['String']>;
  otherData?: InputMaybe<Scalars['String']>;
  otherData2?: InputMaybe<Scalars['String']>;
  otherSpaceNumber?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<UserInput>;
  ownerId?: InputMaybe<Scalars['String']>;
  parkingGarageInfo?: InputMaybe<ParkingGarageInfoInput>;
  parkingLotInfo?: InputMaybe<ParkingLotInfoInput>;
  parkings?: InputMaybe<Array<InputMaybe<PropertyParkingInput>>>;
  patternFeatures?: InputMaybe<Array<InputMaybe<LifeFunctionInput>>>;
  patterns?: InputMaybe<Array<InputMaybe<PropertyPatternInput>>>;
  photos?: InputMaybe<Array<InputMaybe<PropertyPhotoInput>>>;
  publicRatio?: InputMaybe<Scalars['Float']>;
  publicUtilities?: InputMaybe<Array<InputMaybe<PropertyPublicUtilityInput>>>;
  publicUtilitiesComment?: InputMaybe<Scalars['String']>;
  referralFee?: InputMaybe<Scalars['Float']>;
  rentPrice?: InputMaybe<Scalars['Int']>;
  rent_attachments?: InputMaybe<Array<InputMaybe<RentAttachmentInput>>>;
  securityGuard?: InputMaybe<Scalars['Int']>;
  sellPrice?: InputMaybe<Scalars['Int']>;
  seller?: InputMaybe<UserInput>;
  sellerId?: InputMaybe<Scalars['String']>;
  shape?: InputMaybe<PropertyShapeInput>;
  shapeId?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['Int']>;
  sourceContractType?: InputMaybe<Scalars['Int']>;
  sourceId?: InputMaybe<Scalars['Int']>;
  spaceNumber?: InputMaybe<Scalars['Float']>;
  specialComment?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date']>;
  state?: InputMaybe<Scalars['Int']>;
  styles?: InputMaybe<Array<InputMaybe<LifeFunctionInput>>>;
  supportSetups?: InputMaybe<Array<InputMaybe<LifeFunctionInput>>>;
  takeViewComment?: InputMaybe<Scalars['String']>;
  takeViewPrice?: InputMaybe<Scalars['Int']>;
  takeViewSpecialTime?: InputMaybe<Scalars['String']>;
  taxPercentage?: InputMaybe<Scalars['Float']>;
  threeDImage?: InputMaybe<Scalars['String']>;
  totalDoorNumber?: InputMaybe<Scalars['Int']>;
  totalFloorNumber?: InputMaybe<FloorDetailInput>;
  transportationFacilities?: InputMaybe<Array<InputMaybe<MrtInput>>>;
  type?: InputMaybe<Scalars['Int']>;
  updatePhotos?: InputMaybe<Array<InputMaybe<PropertyPhotoInput>>>;
  usages?: InputMaybe<Array<InputMaybe<PropertyUsageInput>>>;
};

/** propertyKind data */
export type PropertyKind = {
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  properties?: Maybe<Array<Maybe<Property>>>;
};

/** PageInfo data */
export type PropertyKindEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<PropertyKind>;
};

/** PropertyKind data */
export type PropertyKindInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  properties?: InputMaybe<Array<InputMaybe<PropertyInput>>>;
};

/** Pagination data */
export type PropertyKindPagination = {
  edges?: Maybe<Array<Maybe<PropertyKindEdgeType>>>;
  nodes?: Maybe<Array<Maybe<PropertyKind>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** PropertyKind data */
export type PropertyKindSearchInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  properties?: InputMaybe<Array<InputMaybe<PropertyInput>>>;
};

/** propertyOrder data */
export type PropertyOrder = {
  address?: Maybe<Scalars['String']>;
  agent?: Maybe<AgentDetail>;
  category?: Maybe<PropertyCategory>;
  categoryId?: Maybe<Scalars['String']>;
  city?: Maybe<City>;
  cityId?: Maybe<Scalars['Int']>;
  comment?: Maybe<Scalars['String']>;
  district?: Maybe<District>;
  districtId?: Maybe<Scalars['Int']>;
  floorNumber?: Maybe<Scalars['Int']>;
  fullAddress?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  info?: Maybe<InfoType>;
  managementFee?: Maybe<Scalars['Int']>;
  orderPeriod?: Maybe<Scalars['Int']>;
  otherData?: Maybe<Scalars['String']>;
  owner?: Maybe<User>;
  ownerId?: Maybe<Scalars['String']>;
  parkings?: Maybe<Array<Maybe<PropertyParking>>>;
  patterns?: Maybe<Array<Maybe<PropertyPattern>>>;
  rentPrice?: Maybe<Scalars['Int']>;
  rent_attachments?: Maybe<Array<Maybe<RentAttachment>>>;
  sellPrice?: Maybe<Scalars['Int']>;
  seller?: Maybe<User>;
  sellerId?: Maybe<Scalars['String']>;
  totalFloorNumber?: Maybe<FloorDetail>;
  usages?: Maybe<Array<Maybe<PropertyUsage>>>;
};

/** PageInfo data */
export type PropertyOrderEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<PropertyOrder>;
};

/** PropertyOrder data */
export type PropertyOrderInput = {
  address?: InputMaybe<Scalars['String']>;
  agent?: InputMaybe<AgentDetailInput>;
  category?: InputMaybe<PropertyCategoryInput>;
  categoryId?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<CityInput>;
  cityId?: InputMaybe<Scalars['Int']>;
  comment?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<DistrictInput>;
  districtId?: InputMaybe<Scalars['Int']>;
  floorNumber?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  managementFee?: InputMaybe<Scalars['Int']>;
  orderPeriod?: InputMaybe<Scalars['Int']>;
  otherData?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<UserInput>;
  ownerId?: InputMaybe<Scalars['String']>;
  parkings?: InputMaybe<Array<InputMaybe<PropertyParkingInput>>>;
  patterns?: InputMaybe<Array<InputMaybe<PropertyPatternInput>>>;
  rentPrice?: InputMaybe<Scalars['Int']>;
  rent_attachments?: InputMaybe<Array<InputMaybe<RentAttachmentInput>>>;
  sellPrice?: InputMaybe<Scalars['Int']>;
  seller?: InputMaybe<UserInput>;
  sellerId?: InputMaybe<Scalars['String']>;
  totalFloorNumber?: InputMaybe<FloorDetailInput>;
  usages?: InputMaybe<Array<InputMaybe<PropertyUsageInput>>>;
};

/** Pagination data */
export type PropertyOrderPagination = {
  edges?: Maybe<Array<Maybe<PropertyOrderEdgeType>>>;
  nodes?: Maybe<Array<Maybe<PropertyOrder>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** PropertyOrder data */
export type PropertyOrderSearchInput = {
  departmentId?: InputMaybe<Scalars['String']>;
  fullAddress?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Scalars['String']>;
  ownerName?: InputMaybe<Scalars['String']>;
  sellerId?: InputMaybe<Scalars['String']>;
};

export type PropertyOtherData = {
  attachFloor?: Maybe<Scalars['Int']>;
  basePrice?: Maybe<BasePriceData>;
  cook?: Maybe<Scalars['Boolean']>;
  deposit?: Maybe<Scalars['Int']>;
  developerIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  education?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['Boolean']>;
  features?: Maybe<Array<Maybe<PublicFeature>>>;
  god?: Maybe<Scalars['Boolean']>;
  identities?: Maybe<Array<Maybe<PropertyIdentity>>>;
  notarization?: Maybe<Scalars['Boolean']>;
  orderAttachment?: Maybe<Scalars['String']>;
  pet?: Maybe<Scalars['Boolean']>;
  petComment?: Maybe<Scalars['String']>;
  publicUtilities?: Maybe<Array<Maybe<PublicUtilityOtherData>>>;
  registered?: Maybe<Scalars['Boolean']>;
  shortest?: Maybe<Scalars['Int']>;
  smoke?: Maybe<Scalars['Boolean']>;
  smokeComment?: Maybe<Scalars['String']>;
  style?: Maybe<Scalars['String']>;
};

/** Pagination data */
export type PropertyPagination = {
  edges?: Maybe<Array<Maybe<PropertyEdgeType>>>;
  nodes?: Maybe<Array<Maybe<Property>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** propertyParking data */
export type PropertyParking = {
  amount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['String']>;
  propertyOrder?: Maybe<PropertyOrder>;
  propertyOrderId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['Int']>;
};

/** PageInfo data */
export type PropertyParkingEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<PropertyParking>;
};

/** PropertyParking data */
export type PropertyParkingInput = {
  amount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  property?: InputMaybe<PropertyInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  propertyOrder?: InputMaybe<PropertyOrderInput>;
  propertyOrderId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['Int']>;
};

/** Pagination data */
export type PropertyParkingPagination = {
  edges?: Maybe<Array<Maybe<PropertyParkingEdgeType>>>;
  nodes?: Maybe<Array<Maybe<PropertyParking>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** PropertyParking data */
export type PropertyParkingSearchInput = {
  amount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  property?: InputMaybe<PropertyInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  propertyOrder?: InputMaybe<PropertyOrderInput>;
  propertyOrderId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['Int']>;
};

/** propertyPattern data */
export type PropertyPattern = {
  amount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['String']>;
  propertyOrder?: Maybe<PropertyOrder>;
  propertyOrderId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['Int']>;
};

/** PageInfo data */
export type PropertyPatternEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<PropertyPattern>;
};

/** PropertyPattern data */
export type PropertyPatternInput = {
  amount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  property?: InputMaybe<PropertyInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  propertyOrder?: InputMaybe<PropertyOrderInput>;
  propertyOrderId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['Int']>;
};

/** Pagination data */
export type PropertyPatternPagination = {
  edges?: Maybe<Array<Maybe<PropertyPatternEdgeType>>>;
  nodes?: Maybe<Array<Maybe<PropertyPattern>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** PropertyPattern data */
export type PropertyPatternSearchInput = {
  amount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  property?: InputMaybe<PropertyInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  propertyOrder?: InputMaybe<PropertyOrderInput>;
  propertyOrderId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['Int']>;
};

/** propertyPhoto data */
export type PropertyPhoto = {
  body?: Maybe<Scalars['String']>;
  file?: Maybe<FileDetail>;
  fileId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Int']>;
  subject?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** PageInfo data */
export type PropertyPhotoEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<PropertyPhoto>;
};

/** PropertyPhoto data */
export type PropertyPhotoInput = {
  body?: InputMaybe<Scalars['String']>;
  checked?: InputMaybe<Scalars['Boolean']>;
  file?: InputMaybe<FileInput>;
  fileId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  property?: InputMaybe<PropertyInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['Int']>;
  subject?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Pagination data */
export type PropertyPhotoPagination = {
  edges?: Maybe<Array<Maybe<PropertyPhotoEdgeType>>>;
  nodes?: Maybe<Array<Maybe<PropertyPhoto>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** PropertyPhoto data */
export type PropertyPhotoSearchInput = {
  body?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<FileInput>;
  fileId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  property?: InputMaybe<PropertyInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
};

/** propertyPublicUtility data */
export type PropertyPublicUtility = {
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** PageInfo data */
export type PropertyPublicUtilityEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<PropertyPublicUtility>;
};

/** PropertyPublicUtility data */
export type PropertyPublicUtilityInput = {
  checked?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Pagination data */
export type PropertyPublicUtilityPagination = {
  edges?: Maybe<Array<Maybe<PropertyPublicUtilityEdgeType>>>;
  nodes?: Maybe<Array<Maybe<PropertyPublicUtility>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** PropertyPublicUtility data */
export type PropertyPublicUtilitySearchInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** propertyReview data */
export type PropertyReview = {
  data?: Maybe<Scalars['String']>;
  department?: Maybe<Department>;
  departmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  info?: Maybe<InfoType>;
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['Int']>;
  reviewer?: Maybe<User>;
  reviewerId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** PageInfo data */
export type PropertyReviewEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<PropertyReview>;
};

/** PropertyReview data */
export type PropertyReviewInput = {
  data?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<DepartmentInput>;
  departmentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  property?: InputMaybe<PropertyInput>;
  propertyId?: InputMaybe<Scalars['Int']>;
  reviewer?: InputMaybe<UserInput>;
  reviewerId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** Pagination data */
export type PropertyReviewPagination = {
  edges?: Maybe<Array<Maybe<PropertyReviewEdgeType>>>;
  nodes?: Maybe<Array<Maybe<PropertyReview>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** PropertyReview data */
export type PropertyReviewSearchInput = {
  creatorId?: InputMaybe<Scalars['String']>;
  departmentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  new?: InputMaybe<Scalars['Boolean']>;
  propertyId?: InputMaybe<Scalars['Int']>;
  reviewerId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** Property data */
export type PropertySearchInput = {
  ages?: InputMaybe<Scalars['String']>;
  area?: InputMaybe<Scalars['String']>;
  areas?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  cities?: InputMaybe<Scalars['String']>;
  cityId?: InputMaybe<Scalars['String']>;
  classification?: InputMaybe<Scalars['String']>;
  communities?: InputMaybe<Scalars['String']>;
  departmentId?: InputMaybe<Scalars['String']>;
  devices?: InputMaybe<Scalars['String']>;
  districtId?: InputMaybe<Scalars['String']>;
  districts?: InputMaybe<Scalars['String']>;
  educationSchools?: InputMaybe<Scalars['String']>;
  enable?: InputMaybe<Scalars['Boolean']>;
  faces?: InputMaybe<Scalars['String']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  floors?: InputMaybe<Scalars['String']>;
  furnitures?: InputMaybe<Scalars['String']>;
  headline?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  input?: InputMaybe<Scalars['String']>;
  kind?: InputMaybe<Scalars['String']>;
  kinds?: InputMaybe<Scalars['String']>;
  lifeFunctions?: InputMaybe<Scalars['String']>;
  liveAreas?: InputMaybe<Scalars['String']>;
  mrt?: InputMaybe<Scalars['String']>;
  mrtCategory?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Scalars['String']>;
  parkingTypes?: InputMaybe<Scalars['String']>;
  pattern?: InputMaybe<Scalars['String']>;
  patternFeatures?: InputMaybe<Scalars['String']>;
  patterns?: InputMaybe<Scalars['String']>;
  pet?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['String']>;
  prices?: InputMaybe<Scalars['String']>;
  publicUtilities?: InputMaybe<Scalars['String']>;
  sellerId?: InputMaybe<Scalars['String']>;
  shape?: InputMaybe<Scalars['String']>;
  shapes?: InputMaybe<Scalars['String']>;
  shortest?: InputMaybe<Scalars['String']>;
  smoke?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['Int']>;
  styles?: InputMaybe<Scalars['String']>;
  transportationFacilities?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  usages?: InputMaybe<Scalars['String']>;
};

/** propertyShape data */
export type PropertyShape = {
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  properties?: Maybe<Array<Maybe<Property>>>;
};

/** PageInfo data */
export type PropertyShapeEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<PropertyShape>;
};

/** PropertyShape data */
export type PropertyShapeInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  properties?: InputMaybe<Array<InputMaybe<PropertyInput>>>;
};

/** Pagination data */
export type PropertyShapePagination = {
  edges?: Maybe<Array<Maybe<PropertyShapeEdgeType>>>;
  nodes?: Maybe<Array<Maybe<PropertyShape>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** PropertyShape data */
export type PropertyShapeSearchInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  properties?: InputMaybe<Array<InputMaybe<PropertyInput>>>;
};

/** propertyUsage data */
export type PropertyUsage = {
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** PageInfo data */
export type PropertyUsageEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<PropertyUsage>;
};

/** PropertyUsage data */
export type PropertyUsageInput = {
  checked?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Pagination data */
export type PropertyUsagePagination = {
  edges?: Maybe<Array<Maybe<PropertyUsageEdgeType>>>;
  nodes?: Maybe<Array<Maybe<PropertyUsage>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** PropertyUsage data */
export type PropertyUsageSearchInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type PublicFeature = {
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type PublicUtilityOtherData = {
  floorNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type Query = {
  /** get About by id */
  about?: Maybe<About>;
  /** List of all announcementCategories! */
  allAnnouncementCategories?: Maybe<Array<Maybe<AnnouncementCategory>>>;
  /** List of all announcements! */
  allAnnouncements?: Maybe<Array<Maybe<Announcement>>>;
  /** List of all blogCategories! */
  allBlogCategories?: Maybe<Array<Maybe<BlogCategory>>>;
  /** List of all blogTags! */
  allBlogTags?: Maybe<Array<Maybe<BlogTag>>>;
  /** List of all blogs! */
  allBlogs?: Maybe<Array<Maybe<Blog>>>;
  /** List of all cities! */
  allCities?: Maybe<Array<Maybe<City>>>;
  /** List of all communities! */
  allCommunities?: Maybe<Array<Maybe<Community>>>;
  /** List of all companies! */
  allCompanies?: Maybe<Array<Maybe<Company>>>;
  /** List of all companyCategories! */
  allCompanyCategories?: Maybe<Array<Maybe<CompanyCategory>>>;
  /** List of all companyTags! */
  allCompanyTags?: Maybe<Array<Maybe<CompanyTag>>>;
  /** List of all departmentInfos! */
  allDepartmentInfos?: Maybe<Array<Maybe<DepartmentInfo>>>;
  /** List of all departments! */
  allDepartments?: Maybe<Array<Maybe<Department>>>;
  /** List of all districts! */
  allDistricts?: Maybe<Array<Maybe<District>>>;
  /** List of all expenses! */
  allExpenses?: Maybe<Array<Maybe<Expense>>>;
  /** List of all files! */
  allFiles?: Maybe<Array<Maybe<File>>>;
  /** List of all infoPhotos! */
  allInfoPhotos?: Maybe<Array<Maybe<InfoPhoto>>>;
  /** List of all languageTypes! */
  allLanguageTypes?: Maybe<Array<Maybe<LanguageType>>>;
  /** List of all languages! */
  allLanguages?: Maybe<Array<Maybe<Language>>>;
  /** List of all LifeFunctions! */
  allLifeFunctions?: Maybe<Array<Maybe<LifeFunction>>>;
  /** List of all liveAreas! */
  allLiveAreas?: Maybe<Array<Maybe<LiveArea>>>;
  /** List of all mails! */
  allMails?: Maybe<Array<Maybe<Mail>>>;
  /** List of all metas! */
  allMetas?: Maybe<Array<Maybe<Meta>>>;
  /** List of all mrtCategories! */
  allMrtCategories?: Maybe<Array<Maybe<MrtCategory>>>;
  /** List of all mrts! */
  allMrts?: Maybe<Array<Maybe<Mrt>>>;
  /** List of all pages! */
  allPages?: Maybe<Array<Maybe<Page>>>;
  /** List of all payslips! */
  allPayslips?: Maybe<Array<Maybe<Payslip>>>;
  /** List of all properties! */
  allProperties?: Maybe<Array<Maybe<Property>>>;
  /** List of all propertyCategories! */
  allPropertyCategories?: Maybe<Array<Maybe<PropertyCategory>>>;
  /** List of all propertyContracts! */
  allPropertyContracts?: Maybe<Array<Maybe<PropertyContract>>>;
  /** List of all propertyDevices! */
  allPropertyDevices?: Maybe<Array<Maybe<PropertyDevice>>>;
  /** List of all propertyFaces! */
  allPropertyFaces?: Maybe<Array<Maybe<PropertyFace>>>;
  /** List of all propertyFurnitures! */
  allPropertyFurnitures?: Maybe<Array<Maybe<PropertyFurniture>>>;
  /** List of all propertyKinds! */
  allPropertyKinds?: Maybe<Array<Maybe<PropertyKind>>>;
  /** List of all propertyOrders! */
  allPropertyOrders?: Maybe<Array<Maybe<PropertyOrder>>>;
  /** List of all propertyParkings! */
  allPropertyParkings?: Maybe<Array<Maybe<PropertyParking>>>;
  /** List of all propertyPatterns! */
  allPropertyPatterns?: Maybe<Array<Maybe<PropertyPattern>>>;
  /** List of all propertyPhotos! */
  allPropertyPhotos?: Maybe<Array<Maybe<PropertyPhoto>>>;
  /** List of all propertyPublicUtilities! */
  allPropertyPublicUtilities?: Maybe<Array<Maybe<PropertyPublicUtility>>>;
  /** List of all propertyReviews! */
  allPropertyReviews?: Maybe<Array<Maybe<PropertyReview>>>;
  /** List of all propertyShapes! */
  allPropertyShapes?: Maybe<Array<Maybe<PropertyShape>>>;
  /** List of all propertyUsages! */
  allPropertyUsages?: Maybe<Array<Maybe<PropertyUsage>>>;
  /** List of all rentAttachments! */
  allRentAttachments?: Maybe<Array<Maybe<RentAttachment>>>;
  /** List of all roles! */
  allRoles?: Maybe<Array<Maybe<Role>>>;
  /** List of all systems! */
  allSystems?: Maybe<Array<Maybe<System>>>;
  /** List of all userPhotos! */
  allUserPhotos?: Maybe<Array<Maybe<UserPhoto>>>;
  /** List of all userProfiles! */
  allUserProfiles?: Maybe<Array<Maybe<UserProfile>>>;
  /** List of all userSocials! */
  allUserSocials?: Maybe<Array<Maybe<UserSocial>>>;
  /** List of all users! */
  allUsers?: Maybe<Array<Maybe<User>>>;
  /** get announcement by id */
  announcement?: Maybe<Announcement>;
  /** Pagination of all announcementCategories! */
  announcementCategories?: Maybe<AnnouncementCategoryPagination>;
  /** get announcementCategory by id */
  announcementCategory?: Maybe<AnnouncementCategory>;
  /** Pagination of all announcements! */
  announcements?: Maybe<AnnouncementPagination>;
  /** authorization and get token */
  authorization?: Maybe<User>;
  /** get blog by id */
  blog?: Maybe<Blog>;
  /** Pagination of all blogCategories! */
  blogCategories?: Maybe<BlogCategoryPagination>;
  /** get blogCategory by id */
  blogCategory?: Maybe<BlogCategory>;
  /** get blogTag by id */
  blogTag?: Maybe<BlogTag>;
  /** Pagination of all blogTags! */
  blogTags?: Maybe<BlogTagPagination>;
  /** Pagination of all blogs! */
  blogs?: Maybe<BlogPagination>;
  /** Pagination of all cities! */
  cities?: Maybe<CityPagination>;
  /** get city by id */
  city?: Maybe<City>;
  /** Pagination of all communities! */
  communities?: Maybe<CommunityPagination>;
  /** get community by id */
  community?: Maybe<Community>;
  /** Pagination of all companies! */
  companies?: Maybe<CompanyPagination>;
  /** get company by id */
  company?: Maybe<Company>;
  /** Pagination of all companyCategories! */
  companyCategories?: Maybe<CompanyCategoryPagination>;
  /** get companyCategory by id */
  companyCategory?: Maybe<CompanyCategory>;
  /** get companyTag by id */
  companyTag?: Maybe<CompanyTag>;
  /** Pagination of all companyTags! */
  companyTags?: Maybe<CompanyTagPagination>;
  /** get department by id */
  department?: Maybe<Department>;
  /** get departmentInfo by id */
  departmentInfo?: Maybe<DepartmentInfo>;
  /** Pagination of all departmentInfos! */
  departmentInfos?: Maybe<DepartmentInfoPagination>;
  /** Pagination of all departments! */
  departments?: Maybe<DepartmentPagination>;
  /** get district by id */
  district?: Maybe<District>;
  /** Pagination of all districts! */
  districts?: Maybe<DistrictPagination>;
  /** get expense by id */
  expense?: Maybe<Expense>;
  /** Pagination of all expenses! */
  expenses?: Maybe<ExpensePagination>;
  /** get file by id */
  file?: Maybe<File>;
  /** Pagination of all files! */
  files?: Maybe<FilePagination>;
  /** get infoPhoto by id */
  infoPhoto?: Maybe<InfoPhoto>;
  /** Pagination of all infoPhotos! */
  infoPhotos?: Maybe<InfoPhotoPagination>;
  /** get language by id */
  language?: Maybe<Language>;
  /** get languageType by id */
  languageType?: Maybe<LanguageType>;
  /** Pagination of all languageTypes! */
  languageTypes?: Maybe<LanguageTypePagination>;
  /** Pagination of all languages! */
  languages?: Maybe<LanguagePagination>;
  /** get liveArea by id */
  liveArea?: Maybe<LiveArea>;
  /** Pagination of all liveAreas! */
  liveAreas?: Maybe<LiveAreaPagination>;
  /** Login and get token */
  login?: Maybe<Auth>;
  /** get mail by id */
  mail?: Maybe<Mail>;
  /** Pagination of all mails! */
  mails?: Maybe<MailPagination>;
  /** get meta by id */
  meta?: Maybe<Meta>;
  /** Pagination of all metas! */
  metas?: Maybe<MetaPagination>;
  /** get mrt by id */
  mrt?: Maybe<Mrt>;
  /** Pagination of all mrtCategories! */
  mrtCategories?: Maybe<MrtCategoryPagination>;
  /** get mrtCategory by id */
  mrtCategory?: Maybe<MrtCategory>;
  /** Pagination of all mrts! */
  mrts?: Maybe<MrtPagination>;
  /** get page by id */
  page?: Maybe<Page>;
  /** Pagination of all pages! */
  pages?: Maybe<PagePagination>;
  /** get payslip by id */
  payslip?: Maybe<Payslip>;
  /** Pagination of all payslips! */
  payslips?: Maybe<PayslipPagination>;
  /** Pagination of all properties! */
  properties?: Maybe<PropertyPagination>;
  /** get property by id */
  property?: Maybe<Property>;
  /** Pagination of all propertyCategories! */
  propertyCategories?: Maybe<PropertyCategoryPagination>;
  /** get propertyCategory by id */
  propertyCategory?: Maybe<PropertyCategory>;
  /** get propertyContract by id */
  propertyContract?: Maybe<PropertyContract>;
  /** Pagination of all propertyContracts! */
  propertyContracts?: Maybe<PropertyContractPagination>;
  /** get propertyDevice by id */
  propertyDevice?: Maybe<PropertyDevice>;
  /** Pagination of all propertyDevices! */
  propertyDevices?: Maybe<PropertyDevicePagination>;
  /** get propertyFace by id */
  propertyFace?: Maybe<PropertyFace>;
  /** Pagination of all propertyFaces! */
  propertyFaces?: Maybe<PropertyFacePagination>;
  /** get propertyFurniture by id */
  propertyFurniture?: Maybe<PropertyFurniture>;
  /** Pagination of all propertyFurnitures! */
  propertyFurnitures?: Maybe<PropertyFurniturePagination>;
  /** get propertyKind by id */
  propertyKind?: Maybe<PropertyKind>;
  /** Pagination of all propertyKinds! */
  propertyKinds?: Maybe<PropertyKindPagination>;
  /** get propertyOrder by id */
  propertyOrder?: Maybe<PropertyOrder>;
  /** Pagination of all propertyOrders! */
  propertyOrders?: Maybe<PropertyOrderPagination>;
  /** get propertyParking by id */
  propertyParking?: Maybe<PropertyParking>;
  /** Pagination of all propertyParkings! */
  propertyParkings?: Maybe<PropertyParkingPagination>;
  /** get propertyPattern by id */
  propertyPattern?: Maybe<PropertyPattern>;
  /** Pagination of all propertyPatterns! */
  propertyPatterns?: Maybe<PropertyPatternPagination>;
  /** get propertyPhoto by id */
  propertyPhoto?: Maybe<PropertyPhoto>;
  /** Pagination of all propertyPhotos! */
  propertyPhotos?: Maybe<PropertyPhotoPagination>;
  /** Pagination of all propertyPublicUtilities! */
  propertyPublicUtilities?: Maybe<PropertyPublicUtilityPagination>;
  /** get propertyPublicUtility by id */
  propertyPublicUtility?: Maybe<PropertyPublicUtility>;
  /** get propertyReview by id */
  propertyReview?: Maybe<PropertyReview>;
  /** Pagination of all propertyReviews! */
  propertyReviews?: Maybe<PropertyReviewPagination>;
  /** get propertyShape by id */
  propertyShape?: Maybe<PropertyShape>;
  /** Pagination of all propertyShapes! */
  propertyShapes?: Maybe<PropertyShapePagination>;
  /** get propertyUsage by id */
  propertyUsage?: Maybe<PropertyUsage>;
  /** Pagination of all propertyUsages! */
  propertyUsages?: Maybe<PropertyUsagePagination>;
  /** get rentAttachment by id */
  rentAttachment?: Maybe<RentAttachment>;
  /** Pagination of all rentAttachments! */
  rentAttachments?: Maybe<RentAttachmentPagination>;
  /** get role by id */
  role?: Maybe<Role>;
  /** Pagination of all roles! */
  roles?: Maybe<RolePagination>;
  /** get system by id */
  system?: Maybe<System>;
  /** Pagination of all systems! */
  systems?: Maybe<SystemPagination>;
  /** get user by id */
  user?: Maybe<User>;
  /** get userPhoto by id */
  userPhoto?: Maybe<UserPhoto>;
  /** Pagination of all userPhotos! */
  userPhotos?: Maybe<UserPhotoPagination>;
  /** get userProfile by id */
  userProfile?: Maybe<UserProfile>;
  /** Pagination of all userProfiles! */
  userProfiles?: Maybe<UserProfilePagination>;
  /** get userSocial by id */
  userSocial?: Maybe<UserSocial>;
  /** Pagination of all userSocials! */
  userSocials?: Maybe<UserSocialPagination>;
  /** Pagination of all users! */
  users?: Maybe<UserPagination>;
};


export type QueryAllBlogCategoriesArgs = {
  isManage?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAllCitiesArgs = {
  onlyProperty?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAllCompanyCategoriesArgs = {
  isManage?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAllDepartmentsArgs = {
  root?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAllDistrictsArgs = {
  city?: InputMaybe<Scalars['Int']>;
  onlyProperty?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAllMrtCategoriesArgs = {
  onlyProperty?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAllMrtsArgs = {
  category?: InputMaybe<Scalars['String']>;
  onlyProperty?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAllRolesArgs = {
  department?: InputMaybe<Scalars['String']>;
  withProfile?: InputMaybe<Scalars['Boolean']>;
  withUser?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAllUsersArgs = {
  departmentId?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  roleLevel?: InputMaybe<Scalars['Int']>;
  withSocials?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAnnouncementArgs = {
  id: Scalars['Int'];
};


export type QueryAnnouncementCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<AnnouncementCategorySearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryAnnouncementCategoryArgs = {
  id: Scalars['ID'];
};


export type QueryAnnouncementsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isManage?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<AnnouncementSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryBlogArgs = {
  id: Scalars['Int'];
};


export type QueryBlogCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<BlogCategorySearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryBlogCategoryArgs = {
  id: Scalars['ID'];
};


export type QueryBlogTagArgs = {
  id: Scalars['ID'];
};


export type QueryBlogTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<BlogTagSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryBlogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isManage?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<BlogSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<CitySearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCityArgs = {
  id: Scalars['ID'];
};


export type QueryCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isManage?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<CommunitySearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCommunityArgs = {
  id: Scalars['Int'];
};


export type QueryCompaniesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isManage?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<CompanySearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCompanyArgs = {
  id: Scalars['Int'];
};


export type QueryCompanyCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<CompanyCategorySearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCompanyCategoryArgs = {
  id: Scalars['ID'];
};


export type QueryCompanyTagArgs = {
  id: Scalars['ID'];
};


export type QueryCompanyTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<CompanyTagSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryDepartmentArgs = {
  id: Scalars['ID'];
};


export type QueryDepartmentInfoArgs = {
  id: Scalars['ID'];
};


export type QueryDepartmentInfosArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<DepartmentInfoSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryDepartmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<DepartmentSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryDistrictArgs = {
  id: Scalars['ID'];
};


export type QueryDistrictsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<DistrictSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryExpenseArgs = {
  id: Scalars['Int'];
};


export type QueryExpensesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isManage?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<ExpenseSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryFileArgs = {
  id: Scalars['ID'];
};


export type QueryFilesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<FileSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryInfoPhotoArgs = {
  id: Scalars['Int'];
};


export type QueryInfoPhotosArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isManage?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<InfoPhotoSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryLanguageArgs = {
  id: Scalars['ID'];
};


export type QueryLanguageTypeArgs = {
  id: Scalars['ID'];
};


export type QueryLanguageTypesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<LanguageTypeSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryLanguagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<LanguageSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryLiveAreaArgs = {
  id: Scalars['Int'];
};


export type QueryLiveAreasArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isManage?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<LiveAreaSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryLoginArgs = {
  account: Scalars['String'];
  password: Scalars['String'];
};


export type QueryMailArgs = {
  id: Scalars['ID'];
};


export type QueryMailsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<MailSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryMetaArgs = {
  id: Scalars['ID'];
};


export type QueryMetasArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<MetaSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryMrtArgs = {
  id: Scalars['ID'];
};


export type QueryMrtCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  onlyProperty?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<MrtCategorySearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryMrtCategoryArgs = {
  id: Scalars['ID'];
  mrts?: InputMaybe<Scalars['Boolean']>;
};


export type QueryMrtsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<MrtSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPageArgs = {
  id: Scalars['ID'];
};


export type QueryPagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<PageSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPayslipArgs = {
  id: Scalars['Int'];
};


export type QueryPayslipsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isManage?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<PayslipSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPropertiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isManage?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  patterns?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<PropertySearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPropertyArgs = {
  id: Scalars['Int'];
  isManage?: InputMaybe<Scalars['Boolean']>;
};


export type QueryPropertyCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<PropertyCategorySearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPropertyCategoryArgs = {
  id: Scalars['ID'];
};


export type QueryPropertyContractArgs = {
  id: Scalars['Int'];
};


export type QueryPropertyContractsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isManage?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<PropertyContractSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPropertyDeviceArgs = {
  id: Scalars['ID'];
};


export type QueryPropertyDevicesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<PropertyDeviceSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPropertyFaceArgs = {
  id: Scalars['ID'];
};


export type QueryPropertyFacesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<PropertyFaceSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPropertyFurnitureArgs = {
  id: Scalars['ID'];
};


export type QueryPropertyFurnituresArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<PropertyFurnitureSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPropertyKindArgs = {
  id: Scalars['ID'];
};


export type QueryPropertyKindsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<PropertyKindSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPropertyOrderArgs = {
  id: Scalars['Int'];
};


export type QueryPropertyOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<PropertyOrderSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPropertyParkingArgs = {
  id: Scalars['ID'];
};


export type QueryPropertyParkingsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<PropertyParkingSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPropertyPatternArgs = {
  id: Scalars['ID'];
};


export type QueryPropertyPatternsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<PropertyPatternSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPropertyPhotoArgs = {
  id: Scalars['ID'];
};


export type QueryPropertyPhotosArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<PropertyPhotoSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPropertyPublicUtilitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<PropertyPublicUtilitySearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPropertyPublicUtilityArgs = {
  id: Scalars['ID'];
};


export type QueryPropertyReviewArgs = {
  id: Scalars['Int'];
};


export type QueryPropertyReviewsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isManage?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<PropertyReviewSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPropertyShapeArgs = {
  id: Scalars['ID'];
};


export type QueryPropertyShapesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<PropertyShapeSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPropertyUsageArgs = {
  id: Scalars['ID'];
};


export type QueryPropertyUsagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<PropertyUsageSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryRentAttachmentArgs = {
  id: Scalars['ID'];
};


export type QueryRentAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<RentAttachmentSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryRoleArgs = {
  id: Scalars['ID'];
};


export type QueryRolesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<RoleSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QuerySystemArgs = {
  id: Scalars['ID'];
};


export type QuerySystemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<SystemSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryUserPhotoArgs = {
  id: Scalars['ID'];
};


export type QueryUserPhotosArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<UserPhotoSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryUserProfileArgs = {
  id: Scalars['ID'];
};


export type QueryUserProfilesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<UserProfileSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryUserSocialArgs = {
  id: Scalars['ID'];
};


export type QueryUserSocialsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<UserSocialSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isManage?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<UserSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type RealPrice = {
  completedDate?: Maybe<Scalars['Date']>;
  completedSigner?: Maybe<Scalars['Boolean']>;
  hostCompletedDate?: Maybe<Scalars['Date']>;
  hostRegistrationNumber?: Maybe<Scalars['String']>;
  registrationNumber?: Maybe<Scalars['String']>;
};

export type RealPriceInput = {
  completedDate?: InputMaybe<Scalars['Date']>;
  completedSigner?: InputMaybe<Scalars['Boolean']>;
  hostCompletedDate?: InputMaybe<Scalars['Date']>;
  hostRegistrationNumber?: InputMaybe<Scalars['String']>;
  registrationNumber?: InputMaybe<Scalars['String']>;
};

export type Referral = {
  date?: Maybe<Scalars['Date']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  rate?: Maybe<Scalars['Float']>;
  sign?: Maybe<Scalars['Boolean']>;
};

export type ReferralInput = {
  date?: InputMaybe<Scalars['Date']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  rate?: InputMaybe<Scalars['Float']>;
  sign?: InputMaybe<Scalars['Boolean']>;
};

/** rentAttachment data */
export type RentAttachment = {
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** PageInfo data */
export type RentAttachmentEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<RentAttachment>;
};

/** RentAttachment data */
export type RentAttachmentInput = {
  checked?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Pagination data */
export type RentAttachmentPagination = {
  edges?: Maybe<Array<Maybe<RentAttachmentEdgeType>>>;
  nodes?: Maybe<Array<Maybe<RentAttachment>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** RentAttachment data */
export type RentAttachmentSearchInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Result data */
export type Result = {
  affectedRows?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
};

/** role data */
export type Role = {
  department?: Maybe<Department>;
  departmentId?: Maybe<Scalars['String']>;
  enable?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  level?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Int']>;
  users?: Maybe<Array<Maybe<User>>>;
};

/** PageInfo data */
export type RoleEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Role>;
};

/** Role data */
export type RoleInput = {
  department?: InputMaybe<DepartmentInput>;
  departmentId?: InputMaybe<Scalars['String']>;
  enable?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  level?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['Int']>;
  users?: InputMaybe<Array<InputMaybe<UserInput>>>;
};

/** Pagination data */
export type RolePagination = {
  edges?: Maybe<Array<Maybe<RoleEdgeType>>>;
  nodes?: Maybe<Array<Maybe<Role>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Role data */
export type RoleSearchInput = {
  department?: InputMaybe<DepartmentInput>;
  departmentId?: InputMaybe<Scalars['String']>;
  enable?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  level?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['Int']>;
  users?: InputMaybe<Array<InputMaybe<UserInput>>>;
};

export type SignInfo = {
  date?: Maybe<Scalars['Date']>;
  price?: Maybe<Scalars['Int']>;
};

export type SignInfoInput = {
  date?: InputMaybe<Scalars['Date']>;
  price?: InputMaybe<Scalars['Int']>;
};

export type Signature = {
  secretary?: Maybe<SignatureItem>;
  supervisor?: Maybe<SignatureItem>;
};

export type SignatureInput = {
  secretary?: InputMaybe<SignatureItemInput>;
  supervisor?: InputMaybe<SignatureItemInput>;
};

export type SignatureItem = {
  date?: Maybe<Scalars['Date']>;
  signature?: Maybe<Scalars['String']>;
};

export type SignatureItemInput = {
  date?: InputMaybe<Scalars['Date']>;
  signature?: InputMaybe<Scalars['String']>;
  signatureUpload?: InputMaybe<Scalars['Upload']>;
};

/** system data */
export type System = {
  data?: Maybe<Scalars['String']>;
  dataJSON?: Maybe<Scalars['JSONObject']>;
  id?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
};

/** PageInfo data */
export type SystemEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<System>;
};

/** System data */
export type SystemInput = {
  data?: InputMaybe<Scalars['String']>;
  dataJSON?: InputMaybe<Scalars['JSONObject']>;
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Pagination data */
export type SystemPagination = {
  edges?: Maybe<Array<Maybe<SystemEdgeType>>>;
  nodes?: Maybe<Array<Maybe<System>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** System data */
export type SystemSearchInput = {
  data?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** user data */
export type User = {
  account?: Maybe<Scalars['String']>;
  cover?: Maybe<FileDetail>;
  department?: Maybe<Department>;
  departmentId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  info?: Maybe<InfoType>;
  landlordPropertyContracts?: Maybe<Array<Maybe<PropertyContract>>>;
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ownerProperties?: Maybe<Array<Maybe<Property>>>;
  password?: Maybe<Scalars['String']>;
  payment?: Maybe<PaymentInfo>;
  photos?: Maybe<Array<Maybe<UserPhoto>>>;
  profile?: Maybe<UserProfile>;
  properties?: Maybe<UserProperty>;
  role?: Maybe<Role>;
  roleId?: Maybe<Scalars['String']>;
  socials?: Maybe<Array<Maybe<UserSocial>>>;
  sort?: Maybe<Scalars['Int']>;
  tenantPropertyContracts?: Maybe<Array<Maybe<PropertyContract>>>;
};

/** UserCompany data */
export type UserCompany = {
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  taxIDNumber?: Maybe<Scalars['String']>;
};

/** UserCompanyInput data */
export type UserCompanyInput = {
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  taxIDNumber?: InputMaybe<Scalars['String']>;
};

/** PageInfo data */
export type UserEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<User>;
};

/** User data */
export type UserInput = {
  account?: InputMaybe<Scalars['String']>;
  cover?: InputMaybe<Scalars['Upload']>;
  creatorId?: InputMaybe<Scalars['String']>;
  deletePhotos?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  department?: InputMaybe<DepartmentInput>;
  departmentId?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  newPassword?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  photos?: InputMaybe<Array<InputMaybe<UserPhotoInput>>>;
  profile?: InputMaybe<UserProfileInput>;
  role?: InputMaybe<RoleInput>;
  roleId?: InputMaybe<Scalars['String']>;
  socialWithImgs?: InputMaybe<Array<InputMaybe<UserSocialInput>>>;
  socials?: InputMaybe<Array<InputMaybe<UserSocialInput>>>;
  sort?: InputMaybe<Scalars['Int']>;
  sourceId?: InputMaybe<Scalars['String']>;
  updatePhotos?: InputMaybe<Array<InputMaybe<UserPhotoInput>>>;
};

/** Pagination data */
export type UserPagination = {
  edges?: Maybe<Array<Maybe<UserEdgeType>>>;
  nodes?: Maybe<Array<Maybe<User>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** userPhoto data */
export type UserPhoto = {
  body?: Maybe<Scalars['String']>;
  file?: Maybe<FileDetail>;
  fileId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  subject?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
};

/** PageInfo data */
export type UserPhotoEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<UserPhoto>;
};

/** UserPhoto data */
export type UserPhotoInput = {
  body?: InputMaybe<Scalars['String']>;
  checked?: InputMaybe<Scalars['Boolean']>;
  file?: InputMaybe<FileInput>;
  fileId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['Int']>;
  subject?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<UserInput>;
  userId?: InputMaybe<Scalars['String']>;
};

/** Pagination data */
export type UserPhotoPagination = {
  edges?: Maybe<Array<Maybe<UserPhotoEdgeType>>>;
  nodes?: Maybe<Array<Maybe<UserPhoto>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** UserPhoto data */
export type UserPhotoSearchInput = {
  body?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<FileInput>;
  fileId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<UserInput>;
  userId?: InputMaybe<Scalars['String']>;
};

/** userProfile data */
export type UserProfile = {
  address?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['Date']>;
  city?: Maybe<City>;
  cityId?: Maybe<Scalars['Int']>;
  company?: Maybe<UserCompany>;
  description?: Maybe<Scalars['String']>;
  district?: Maybe<District>;
  districtId?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  emergencyContact?: Maybe<ContractInfoEmergencyContact>;
  fullAddress?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['Boolean']>;
  homeNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  idNumber?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
};

/** PageInfo data */
export type UserProfileEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<UserProfile>;
};

/** UserProfile data */
export type UserProfileInput = {
  address?: InputMaybe<Scalars['String']>;
  birthday?: InputMaybe<Scalars['Date']>;
  city?: InputMaybe<CityInput>;
  cityId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<UserCompanyInput>;
  description?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<DistrictInput>;
  districtId?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  emergencyContact?: InputMaybe<ContractInfoEmergencyContactInput>;
  gender?: InputMaybe<Scalars['Boolean']>;
  homeNumber?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  idNumber?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<UserInput>;
  userId?: InputMaybe<Scalars['String']>;
};

/** Pagination data */
export type UserProfilePagination = {
  edges?: Maybe<Array<Maybe<UserProfileEdgeType>>>;
  nodes?: Maybe<Array<Maybe<UserProfile>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** UserProfile data */
export type UserProfileSearchInput = {
  address?: InputMaybe<Scalars['String']>;
  birthday?: InputMaybe<Scalars['Date']>;
  city?: InputMaybe<CityInput>;
  cityId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<UserCompanyInput>;
  description?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<DistrictInput>;
  districtId?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['Boolean']>;
  homeNumber?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  idNumber?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<UserInput>;
  userId?: InputMaybe<Scalars['String']>;
};

export type UserProperty = {
  /** The userPropertiesData */
  all?: Maybe<Array<Maybe<Property>>>;
  /** The userPropertiesData */
  featured?: Maybe<Array<Maybe<Property>>>;
  /** The userPropertiesData */
  headline?: Maybe<Property>;
};

/** User data */
export type UserSearchInput = {
  account?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  idNumber?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  level?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
};

/** userSocial data */
export type UserSocial = {
  customId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  img?: Maybe<FileDetail>;
  imgId?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
};

/** PageInfo data */
export type UserSocialEdgeType = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<UserSocial>;
};

/** UserSocial data */
export type UserSocialInput = {
  customId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  img?: InputMaybe<Scalars['Upload']>;
  path?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<UserInput>;
  userId?: InputMaybe<Scalars['String']>;
};

/** Pagination data */
export type UserSocialPagination = {
  edges?: Maybe<Array<Maybe<UserSocialEdgeType>>>;
  nodes?: Maybe<Array<Maybe<UserSocial>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** UserSocial data */
export type UserSocialSearchInput = {
  customId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  img?: InputMaybe<FileInput>;
  imgId?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<UserInput>;
  userId?: InputMaybe<Scalars['String']>;
};

export type GetFullAboutQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFullAboutQuery = { about?: { story?: string | null, info?: { title?: string | null, description?: string | null, email?: string | null, homeNumber?: string | null, phoneNumber?: string | null, fullAddress?: string | null, logo?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null, bannerLogo?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null, relations?: Array<{ title?: string | null, link?: string | null, logo?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null> | null } | null };

export type GetAboutCoverAndStoryQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAboutCoverAndStoryQueryQuery = { about?: { story?: string | null, info?: { aboutCover?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null } | null };

export type GetDepartmentMembersQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetDepartmentMembersQuery = { user?: { id: string, name?: string | null, cover?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null, role?: { name?: string | null } | null, department?: { id?: string | null, name?: string | null } | null, profile?: { description?: string | null, phoneNumber?: string | null, homeNumber?: string | null, fullAddress?: string | null, address?: string | null, email?: string | null } | null, socials?: Array<{ type?: string | null, customId?: string | null, path?: string | null, img?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null> | null, photos?: Array<{ subject?: string | null, body?: string | null, file?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null> | null, properties?: { headline?: { id?: number | null, name?: string | null, type?: number | null, featured?: boolean | null, isNew?: boolean | null, price?: string | null, age?: string | null, state?: number | null, body_short?: string | null, spaceNumber?: number | null, mainSpaceNumber?: number | null, photo?: { file?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null, patterns?: Array<{ amount?: number | null, type?: number | null } | null> | null, category?: { id?: string | null, name?: string | null } | null, city?: { name?: string | null } | null, district?: { name?: string | null } | null } | null } | null } | null };

export type BlogFieldsFragment = { id: number, subject?: string | null, description?: string | null, category?: { id?: string | null, name?: string | null, type?: number | null } | null, cover?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null, info?: { createdAt?: any | null, updatedAt?: any | null } | null };

export type BlogQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type BlogQuery = { blog?: { subject?: string | null, description?: string | null, body?: string | null, cover?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null, category?: { id?: string | null, name?: string | null, type?: number | null } | null, info?: { createdAt?: any | null, updatedAt?: any | null, creator?: { id: string, name?: string | null, role?: { level?: number | null } | null, cover?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null, updater?: { name?: string | null } | null } | null, related?: Array<{ id: number, subject?: string | null, description?: string | null, category?: { id?: string | null, name?: string | null, type?: number | null } | null, cover?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null, info?: { createdAt?: any | null, updatedAt?: any | null } | null } | null> | null } | null };

export type BlogsQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
  query?: InputMaybe<BlogSearchInput>;
  orderBy?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
}>;


export type BlogsQuery = { blogs?: { totalCount?: number | null, nodes?: Array<{ id: number, subject?: string | null, description?: string | null, category?: { id?: string | null, name?: string | null, type?: number | null } | null, cover?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null, info?: { createdAt?: any | null, updatedAt?: any | null } | null } | null> | null, pageInfo?: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, currentPageIndex?: number | null, totalPageCount?: number | null } | null } | null };

export type AllBlogCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllBlogCategoriesQuery = { allBlogCategories?: Array<{ id?: string | null, name?: string | null } | null> | null };

export type AllCitiesQueryVariables = Exact<{
  onlyProperty?: InputMaybe<Scalars['Boolean']>;
}>;


export type AllCitiesQuery = { allCities?: Array<{ id?: number | null, name?: string | null } | null> | null };

export type CommunityFieldsFragment = { id?: number | null, name?: string | null, body?: string | null, cityId?: number | null, districtId?: number | null, address?: string | null, builderName?: string | null, mainStructure?: number | null, completeDate?: any | null, doorNumber?: number | null, elevatorsNumber?: number | null, managementPhoneNumber?: string | null, securityGuard?: number | null, takeViewPrice?: number | null, takeViewComment?: string | null, takeViewSpecialTime?: string | null, publicUtilitiesComment?: string | null };

export type CommunityQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CommunityQuery = { community?: { id?: number | null, name?: string | null, body?: string | null, cityId?: number | null, districtId?: number | null, address?: string | null, builderName?: string | null, mainStructure?: number | null, completeDate?: any | null, doorNumber?: number | null, elevatorsNumber?: number | null, managementPhoneNumber?: string | null, securityGuard?: number | null, takeViewPrice?: number | null, takeViewComment?: string | null, takeViewSpecialTime?: string | null, publicUtilitiesComment?: string | null, photos?: Array<{ id?: string | null, subject?: string | null, body?: string | null, file?: { id: string, targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null> | null } | null };

export type CommunitiesQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
  query?: InputMaybe<CommunitySearchInput>;
}>;


export type CommunitiesQuery = { communities?: { totalCount?: number | null, nodes?: Array<{ id?: number | null, name?: string | null, body?: string | null, cityId?: number | null, districtId?: number | null, address?: string | null, builderName?: string | null, mainStructure?: number | null, completeDate?: any | null, doorNumber?: number | null, elevatorsNumber?: number | null, managementPhoneNumber?: string | null, securityGuard?: number | null, takeViewPrice?: number | null, takeViewComment?: string | null, takeViewSpecialTime?: string | null, publicUtilitiesComment?: string | null } | null> | null, pageInfo?: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, currentPageIndex?: number | null, totalPageCount?: number | null } | null } | null };

export type CompanyFieldsFragment = { id: number, name?: string | null, description?: string | null, category?: { id?: string | null, name?: string | null } | null, cover?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null, info?: { createdAt?: any | null, updatedAt?: any | null } | null };

export type CompanyQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CompanyQuery = { company?: { name?: string | null, description?: string | null, url?: string | null, body?: string | null, location?: { fullAddress?: string | null } | null, cover?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null, category?: { id?: string | null, name?: string | null } | null, info?: { createdAt?: any | null, updatedAt?: any | null, creator?: { id: string, name?: string | null, role?: { level?: number | null } | null, cover?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null, updater?: { name?: string | null } | null } | null, related?: Array<{ id: number, name?: string | null, description?: string | null, category?: { id?: string | null, name?: string | null } | null, cover?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null, info?: { createdAt?: any | null, updatedAt?: any | null } | null } | null> | null } | null };

export type CompaniesQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
  query?: InputMaybe<CompanySearchInput>;
}>;


export type CompaniesQuery = { companies?: { totalCount?: number | null, nodes?: Array<{ id: number, name?: string | null, description?: string | null, category?: { id?: string | null, name?: string | null } | null, cover?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null, info?: { createdAt?: any | null, updatedAt?: any | null } | null } | null> | null, pageInfo?: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, currentPageIndex?: number | null, totalPageCount?: number | null } | null } | null };

export type AllCompanyCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCompanyCategoriesQuery = { allCompanyCategories?: Array<{ id?: string | null, name?: string | null } | null> | null };

export type GetDepartmentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetDepartmentQuery = { department?: { id?: string | null, name?: string | null, enable?: boolean | null, level?: number | null, info?: { description?: string | null, story?: string | null, email?: string | null, phoneNumber?: string | null, homeNumber?: string | null, cityId?: number | null, districtId?: number | null, fullAddress?: string | null, logo?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null, aboutCover?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null } | null };

export type InfoFieldFragment = { info?: { phoneNumber?: string | null, homeNumber?: string | null, fullAddress?: string | null, logo?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null };

export type GetAllDepartmentQueryVariables = Exact<{
  root?: InputMaybe<Scalars['Boolean']>;
  withInfo: Scalars['Boolean'];
}>;


export type GetAllDepartmentQuery = { allDepartments?: Array<{ id?: string | null, name?: string | null, info?: { phoneNumber?: string | null, homeNumber?: string | null, fullAddress?: string | null, logo?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null } | null> | null };

export type AllDistrictsQueryVariables = Exact<{
  city: Scalars['Int'];
  onlyProperty?: InputMaybe<Scalars['Boolean']>;
}>;


export type AllDistrictsQuery = { allDistricts?: Array<{ id?: number | null, name?: string | null, zip?: number | null } | null> | null };

export type ExpenseFieldsFragment = { id?: number | null, type?: string | null, userId?: string | null, rate?: number | null, sourcePrice?: number | null, referralPrice?: number | null, tax?: number | null, finalPrice?: number | null, fillPrice?: number | null, registrationDate?: any | null, contractId?: string | null, comment?: string | null, user?: { id: string, name?: string | null } | null };

export type ExpenseQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ExpenseQuery = { expense?: { id?: number | null, userId?: string | null, rate?: number | null, sourcePrice?: number | null, referralPrice?: number | null, tax?: number | null, finalPrice?: number | null, fillPrice?: number | null, contractId?: string | null } | null };

export type ExpensesQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
  query?: InputMaybe<ExpenseSearchInput>;
}>;


export type ExpensesQuery = { expenses?: { totalCount?: number | null, nodes?: Array<{ id?: number | null, type?: string | null, userId?: string | null, rate?: number | null, sourcePrice?: number | null, referralPrice?: number | null, tax?: number | null, finalPrice?: number | null, fillPrice?: number | null, registrationDate?: any | null, contractId?: string | null, comment?: string | null, user?: { id: string, name?: string | null } | null } | null> | null, pageInfo?: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, currentPageIndex?: number | null, totalPageCount?: number | null } | null } | null };

export type InfoPhotoFieldsFragment = { id?: string | null, subject?: string | null, body?: string | null, fileId?: string | null };

export type InfoPhotoQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type InfoPhotoQuery = { infoPhoto?: { id?: string | null, subject?: string | null, body?: string | null, fileId?: string | null } | null };

export type InfoPhotosQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
  query?: InputMaybe<InfoPhotoSearchInput>;
}>;


export type InfoPhotosQuery = { infoPhotos?: { totalCount?: number | null, nodes?: Array<{ id?: string | null, subject?: string | null, body?: string | null, fileId?: string | null } | null> | null, pageInfo?: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, currentPageIndex?: number | null, totalPageCount?: number | null } | null } | null };

export type NearByFieldFragment = { nearbyFacilities?: { massTransit?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, majorConstruction?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, departmentStore?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, medicalInformation?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, leisureFacilities?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, supermarket?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, traditionalMarket?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, shoppingDistrict?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, educationSchools?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null } | null };

export type LiveAreaFieldsFragment = { id?: number | null, name?: string | null, fullAddressShort?: string | null, photo?: { file?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null, nearbyFacilities?: { massTransit?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, majorConstruction?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, departmentStore?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, medicalInformation?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, leisureFacilities?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, supermarket?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, traditionalMarket?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, shoppingDistrict?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, educationSchools?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null } | null };

export type LiveAreaQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LiveAreaQuery = { liveArea?: { id?: number | null, name?: string | null, fullAddressShort?: string | null, body?: string | null, communities?: Array<{ id?: number | null, name?: string | null } | null> | null, photos?: Array<{ file?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null> | null, nearbyFacilities?: { massTransit?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, majorConstruction?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, departmentStore?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, medicalInformation?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, leisureFacilities?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, supermarket?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, traditionalMarket?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, shoppingDistrict?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, educationSchools?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null } | null } | null };

export type LiveAreasQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
  query?: InputMaybe<LiveAreaSearchInput>;
}>;


export type LiveAreasQuery = { liveAreas?: { totalCount?: number | null, nodes?: Array<{ id?: number | null, name?: string | null, fullAddressShort?: string | null, photo?: { file?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null, nearbyFacilities?: { massTransit?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, majorConstruction?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, departmentStore?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, medicalInformation?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, leisureFacilities?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, supermarket?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, traditionalMarket?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, shoppingDistrict?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, educationSchools?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null } | null } | null> | null, pageInfo?: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, currentPageIndex?: number | null, totalPageCount?: number | null } | null } | null };

export type AllMrtCategoriesQueryVariables = Exact<{
  onlyProperty?: InputMaybe<Scalars['Boolean']>;
}>;


export type AllMrtCategoriesQuery = { allMrtCategories?: Array<{ id?: string | null, name?: string | null } | null> | null };

export type AllMrtsQueryVariables = Exact<{
  category?: InputMaybe<Scalars['String']>;
  onlyProperty?: InputMaybe<Scalars['Boolean']>;
}>;


export type AllMrtsQuery = { allMrts?: Array<{ id?: string | null, name?: string | null } | null> | null };

export type SearchLocationsQueryVariables = Exact<{
  query?: InputMaybe<MrtCategorySearchInput>;
  onlyProperty?: InputMaybe<Scalars['Boolean']>;
}>;


export type SearchLocationsQuery = { mrtCategories?: { nodes?: Array<{ id?: string | null, name?: string | null, mrts?: Array<{ id?: string | null, name?: string | null } | null> | null } | null> | null } | null };

export type AllMembersQueryVariables = Exact<{
  roleLevel?: InputMaybe<Scalars['Int']>;
  departmentId?: InputMaybe<Scalars['String']>;
}>;


export type AllMembersQuery = { allUsers?: Array<{ id: string, name?: string | null, cover?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null, profile?: { phoneNumber?: string | null } | null, socials?: Array<{ type?: string | null, customId?: string | null, path?: string | null, img?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null> | null } | null> | null };

export type AllRentAttachmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllRentAttachmentsQuery = { allRentAttachments?: Array<{ id?: number | null, name?: string | null } | null> | null };

export type AllPropertyShapesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPropertyShapesQuery = { allPropertyShapes?: Array<{ id?: number | null, name?: string | null } | null> | null };

export type AllPropertyShapesValueQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPropertyShapesValueQuery = { allPropertyShapes?: Array<{ value?: number | null, title?: string | null } | null> | null };

export type AllPropertyKindsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPropertyKindsQuery = { allPropertyKinds?: Array<{ id?: number | null, name?: string | null } | null> | null };

export type AllPropertyKindsValueQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPropertyKindsValueQuery = { allPropertyKinds?: Array<{ value?: number | null, title?: string | null } | null> | null };

export type AllPropertyUsagesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPropertyUsagesQuery = { allPropertyUsages?: Array<{ id?: number | null, name?: string | null } | null> | null };

export type CreatePropertyOrderMutationVariables = Exact<{
  input: PropertyOrderInput;
}>;


export type CreatePropertyOrderMutation = { createPropertyOrder?: { id: number } | null };

export type AllPropertyFacesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPropertyFacesQuery = { allPropertyFaces?: Array<{ id?: string | null, name?: string | null } | null> | null };

export type AllPropertyFurnituresQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPropertyFurnituresQuery = { allPropertyFurnitures?: Array<{ id?: number | null, name?: string | null } | null> | null };

export type AllPropertyPublicUtilitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPropertyPublicUtilitiesQuery = { allPropertyPublicUtilities?: Array<{ id?: number | null, name?: string | null } | null> | null };

export type AllLifeFunctionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllLifeFunctionsQuery = { allLifeFunctions?: Array<{ id?: number | null, name?: string | null, type?: string | null } | null> | null };

export type AllPropertyDevicesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPropertyDevicesQuery = { allPropertyDevices?: Array<{ id?: number | null, name?: string | null } | null> | null };

export type GetPageQueryVariables = Exact<{
  id: Scalars['ID'];
  withBody: Scalars['Boolean'];
}>;


export type GetPageQuery = { page?: { id: string, title?: string | null, description?: string | null, body?: string | null, cover?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null, breadCrumb?: Array<{ url?: string | null, title?: string | null } | null> | null } | null };

export type PayslipFieldsFragment = { id?: number | null, comment?: string | null, userId?: string | null, status?: number | null, completedDate?: any | null, snapshot?: any | null, expenses?: Array<{ id?: number | null, type?: string | null, userId?: string | null, rate?: number | null, sourcePrice?: number | null, referralPrice?: number | null, tax?: number | null, finalPrice?: number | null, fillPrice?: number | null, registrationDate?: any | null, contractId?: string | null, comment?: string | null, user?: { id: string, name?: string | null } | null } | null> | null, user?: { departmentId?: string | null, name?: string | null, department?: { name?: string | null } | null } | null, period?: { from?: any | null, to?: any | null } | null };

export type PayslipQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type PayslipQuery = { payslip?: { id?: number | null, userId?: string | null, status?: number | null, completedDate?: any | null } | null };

export type PayslipsQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
  query?: InputMaybe<PayslipSearchInput>;
}>;


export type PayslipsQuery = { payslips?: { totalCount?: number | null, nodes?: Array<{ id?: number | null, comment?: string | null, userId?: string | null, status?: number | null, completedDate?: any | null, snapshot?: any | null, expenses?: Array<{ id?: number | null, type?: string | null, userId?: string | null, rate?: number | null, sourcePrice?: number | null, referralPrice?: number | null, tax?: number | null, finalPrice?: number | null, fillPrice?: number | null, registrationDate?: any | null, contractId?: string | null, comment?: string | null, user?: { id: string, name?: string | null } | null } | null> | null, user?: { departmentId?: string | null, name?: string | null, department?: { name?: string | null } | null } | null, period?: { from?: any | null, to?: any | null } | null } | null> | null, pageInfo?: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, currentPageIndex?: number | null, totalPageCount?: number | null } | null } | null };

export type PropertyContractFieldsFragment = { id?: number | null, type?: number | null, completedDate?: any | null, signDate?: any | null, propertyId?: number | null, price?: number | null, commission?: number | null, documented?: boolean | null, uploaded?: boolean | null, priceCovers?: Array<{ id?: number | null, name?: string | null } | null> | null };

export type PropertyContractQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type PropertyContractQuery = { propertyContract?: { id?: number | null, type?: number | null, completedDate?: any | null, signDate?: any | null, propertyId?: number | null, price?: number | null, commission?: number | null, documented?: boolean | null, uploaded?: boolean | null, priceCovers?: Array<{ id?: number | null, name?: string | null } | null> | null } | null };

export type PropertyContractsQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
  query?: InputMaybe<PropertyContractSearchInput>;
}>;


export type PropertyContractsQuery = { propertyContracts?: { totalCount?: number | null, nodes?: Array<{ id?: number | null, type?: number | null, completedDate?: any | null, signDate?: any | null, propertyId?: number | null, price?: number | null, commission?: number | null, documented?: boolean | null, uploaded?: boolean | null, priceCovers?: Array<{ id?: number | null, name?: string | null } | null> | null } | null> | null, pageInfo?: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, currentPageIndex?: number | null, totalPageCount?: number | null } | null } | null };

export type PropertyReviewFieldsFragment = { id?: number | null, departmentId?: string | null, propertyId?: number | null, status?: string | null, reviewerId?: string | null };

export type PropertyReviewQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type PropertyReviewQuery = { propertyReview?: { id?: number | null, departmentId?: string | null, propertyId?: number | null, status?: string | null, reviewerId?: string | null } | null };

export type PropertyReviewsQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
  query?: InputMaybe<PropertyReviewSearchInput>;
}>;


export type PropertyReviewsQuery = { propertyReviews?: { totalCount?: number | null, nodes?: Array<{ id?: number | null, departmentId?: string | null, propertyId?: number | null, status?: string | null, reviewerId?: string | null } | null> | null, pageInfo?: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, currentPageIndex?: number | null, totalPageCount?: number | null } | null } | null };

export type PropertyFullFieldsFragment = { id?: number | null, name?: string | null, isNew?: boolean | null, startDate?: any | null, expiredDate?: any | null, state?: number | null, classification?: number | null, body?: string | null, featured?: boolean | null, price?: string | null, spaceNumber?: number | null, mainSpaceNumber?: number | null, floorNumber?: string | null, otherData?: string | null, publicRatio?: number | null, completeDate?: any | null, age?: string | null, buildingName?: string | null, elevatorsNumber?: number | null, fullAddressShort?: string | null, fullAddress?: string | null, keyBelong?: string | null, threeDImage?: string | null, type?: number | null, launchedDate?: any | null, enable?: boolean | null, managementFee?: number | null, managementFeePerUnit?: number | null, referralFee?: number | null, builderName?: string | null, businessRegistration?: boolean | null, doorNumber?: number | null, totalDoorNumber?: number | null, includeTax?: boolean | null, internalStates?: number | null, keyBelongType?: number | null, landSpaceNumber?: number | null, mainStructure?: number | null, managementPhoneNumber?: string | null, on591Id?: string | null, securityGuard?: number | null, sourceContractType?: number | null, specialComment?: string | null, takeViewComment?: string | null, takeViewPrice?: number | null, takeViewSpecialTime?: string | null, taxPercentage?: number | null, nears?: Array<{ fullAddressShort?: string | null, id?: number | null, name?: string | null, type?: number | null, featured?: boolean | null, isNew?: boolean | null, price?: string | null, age?: string | null, state?: number | null, body_short?: string | null, spaceNumber?: number | null, mainSpaceNumber?: number | null, geopoint?: { longitude?: number | null, latitude?: number | null } | null, photo?: { file?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null, patterns?: Array<{ amount?: number | null, type?: number | null } | null> | null, category?: { id?: string | null, name?: string | null } | null, city?: { name?: string | null } | null, district?: { name?: string | null } | null } | null> | null, transportationFacilities?: Array<{ id?: string | null, name?: string | null, category?: { id?: string | null, type?: string | null } | null } | null> | null, seller?: { id: string, name?: string | null, cover?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null, department?: { id?: string | null, name?: string | null, info?: { homeNumber?: string | null } | null } | null, profile?: { phoneNumber?: string | null, description?: string | null } | null, socials?: Array<{ type?: string | null, customId?: string | null, path?: string | null, img?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null> | null } | null, totalFloorNumber?: { up?: number | null, down?: number | null } | null, otherData2?: { orderAttachment?: string | null, education?: string | null, attachFloor?: number | null, deposit?: number | null, shortest?: number | null, cook?: boolean | null, pet?: boolean | null, style?: string | null, petComment?: string | null, smokeComment?: string | null, features?: Array<{ id?: number | null, description?: string | null } | null> | null, identities?: Array<{ id?: number | null, name?: string | null, checked?: boolean | null, initChecked?: boolean | null } | null> | null, publicUtilities?: Array<{ id?: number | null, floorNumber?: string | null } | null> | null, basePrice?: { price?: number | null, show?: boolean | null, orderAttachment?: string | null, rentAttachments?: Array<{ name?: string | null } | null> | null } | null } | null, devices?: Array<{ id?: number | null, name?: string | null } | null> | null, furnitures?: Array<{ id?: number | null, name?: string | null } | null> | null, publicUtilities?: Array<{ id?: number | null, name?: string | null } | null> | null, lifeFunctions?: Array<{ id?: number | null, name?: string | null } | null> | null, styles?: Array<{ name?: string | null } | null> | null, patternFeatures?: Array<{ name?: string | null } | null> | null, supportSetups?: Array<{ name?: string | null } | null> | null, educationSchools?: Array<{ name?: string | null } | null> | null, kind?: { name?: string | null } | null, shape?: { name?: string | null } | null, category?: { id?: string | null, name?: string | null } | null, face?: { name?: string | null } | null, geopoint?: { latitude?: number | null, longitude?: number | null } | null, photos?: Array<{ id: string, subject?: string | null, body?: string | null, type?: string | null, file?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null> | null, parkings?: Array<{ id?: number | null, amount?: number | null, type?: number | null } | null> | null, patterns?: Array<{ amount?: number | null, type?: number | null } | null> | null, rent_attachments?: Array<{ id?: number | null, name?: string | null } | null> | null, usages?: Array<{ name?: string | null } | null> | null, community?: { id?: number | null, name?: string | null } | null, motorcycleParkingInfo?: { parkNumber?: string | null, type?: number | null, comment?: string | null } | null, otherSpaceNumber?: { underground?: number | null, arcade?: number | null, attached?: number | null, publicUtilities?: number | null, independentParking?: number | null, floors?: Array<{ name?: string | null, spaceNumber?: number | null } | null> | null } | null, parkingGarageInfo?: { type?: number | null, parkNumber?: Array<{ value?: string | null } | null> | null } | null, parkingLotInfo?: { type?: number | null } | null };

export type GetPropertyQueryVariables = Exact<{
  id: Scalars['Int'];
  isManage?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetPropertyQuery = { property?: { id?: number | null, name?: string | null, isNew?: boolean | null, startDate?: any | null, expiredDate?: any | null, state?: number | null, classification?: number | null, body?: string | null, featured?: boolean | null, price?: string | null, spaceNumber?: number | null, mainSpaceNumber?: number | null, floorNumber?: string | null, otherData?: string | null, publicRatio?: number | null, completeDate?: any | null, age?: string | null, buildingName?: string | null, elevatorsNumber?: number | null, fullAddressShort?: string | null, fullAddress?: string | null, keyBelong?: string | null, threeDImage?: string | null, type?: number | null, launchedDate?: any | null, enable?: boolean | null, managementFee?: number | null, managementFeePerUnit?: number | null, referralFee?: number | null, builderName?: string | null, businessRegistration?: boolean | null, doorNumber?: number | null, totalDoorNumber?: number | null, includeTax?: boolean | null, internalStates?: number | null, keyBelongType?: number | null, landSpaceNumber?: number | null, mainStructure?: number | null, managementPhoneNumber?: string | null, on591Id?: string | null, securityGuard?: number | null, sourceContractType?: number | null, specialComment?: string | null, takeViewComment?: string | null, takeViewPrice?: number | null, takeViewSpecialTime?: string | null, taxPercentage?: number | null, nears?: Array<{ fullAddressShort?: string | null, id?: number | null, name?: string | null, type?: number | null, featured?: boolean | null, isNew?: boolean | null, price?: string | null, age?: string | null, state?: number | null, body_short?: string | null, spaceNumber?: number | null, mainSpaceNumber?: number | null, geopoint?: { longitude?: number | null, latitude?: number | null } | null, photo?: { file?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null, patterns?: Array<{ amount?: number | null, type?: number | null } | null> | null, category?: { id?: string | null, name?: string | null } | null, city?: { name?: string | null } | null, district?: { name?: string | null } | null } | null> | null, transportationFacilities?: Array<{ id?: string | null, name?: string | null, category?: { id?: string | null, type?: string | null } | null } | null> | null, seller?: { id: string, name?: string | null, cover?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null, department?: { id?: string | null, name?: string | null, info?: { homeNumber?: string | null } | null } | null, profile?: { phoneNumber?: string | null, description?: string | null } | null, socials?: Array<{ type?: string | null, customId?: string | null, path?: string | null, img?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null> | null } | null, totalFloorNumber?: { up?: number | null, down?: number | null } | null, otherData2?: { orderAttachment?: string | null, education?: string | null, attachFloor?: number | null, deposit?: number | null, shortest?: number | null, cook?: boolean | null, pet?: boolean | null, style?: string | null, petComment?: string | null, smokeComment?: string | null, features?: Array<{ id?: number | null, description?: string | null } | null> | null, identities?: Array<{ id?: number | null, name?: string | null, checked?: boolean | null, initChecked?: boolean | null } | null> | null, publicUtilities?: Array<{ id?: number | null, floorNumber?: string | null } | null> | null, basePrice?: { price?: number | null, show?: boolean | null, orderAttachment?: string | null, rentAttachments?: Array<{ name?: string | null } | null> | null } | null } | null, devices?: Array<{ id?: number | null, name?: string | null } | null> | null, furnitures?: Array<{ id?: number | null, name?: string | null } | null> | null, publicUtilities?: Array<{ id?: number | null, name?: string | null } | null> | null, lifeFunctions?: Array<{ id?: number | null, name?: string | null } | null> | null, styles?: Array<{ name?: string | null } | null> | null, patternFeatures?: Array<{ name?: string | null } | null> | null, supportSetups?: Array<{ name?: string | null } | null> | null, educationSchools?: Array<{ name?: string | null } | null> | null, kind?: { name?: string | null } | null, shape?: { name?: string | null } | null, category?: { id?: string | null, name?: string | null } | null, face?: { name?: string | null } | null, geopoint?: { latitude?: number | null, longitude?: number | null } | null, photos?: Array<{ id: string, subject?: string | null, body?: string | null, type?: string | null, file?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null> | null, parkings?: Array<{ id?: number | null, amount?: number | null, type?: number | null } | null> | null, patterns?: Array<{ amount?: number | null, type?: number | null } | null> | null, rent_attachments?: Array<{ id?: number | null, name?: string | null } | null> | null, usages?: Array<{ name?: string | null } | null> | null, community?: { id?: number | null, name?: string | null } | null, motorcycleParkingInfo?: { parkNumber?: string | null, type?: number | null, comment?: string | null } | null, otherSpaceNumber?: { underground?: number | null, arcade?: number | null, attached?: number | null, publicUtilities?: number | null, independentParking?: number | null, floors?: Array<{ name?: string | null, spaceNumber?: number | null } | null> | null } | null, parkingGarageInfo?: { type?: number | null, parkNumber?: Array<{ value?: string | null } | null> | null } | null, parkingLotInfo?: { type?: number | null } | null } | null };

export type GetPropertyPageQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
  orderBy?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<PropertySearchInput>;
}>;


export type GetPropertyPageQuery = { properties?: { totalCount?: number | null, nodes?: Array<{ fullAddressShort?: string | null, id?: number | null, name?: string | null, type?: number | null, featured?: boolean | null, isNew?: boolean | null, price?: string | null, age?: string | null, state?: number | null, body_short?: string | null, spaceNumber?: number | null, mainSpaceNumber?: number | null, photo?: { file?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null, patterns?: Array<{ amount?: number | null, type?: number | null } | null> | null, category?: { id?: string | null, name?: string | null } | null, city?: { name?: string | null } | null, district?: { name?: string | null } | null } | null> | null, pageInfo?: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, currentPageIndex?: number | null, totalPageCount?: number | null } | null } | null };

export type SystemPropertyFilesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SystemPropertyFilesQuery = { system?: { dataJSON?: any | null } | null };

export type LoginQueryVariables = Exact<{
  account: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginQuery = { login?: { token?: string | null } | null };

export type AuthorizationQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthorizationQuery = { authorization?: { id: string, name?: string | null, department?: { name?: string | null, id?: string | null } | null, role?: { level?: number | null, name?: string | null } | null, cover?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null };

export type AllRolesQueryVariables = Exact<{
  department?: InputMaybe<Scalars['String']>;
  withUser?: InputMaybe<Scalars['Boolean']>;
  withProfile?: InputMaybe<Scalars['Boolean']>;
}>;


export type AllRolesQuery = { allRoles?: Array<{ name?: string | null, department?: { id?: string | null, name?: string | null } | null, users?: Array<{ id: string, name?: string | null, cover?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null, profile?: { phoneNumber?: string | null, description?: string | null } | null, socials?: Array<{ type?: string | null, customId?: string | null, path?: string | null, img?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null> | null, properties?: { all?: Array<{ id?: number | null } | null> | null } | null } | null> | null } | null> | null };

export type UpdateAboutMutationVariables = Exact<{
  input: AboutInput;
}>;


export type UpdateAboutMutation = { updateAbout?: { affectedRows?: number | null } | null };

export type AboutQueryVariables = Exact<{ [key: string]: never; }>;


export type AboutQuery = { about?: { story?: string | null, info?: { title?: string | null, logoId?: string | null, bannerLogoId?: string | null, watermarkId?: string | null, aboutCoverId?: string | null, description?: string | null, email?: string | null, homeNumber?: string | null, phoneNumber?: string | null, story?: string | null, cityId?: number | null, districtId?: number | null, address?: string | null, logo?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null, bannerLogo?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null, watermark?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null, aboutCover?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null, city?: { name?: string | null } | null, district?: { name?: string | null } | null } | null, relations?: Array<{ title?: string | null, link?: string | null, logoId?: string | null, logo?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null> | null } | null };

export type CreateAnnouncementCategoryMutationVariables = Exact<{
  input: AnnouncementCategoryInput;
}>;


export type CreateAnnouncementCategoryMutation = { createAnnouncementCategory?: { id?: string | null } | null };

export type UpdateAnnouncementCategoryMutationVariables = Exact<{
  input: AnnouncementCategoryInput;
}>;


export type UpdateAnnouncementCategoryMutation = { updateAnnouncementCategory?: { id?: string | null } | null };

export type DeleteAnnouncementCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteAnnouncementCategoryMutation = { deleteAnnouncementCategory?: { id?: string | null, affectedRows?: number | null } | null };

export type AllAnnouncementCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllAnnouncementCategoriesQuery = { allAnnouncementCategories?: Array<{ id?: string | null, name?: string | null } | null> | null };

export type AnnouncementCategoryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AnnouncementCategoryQuery = { announcementCategory?: { id?: string | null, name?: string | null, type?: number | null, color?: string | null } | null };

export type AnnouncementCategoriesQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
  query?: InputMaybe<AnnouncementCategorySearchInput>;
}>;


export type AnnouncementCategoriesQuery = { announcementCategories?: { totalCount?: number | null, nodes?: Array<{ id?: string | null, name?: string | null, color?: string | null, type?: number | null } | null> | null, pageInfo?: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, currentPageIndex?: number | null, totalPageCount?: number | null } | null } | null };

export type CreateAnnouncementMutationVariables = Exact<{
  input: AnnouncementInput;
}>;


export type CreateAnnouncementMutation = { createAnnouncement?: { id?: number | null } | null };

export type UpdateAnnouncementMutationVariables = Exact<{
  input: AnnouncementInput;
}>;


export type UpdateAnnouncementMutation = { updateAnnouncement?: { id?: number | null } | null };

export type DeleteAnnouncementMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteAnnouncementMutation = { deleteAnnouncement?: { id?: string | null, affectedRows?: number | null } | null };

export type AllAnnouncementsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllAnnouncementsQuery = { allAnnouncements?: Array<{ id?: number | null, subject?: string | null, description?: string | null, body?: string | null, category?: { name?: string | null } | null } | null> | null };

export type AnnouncementQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AnnouncementQuery = { announcement?: { id?: number | null, subject?: string | null, description?: string | null, body?: string | null, categoryId?: string | null, enable?: boolean | null, toUsers?: Array<{ id: string, name?: string | null, departmentId?: string | null } | null> | null, toDepartments?: Array<{ id?: string | null, name?: string | null } | null> | null, category?: { name?: string | null, color?: string | null } | null, info?: { updatedAt?: any | null, createdAt?: any | null, creator?: { id: string, name?: string | null } | null, updater?: { name?: string | null, cover?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null } | null, period?: { from?: any | null, to?: any | null } | null } | null };

export type AnnouncementsQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
  query?: InputMaybe<AnnouncementSearchInput>;
}>;


export type AnnouncementsQuery = { announcements?: { totalCount?: number | null, nodes?: Array<{ id?: number | null, subject?: string | null, enable?: boolean | null, category?: { name?: string | null, color?: string | null, id?: string | null } | null, info?: { updatedAt?: any | null, createdAt?: any | null, creator?: { id: string, name?: string | null } | null, updater?: { name?: string | null, cover?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null } | null, toUsers?: Array<{ id: string, name?: string | null } | null> | null, toDepartments?: Array<{ id?: string | null, name?: string | null } | null> | null, period?: { from?: any | null, to?: any | null } | null } | null> | null, pageInfo?: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, currentPageIndex?: number | null, totalPageCount?: number | null } | null } | null };

export type CreateBlogMutationVariables = Exact<{
  input: BlogInput;
}>;


export type CreateBlogMutation = { createBlog?: { id: number } | null };

export type UpdateBlogMutationVariables = Exact<{
  input: BlogInput;
}>;


export type UpdateBlogMutation = { updateBlog?: { id: number } | null };

export type DeleteBlogMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteBlogMutation = { deleteBlog?: { id?: string | null, affectedRows?: number | null } | null };

export type AllBlogsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllBlogsQuery = { allBlogs?: Array<{ id: number, subject?: string | null, description?: string | null, body?: string | null, category?: { name?: string | null } | null } | null> | null };

export type ManageBlogQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ManageBlogQuery = { blog?: { id: number, subject?: string | null, description?: string | null, body?: string | null, categoryId?: string | null, enable?: boolean | null, cover?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null, info?: { updatedAt?: any | null, createdAt?: any | null, creator?: { id: string, departmentId?: string | null, name?: string | null } | null, updater?: { name?: string | null, cover?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null } | null, photos?: Array<{ id?: string | null, subject?: string | null, body?: string | null, fileId?: string | null, file?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null> | null } | null };

export type ManageBlogsQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
  orderBy?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<BlogSearchInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
}>;


export type ManageBlogsQuery = { blogs?: { totalCount?: number | null, nodes?: Array<{ id: number, subject?: string | null, description?: string | null, enable?: boolean | null, body?: string | null, sort?: number | null, category?: { name?: string | null } | null, info?: { updatedAt?: any | null, createdAt?: any | null, creator?: { id: string, name?: string | null } | null, updater?: { name?: string | null, cover?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null } | null } | null> | null, pageInfo?: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, currentPageIndex?: number | null, totalPageCount?: number | null } | null } | null };

export type CreateBlogCategoryMutationVariables = Exact<{
  input: BlogCategoryInput;
}>;


export type CreateBlogCategoryMutation = { createBlogCategory?: { id?: string | null } | null };

export type UpdateBlogCategoryMutationVariables = Exact<{
  input: BlogCategoryInput;
}>;


export type UpdateBlogCategoryMutation = { updateBlogCategory?: { id?: string | null } | null };

export type DeleteBlogCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteBlogCategoryMutation = { deleteBlogCategory?: { id?: string | null, affectedRows?: number | null } | null };

export type ManageAllBlogCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type ManageAllBlogCategoriesQuery = { allBlogCategories?: Array<{ id?: string | null, name?: string | null, type?: number | null } | null> | null };

export type BlogCategoryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BlogCategoryQuery = { blogCategory?: { id?: string | null, name?: string | null, type?: number | null } | null };

export type BlogCategoriesQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
  reverse?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<BlogCategorySearchInput>;
}>;


export type BlogCategoriesQuery = { blogCategories?: { totalCount?: number | null, nodes?: Array<{ id?: string | null, name?: string | null, type?: number | null } | null> | null, pageInfo?: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, currentPageIndex?: number | null, totalPageCount?: number | null } | null } | null };

export type CreateCommunityMutationVariables = Exact<{
  input: CommunityInput;
}>;


export type CreateCommunityMutation = { createCommunity?: { id?: number | null } | null };

export type UpdateCommunityMutationVariables = Exact<{
  input: CommunityInput;
}>;


export type UpdateCommunityMutation = { updateCommunity?: { id?: number | null } | null };

export type DeleteCommunityMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteCommunityMutation = { deleteCommunity?: { id?: string | null, affectedRows?: number | null } | null };

export type AllCommunitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCommunitiesQuery = { allCommunities?: Array<{ id?: number | null, name?: string | null, body?: string | null, cityId?: number | null, districtId?: number | null, address?: string | null, builderName?: string | null, mainStructure?: number | null, completeDate?: any | null, doorNumber?: number | null, elevatorsNumber?: number | null, managementPhoneNumber?: string | null, securityGuard?: number | null, takeViewPrice?: number | null, takeViewComment?: string | null, takeViewSpecialTime?: string | null } | null> | null };

export type ManageCommunityQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ManageCommunityQuery = { community?: { id?: number | null, name?: string | null, body?: string | null, cityId?: number | null, districtId?: number | null, address?: string | null, builderName?: string | null, mainStructure?: number | null, completeDate?: any | null, totalDoorNumber?: number | null, doorNumber?: number | null, elevatorsNumber?: number | null, managementPhoneNumber?: string | null, securityGuard?: number | null, takeViewPrice?: number | null, takeViewComment?: string | null, takeViewSpecialTime?: string | null, publicUtilitiesComment?: string | null, overrideLiveAreaId?: number | null, photos?: Array<{ id?: string | null, subject?: string | null, body?: string | null, file?: { id: string, targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null> | null, geopoint?: { latitude?: number | null, longitude?: number | null } | null, totalFloorNumber?: { up?: number | null, down?: number | null } | null, publicUtilities?: Array<{ id?: number | null, name?: string | null } | null> | null, lifeFunctions?: Array<{ id?: number | null, name?: string | null } | null> | null, liveAreas?: Array<{ id?: number | null, name?: string | null } | null> | null, transportationFacilities?: Array<{ id?: string | null, name?: string | null } | null> | null, educationSchools?: Array<{ id?: number | null, name?: string | null } | null> | null, otherData?: { education?: string | null, publicUtilities?: Array<{ id?: number | null, floorNumber?: string | null } | null> | null } | null } | null };

export type ManageCommunitiesQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
  query?: InputMaybe<CommunitySearchInput>;
}>;


export type ManageCommunitiesQuery = { communities?: { totalCount?: number | null, nodes?: Array<{ id?: number | null, name?: string | null, fullAddress?: string | null, info?: { updatedAt?: any | null, createdAt?: any | null, creator?: { id: string, name?: string | null } | null, updater?: { name?: string | null, cover?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null } | null } | null> | null, pageInfo?: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, currentPageIndex?: number | null, totalPageCount?: number | null } | null } | null };

export type CreateCompanyMutationVariables = Exact<{
  input: CompanyInput;
}>;


export type CreateCompanyMutation = { createCompany?: { id: number } | null };

export type UpdateCompanyMutationVariables = Exact<{
  input: CompanyInput;
  nameUpdate?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateCompanyMutation = { updateCompany?: { id: number } | null };

export type DeleteCompanyMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteCompanyMutation = { deleteCompany?: { id?: string | null, affectedRows?: number | null } | null };

export type AllCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCompaniesQuery = { allCompanies?: Array<{ id: number, name?: string | null, description?: string | null, body?: string | null, category?: { name?: string | null } | null } | null> | null };

export type ManageCompanyQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ManageCompanyQuery = { company?: { id: number, name?: string | null, description?: string | null, body?: string | null, url?: string | null, categoryId?: string | null, enable?: boolean | null, location?: { id?: string | null, cityId?: number | null, overseas?: boolean | null, districtId?: number | null, address?: string | null } | null, cover?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null, info?: { updatedAt?: any | null, createdAt?: any | null, creator?: { id: string, departmentId?: string | null, name?: string | null } | null, updater?: { name?: string | null, cover?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null } | null } | null };

export type ManageCompaniesQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
  query?: InputMaybe<CompanySearchInput>;
}>;


export type ManageCompaniesQuery = { companies?: { totalCount?: number | null, nodes?: Array<{ id: number, name?: string | null, enable?: boolean | null, category?: { name?: string | null } | null, info?: { updatedAt?: any | null, createdAt?: any | null, creator?: { id: string, name?: string | null } | null, updater?: { name?: string | null, cover?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null } | null } | null> | null, pageInfo?: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, currentPageIndex?: number | null, totalPageCount?: number | null } | null } | null };

export type CreateCompanyCategoryMutationVariables = Exact<{
  input: CompanyCategoryInput;
}>;


export type CreateCompanyCategoryMutation = { createCompanyCategory?: { id?: string | null } | null };

export type UpdateCompanyCategoryMutationVariables = Exact<{
  input: CompanyCategoryInput;
}>;


export type UpdateCompanyCategoryMutation = { updateCompanyCategory?: { id?: string | null } | null };

export type DeleteCompanyCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCompanyCategoryMutation = { deleteCompanyCategory?: { id?: string | null, affectedRows?: number | null } | null };

export type ManageAllCompanyCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type ManageAllCompanyCategoriesQuery = { allCompanyCategories?: Array<{ id?: string | null, name?: string | null, type?: number | null } | null> | null };

export type CompanyCategoryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CompanyCategoryQuery = { companyCategory?: { id?: string | null, name?: string | null, type?: number | null } | null };

export type CompanyCategoriesQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
}>;


export type CompanyCategoriesQuery = { companyCategories?: { totalCount?: number | null, nodes?: Array<{ id?: string | null, name?: string | null, type?: number | null } | null> | null, pageInfo?: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, currentPageIndex?: number | null, totalPageCount?: number | null } | null } | null };

export type CreateDepartmentMutationVariables = Exact<{
  input: DepartmentInput;
}>;


export type CreateDepartmentMutation = { createDepartment?: { id?: string | null } | null };

export type UpdateDepartmentMutationVariables = Exact<{
  input: DepartmentInput;
}>;


export type UpdateDepartmentMutation = { updateDepartment?: { id?: string | null } | null };

export type DeleteDepartmentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteDepartmentMutation = { deleteDepartment?: { id?: string | null, affectedRows?: number | null } | null };

export type DepartmentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DepartmentQuery = { department?: { id?: string | null, name?: string | null, enable?: boolean | null, level?: number | null, info?: { id?: string | null, description?: string | null, story?: string | null, email?: string | null, phoneNumber?: string | null, homeNumber?: string | null, address?: string | null, cityId?: number | null, districtId?: number | null, fullAddress?: string | null, logo?: { id: string, targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null, aboutCover?: { id: string, targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null, watermark?: { id: string, targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null } | null };

export type DepartmentsQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
}>;


export type DepartmentsQuery = { departments?: { totalCount?: number | null, nodes?: Array<{ id?: string | null, name?: string | null, info?: { fullAddress?: string | null, phoneNumber?: string | null, homeNumber?: string | null, email?: string | null } | null } | null> | null, pageInfo?: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, currentPageIndex?: number | null, totalPageCount?: number | null } | null } | null };

export type AllDepartmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllDepartmentsQuery = { allDepartments?: Array<{ id?: string | null, name?: string | null, info?: { fullAddress?: string | null, phoneNumber?: string | null, homeNumber?: string | null, email?: string | null } | null } | null> | null };

export type CreateExpenseMutationVariables = Exact<{
  input: ExpenseInput;
}>;


export type CreateExpenseMutation = { createExpense?: { id?: number | null } | null };

export type UpdateExpenseMutationVariables = Exact<{
  input: ExpenseInput;
}>;


export type UpdateExpenseMutation = { updateExpense?: { id?: number | null } | null };

export type DeleteExpenseMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteExpenseMutation = { deleteExpense?: { id?: string | null, affectedRows?: number | null } | null };

export type AllExpensesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllExpensesQuery = { allExpenses?: Array<{ id?: number | null, userId?: string | null, rate?: number | null, sourcePrice?: number | null, referralPrice?: number | null, tax?: number | null, finalPrice?: number | null, contractId?: string | null } | null> | null };

export type ManageExpenseQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ManageExpenseQuery = { expense?: { id?: number | null, type?: string | null, userId?: string | null, rate?: number | null, sourcePrice?: number | null, referralPrice?: number | null, tax?: number | null, finalPrice?: number | null, fillPrice?: number | null, status?: number | null, registrationDate?: any | null, completedDate?: any | null, separate?: any | null, sourceExpenseId?: number | null, comment?: string | null, user?: { departmentId?: string | null } | null } | null };

export type ManageExpensesQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
  query?: InputMaybe<ExpenseSearchInput>;
}>;


export type ManageExpensesQuery = { expenses?: { totalCount?: number | null, nodes?: Array<{ id?: number | null, type?: string | null, comment?: string | null, rate?: number | null, finalPrice?: number | null, status?: number | null, registrationDate?: any | null, completedDate?: any | null, separate?: any | null, sourceExpenseId?: number | null, user?: { name?: string | null, department?: { name?: string | null } | null } | null, info?: { creator?: { id: string, name?: string | null } | null } | null } | null> | null, pageInfo?: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, currentPageIndex?: number | null, totalPageCount?: number | null } | null } | null };

export type CreateFileMutationVariables = Exact<{
  files?: InputMaybe<Array<InputMaybe<FileInput>> | InputMaybe<FileInput>>;
  target: Scalars['String'];
  options?: InputMaybe<CreateImageOptionsInput>;
}>;


export type CreateFileMutation = { createFile?: Array<{ id: string, targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null> | null };

export type ProcessFilesMutationVariables = Exact<{
  filePaths?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type ProcessFilesMutation = { processFiles?: Array<{ id: string, targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null> | null };

export type CreateInfoPhotoMutationVariables = Exact<{
  input: InfoPhotoInput;
}>;


export type CreateInfoPhotoMutation = { createInfoPhoto?: { id?: string | null } | null };

export type UpdateInfoPhotoMutationVariables = Exact<{
  input: InfoPhotoInput;
}>;


export type UpdateInfoPhotoMutation = { updateInfoPhoto?: { id?: string | null } | null };

export type DeleteInfoPhotoMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteInfoPhotoMutation = { deleteInfoPhoto?: { id?: string | null, affectedRows?: number | null } | null };

export type AllInfoPhotosQueryVariables = Exact<{ [key: string]: never; }>;


export type AllInfoPhotosQuery = { allInfoPhotos?: Array<{ id?: string | null, subject?: string | null, body?: string | null, fileId?: string | null } | null> | null };

export type ManageInfoPhotoQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ManageInfoPhotoQuery = { infoPhoto?: { id?: string | null, subject?: string | null, body?: string | null, fileId?: string | null } | null };

export type ManageInfoPhotosQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
  query?: InputMaybe<InfoPhotoSearchInput>;
}>;


export type ManageInfoPhotosQuery = { infoPhotos?: { totalCount?: number | null, nodes?: Array<{ id?: string | null, subject?: string | null, body?: string | null, fileId?: string | null } | null> | null, pageInfo?: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, currentPageIndex?: number | null, totalPageCount?: number | null } | null } | null };

export type CreateLanguageMutationVariables = Exact<{
  input?: InputMaybe<LanguageInput>;
}>;


export type CreateLanguageMutation = { createLanguage?: { id?: string | null } | null };

export type UpdateLanguageMutationVariables = Exact<{
  input?: InputMaybe<LanguageInput>;
}>;


export type UpdateLanguageMutation = { updateLanguage?: { id?: string | null, zh_tw?: string | null, en?: string | null, ja?: string | null, type?: number | null } | null };

export type DeleteLanguageMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteLanguageMutation = { deleteLanguage?: { id?: string | null, affectedRows?: number | null } | null };

export type AllLanguagesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllLanguagesQuery = { allLanguages?: Array<{ id?: string | null, zh_tw?: string | null, en?: string | null, ja?: string | null, type?: number | null } | null> | null };

export type LanguageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LanguageQuery = { language?: { id?: string | null, zh_tw?: string | null, en?: string | null, ja?: string | null, type?: number | null } | null };

export type LanguagesQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
  query?: InputMaybe<LanguageSearchInput>;
}>;


export type LanguagesQuery = { languages?: { totalCount?: number | null, nodes?: Array<{ id?: string | null, zh_tw?: string | null, en?: string | null, ja?: string | null, type?: number | null } | null> | null, pageInfo?: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, currentPageIndex?: number | null, totalPageCount?: number | null } | null } | null };

export type NearbyFacilityFieldFragment = { id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null };

export type CreateLiveAreaMutationVariables = Exact<{
  input: LiveAreaInput;
}>;


export type CreateLiveAreaMutation = { createLiveArea?: { id?: number | null } | null };

export type UpdateLiveAreaMutationVariables = Exact<{
  input: LiveAreaInput;
}>;


export type UpdateLiveAreaMutation = { updateLiveArea?: { id?: number | null } | null };

export type DeleteLiveAreaMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteLiveAreaMutation = { deleteLiveArea?: { id?: string | null, affectedRows?: number | null } | null };

export type AllLiveAreasQueryVariables = Exact<{ [key: string]: never; }>;


export type AllLiveAreasQuery = { allLiveAreas?: Array<{ id?: number | null, name?: string | null, body?: string | null, cityId?: number | null, districtId?: number | null, address?: string | null } | null> | null };

export type ManageLiveAreaQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ManageLiveAreaQuery = { liveArea?: { id?: number | null, name?: string | null, body?: string | null, cityId?: number | null, districtId?: number | null, address?: string | null, photos?: Array<{ id?: string | null, subject?: string | null, body?: string | null, file?: { id: string, targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null> | null, nearbyFacilities?: { massTransit?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, majorConstruction?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, departmentStore?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, medicalInformation?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, leisureFacilities?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, supermarket?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, traditionalMarket?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, shoppingDistrict?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null, educationSchools?: Array<{ id?: string | null, name?: string | null, lifeFunctionId?: number | null, url?: string | null } | null> | null } | null } | null };

export type ManageLiveAreasQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
  query?: InputMaybe<LiveAreaSearchInput>;
}>;


export type ManageLiveAreasQuery = { liveAreas?: { totalCount?: number | null, nodes?: Array<{ id?: number | null, name?: string | null, fullAddress?: string | null, info?: { updatedAt?: any | null, createdAt?: any | null, creator?: { id: string, name?: string | null } | null, updater?: { name?: string | null, cover?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null } | null } | null> | null, pageInfo?: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, currentPageIndex?: number | null, totalPageCount?: number | null } | null } | null };

export type CreateMrtCategoryMutationVariables = Exact<{
  input: MrtCategoryInput;
}>;


export type CreateMrtCategoryMutation = { createMrtCategory?: { id?: string | null } | null };

export type UpdateMrtCategoryMutationVariables = Exact<{
  input: MrtCategoryInput;
}>;


export type UpdateMrtCategoryMutation = { updateMrtCategory?: { id?: string | null } | null };

export type DeleteMrtCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteMrtCategoryMutation = { deleteMrtCategory?: { id?: string | null, affectedRows?: number | null } | null };

export type ManageAllMrtCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type ManageAllMrtCategoriesQuery = { allMrtCategories?: Array<{ id?: string | null, name?: string | null, type?: string | null } | null> | null };

export type MrtCategoryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MrtCategoryQuery = { mrtCategory?: { id?: string | null, name?: string | null, type?: string | null, system?: boolean | null, mrts?: Array<{ id?: string | null, name?: string | null, cityId?: number | null, districtId?: number | null, address?: string | null, geopoint?: { longitude?: number | null, latitude?: number | null } | null } | null> | null } | null };

export type MrtCategoriesQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
}>;


export type MrtCategoriesQuery = { mrtCategories?: { totalCount?: number | null, nodes?: Array<{ id?: string | null, name?: string | null, type?: string | null, system?: boolean | null } | null> | null, pageInfo?: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, currentPageIndex?: number | null, totalPageCount?: number | null } | null } | null };

export type CreateMrtMutationVariables = Exact<{
  input: MrtInput;
}>;


export type CreateMrtMutation = { createMrt?: { id?: string | null } | null };

export type UpdateMrtMutationVariables = Exact<{
  input: MrtInput;
}>;


export type UpdateMrtMutation = { updateMrt?: { id?: string | null } | null };

export type DeleteMrtMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteMrtMutation = { deleteMrt?: { id?: string | null, affectedRows?: number | null } | null };

export type ManageAllMrtsQueryVariables = Exact<{
  category?: InputMaybe<Scalars['String']>;
}>;


export type ManageAllMrtsQuery = { allMrts?: Array<{ id?: string | null, name?: string | null, cityId?: number | null, districtId?: number | null, address?: string | null, geopoint?: { longitude?: number | null, latitude?: number | null } | null } | null> | null };

export type MrtQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MrtQuery = { mrt?: { id?: string | null, name?: string | null, cityId?: number | null, districtId?: number | null, overseas?: boolean | null, url?: string | null, lifeFunctionId?: number | null, address?: string | null, categoryId?: string | null, geopoint?: { longitude?: number | null, latitude?: number | null } | null } | null };

export type MrtsQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
  query?: InputMaybe<MrtSearchInput>;
}>;


export type MrtsQuery = { mrts?: { totalCount?: number | null, nodes?: Array<{ id?: string | null, name?: string | null, address?: string | null, cityId?: number | null, districtId?: number | null, overseas?: boolean | null, url?: string | null, fullAddress?: string | null, lifeFunctionId?: number | null, lifeFunction?: { id?: number | null, name?: string | null } | null, category?: { id?: string | null, name?: string | null } | null, geopoint?: { longitude?: number | null, latitude?: number | null } | null } | null> | null, pageInfo?: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, currentPageIndex?: number | null, totalPageCount?: number | null } | null } | null };

export type CreatePageMutationVariables = Exact<{
  input: PageInput;
}>;


export type CreatePageMutation = { createPage?: { id: string } | null };

export type UpdatePageMutationVariables = Exact<{
  input: PageInput;
}>;


export type UpdatePageMutation = { updatePage?: { id: string } | null };

export type DeletePageMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeletePageMutation = { deletePage?: { id?: string | null, affectedRows?: number | null } | null };

export type ManageGetPageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ManageGetPageQuery = { page?: { id: string, title?: string | null, description?: string | null, body?: string | null, defaultPage?: boolean | null, cover?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null };

export type GetPageExistQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPageExistQuery = { page?: { id: string } | null };

export type GetPagePageQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
}>;


export type GetPagePageQuery = { pages?: { totalCount?: number | null, nodes?: Array<{ id: string, title?: string | null, defaultPage?: boolean | null } | null> | null, pageInfo?: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, currentPageIndex?: number | null, totalPageCount?: number | null } | null } | null };

export type CreatePayslipMutationVariables = Exact<{
  input: PayslipInput;
}>;


export type CreatePayslipMutation = { createPayslip?: { id?: number | null } | null };

export type CreatePayslipsMutationVariables = Exact<{
  input: Array<InputMaybe<PayslipInput>> | InputMaybe<PayslipInput>;
}>;


export type CreatePayslipsMutation = { createPayslips?: Array<{ id?: number | null } | null> | null };

export type CreateMultiplePayslipMutationVariables = Exact<{
  input: PayslipSearchInput;
}>;


export type CreateMultiplePayslipMutation = { createMultiplePayslip?: Array<{ user?: { id: string, name?: string | null, department?: { id?: string | null, name?: string | null } | null, payment?: { withholding?: boolean | null, healthInsurance?: { checked?: boolean | null, price?: number | null } | null, laborProtection?: { checked?: boolean | null, price?: number | null } | null } | null } | null, expenses?: Array<{ id?: number | null, rate?: number | null, type?: string | null, sourcePrice?: number | null, referralPrice?: number | null, tax?: number | null, finalPrice?: number | null, fillPrice?: number | null, registrationDate?: any | null, status?: number | null, comment?: string | null } | null> | null } | null> | null };

export type UpdatePayslipMutationVariables = Exact<{
  input: PayslipInput;
}>;


export type UpdatePayslipMutation = { updatePayslip?: { id?: number | null } | null };

export type DeletePayslipMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeletePayslipMutation = { deletePayslip?: { id?: string | null, affectedRows?: number | null } | null };

export type AllPayslipsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPayslipsQuery = { allPayslips?: Array<{ id?: number | null, userId?: string | null, status?: number | null, completedDate?: any | null } | null> | null };

export type ManagePayslipQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ManagePayslipQuery = { payslip?: { id?: number | null, comment?: string | null, userId?: string | null, status?: number | null, completedDate?: any | null, snapshot?: any | null, expenses?: Array<{ id?: number | null, type?: string | null, userId?: string | null, rate?: number | null, sourcePrice?: number | null, referralPrice?: number | null, tax?: number | null, finalPrice?: number | null, fillPrice?: number | null, registrationDate?: any | null, contractId?: string | null, comment?: string | null, user?: { id: string, name?: string | null } | null } | null> | null, user?: { departmentId?: string | null, name?: string | null, department?: { name?: string | null } | null } | null, period?: { from?: any | null, to?: any | null } | null } | null };

export type ManagePayslipsQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
  query?: InputMaybe<PayslipSearchInput>;
}>;


export type ManagePayslipsQuery = { payslips?: { totalCount?: number | null, nodes?: Array<{ id?: number | null, comment?: string | null, userId?: string | null, status?: number | null, completedDate?: any | null, user?: { name?: string | null, department?: { name?: string | null } | null } | null, period?: { from?: any | null, to?: any | null } | null } | null> | null, pageInfo?: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, currentPageIndex?: number | null, totalPageCount?: number | null } | null } | null };

export type ManageFullPayslipsQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
  query?: InputMaybe<PayslipSearchInput>;
}>;


export type ManageFullPayslipsQuery = { payslips?: { totalCount?: number | null, nodes?: Array<{ id?: number | null, comment?: string | null, userId?: string | null, status?: number | null, completedDate?: any | null, snapshot?: any | null, expenses?: Array<{ id?: number | null, type?: string | null, userId?: string | null, rate?: number | null, sourcePrice?: number | null, referralPrice?: number | null, tax?: number | null, finalPrice?: number | null, fillPrice?: number | null, registrationDate?: any | null, contractId?: string | null, comment?: string | null, user?: { id: string, name?: string | null } | null } | null> | null, user?: { departmentId?: string | null, name?: string | null, department?: { name?: string | null } | null } | null, period?: { from?: any | null, to?: any | null } | null } | null> | null, pageInfo?: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, currentPageIndex?: number | null, totalPageCount?: number | null } | null } | null };

export type PropertyContractFieldFragment = { id?: number | null, version?: number | null, parentId?: number | null, departmentId?: string | null, hasTax?: boolean | null, type?: number | null, customerType?: number | null, status?: number | null, completedDate?: any | null, signDate?: any | null, propertySnapshot?: any | null, propertyId?: number | null, price?: number | null, commission?: number | null, rentType?: number | null, documented?: boolean | null, uploaded?: boolean | null, uploadedInfo?: any | null, powerOfAttorney?: string | null, diplomaticMediation?: string | null, dealContractId?: string | null, dealContract?: string | null, developers?: Array<{ id: string, name?: string | null } | null> | null, sellers?: Array<{ id: string, name?: string | null } | null> | null, tenants?: Array<{ id: string, name?: string | null } | null> | null, landlord?: { id: string, name?: string | null } | null, landlords?: Array<{ id: string, name?: string | null } | null> | null, tenantsInfo?: Array<{ uid?: string | null, name?: string | null, phoneNumber?: string | null, agent?: string | null, agentPhoneNumber?: string | null, email?: string | null, commission?: { price?: number | null, way?: number | null, date?: any | null, comment?: string | null } | null, invoice?: { type?: number | null, number?: string | null, uniformNumber?: string | null, comment?: string | null, address?: string | null, price?: number | null } | null, emergencyContact?: { name?: string | null, phoneNumber?: string | null, relationship?: string | null } | null } | null> | null, landlordsInfo?: Array<{ uid?: string | null, name?: string | null, phoneNumber?: string | null, agent?: string | null, agentPhoneNumber?: string | null, email?: string | null, commission?: { price?: number | null, way?: number | null, date?: any | null, comment?: string | null } | null, invoice?: { type?: number | null, number?: string | null, uniformNumber?: string | null, comment?: string | null, address?: string | null, price?: number | null } | null, emergencyContact?: { name?: string | null, phoneNumber?: string | null, relationship?: string | null } | null } | null> | null, period?: { from?: any | null, to?: any | null } | null, companySign?: { date?: any | null, price?: number | null } | null, secretarySign?: { date?: any | null, price?: number | null } | null, referral?: { price?: number | null, rate?: number | null, owner?: string | null, name?: string | null, phoneNumber?: string | null, sign?: boolean | null, date?: any | null } | null, priceCovers?: Array<{ id?: number | null, name?: string | null } | null> | null, info?: { discountReason?: string | null, orderAttachment?: string | null, a?: { uid?: string | null, name?: string | null, phoneNumber?: string | null, agent?: string | null, agentPhoneNumber?: string | null, email?: string | null, commission?: { price?: number | null, way?: number | null, date?: any | null, comment?: string | null } | null, invoice?: { type?: number | null, number?: string | null, uniformNumber?: string | null, comment?: string | null, address?: string | null, price?: number | null } | null, emergencyContact?: { name?: string | null, phoneNumber?: string | null, relationship?: string | null } | null } | null, b?: { uid?: string | null, name?: string | null, phoneNumber?: string | null, agent?: string | null, agentPhoneNumber?: string | null, email?: string | null, commission?: { price?: number | null, way?: number | null, date?: any | null, comment?: string | null } | null, invoice?: { type?: number | null, number?: string | null, uniformNumber?: string | null, comment?: string | null, address?: string | null, price?: number | null } | null, emergencyContact?: { name?: string | null, phoneNumber?: string | null, relationship?: string | null } | null } | null } | null, expenses?: Array<{ id?: number | null, type?: string | null, userId?: string | null, rate?: number | null, sourcePrice?: number | null, referralPrice?: number | null, tax?: number | null, finalPrice?: number | null, fillPrice?: number | null, registrationDate?: any | null, contractId?: string | null, comment?: string | null, user?: { id: string, name?: string | null } | null } | null> | null, realPrice?: { registrationNumber?: string | null, completedDate?: any | null, hostRegistrationNumber?: string | null, hostCompletedDate?: any | null, completedSigner?: boolean | null } | null, photos?: Array<{ id?: string | null, subject?: string | null, body?: string | null, fileId?: string | null, file?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null> | null, signatures?: { secretary?: { signature?: string | null, date?: any | null } | null, supervisor?: { signature?: string | null, date?: any | null } | null } | null };

export type ContractInfoFieldFragment = { uid?: string | null, name?: string | null, phoneNumber?: string | null, agent?: string | null, agentPhoneNumber?: string | null, email?: string | null, commission?: { price?: number | null, way?: number | null, date?: any | null, comment?: string | null } | null, invoice?: { type?: number | null, number?: string | null, uniformNumber?: string | null, comment?: string | null, address?: string | null, price?: number | null } | null, emergencyContact?: { name?: string | null, phoneNumber?: string | null, relationship?: string | null } | null };

export type SignatureItemFieldFragment = { signature?: string | null, date?: any | null };

export type CreatePropertyContractMutationVariables = Exact<{
  input: PropertyContractInput;
}>;


export type CreatePropertyContractMutation = { createPropertyContract?: { id?: number | null } | null };

export type UpdatePropertyContractMutationVariables = Exact<{
  input: PropertyContractInput;
}>;


export type UpdatePropertyContractMutation = { updatePropertyContract?: { id?: number | null } | null };

export type DeletePropertyContractMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeletePropertyContractMutation = { deletePropertyContract?: { id?: string | null, affectedRows?: number | null } | null };

export type ManagePropertyContractQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ManagePropertyContractQuery = { propertyContract?: { id?: number | null, version?: number | null, parentId?: number | null, departmentId?: string | null, hasTax?: boolean | null, type?: number | null, customerType?: number | null, status?: number | null, completedDate?: any | null, signDate?: any | null, propertySnapshot?: any | null, propertyId?: number | null, price?: number | null, commission?: number | null, rentType?: number | null, documented?: boolean | null, uploaded?: boolean | null, uploadedInfo?: any | null, powerOfAttorney?: string | null, diplomaticMediation?: string | null, dealContractId?: string | null, dealContract?: string | null, developers?: Array<{ id: string, name?: string | null } | null> | null, sellers?: Array<{ id: string, name?: string | null } | null> | null, tenants?: Array<{ id: string, name?: string | null } | null> | null, landlord?: { id: string, name?: string | null } | null, landlords?: Array<{ id: string, name?: string | null } | null> | null, tenantsInfo?: Array<{ uid?: string | null, name?: string | null, phoneNumber?: string | null, agent?: string | null, agentPhoneNumber?: string | null, email?: string | null, commission?: { price?: number | null, way?: number | null, date?: any | null, comment?: string | null } | null, invoice?: { type?: number | null, number?: string | null, uniformNumber?: string | null, comment?: string | null, address?: string | null, price?: number | null } | null, emergencyContact?: { name?: string | null, phoneNumber?: string | null, relationship?: string | null } | null } | null> | null, landlordsInfo?: Array<{ uid?: string | null, name?: string | null, phoneNumber?: string | null, agent?: string | null, agentPhoneNumber?: string | null, email?: string | null, commission?: { price?: number | null, way?: number | null, date?: any | null, comment?: string | null } | null, invoice?: { type?: number | null, number?: string | null, uniformNumber?: string | null, comment?: string | null, address?: string | null, price?: number | null } | null, emergencyContact?: { name?: string | null, phoneNumber?: string | null, relationship?: string | null } | null } | null> | null, period?: { from?: any | null, to?: any | null } | null, companySign?: { date?: any | null, price?: number | null } | null, secretarySign?: { date?: any | null, price?: number | null } | null, referral?: { price?: number | null, rate?: number | null, owner?: string | null, name?: string | null, phoneNumber?: string | null, sign?: boolean | null, date?: any | null } | null, priceCovers?: Array<{ id?: number | null, name?: string | null } | null> | null, info?: { discountReason?: string | null, orderAttachment?: string | null, a?: { uid?: string | null, name?: string | null, phoneNumber?: string | null, agent?: string | null, agentPhoneNumber?: string | null, email?: string | null, commission?: { price?: number | null, way?: number | null, date?: any | null, comment?: string | null } | null, invoice?: { type?: number | null, number?: string | null, uniformNumber?: string | null, comment?: string | null, address?: string | null, price?: number | null } | null, emergencyContact?: { name?: string | null, phoneNumber?: string | null, relationship?: string | null } | null } | null, b?: { uid?: string | null, name?: string | null, phoneNumber?: string | null, agent?: string | null, agentPhoneNumber?: string | null, email?: string | null, commission?: { price?: number | null, way?: number | null, date?: any | null, comment?: string | null } | null, invoice?: { type?: number | null, number?: string | null, uniformNumber?: string | null, comment?: string | null, address?: string | null, price?: number | null } | null, emergencyContact?: { name?: string | null, phoneNumber?: string | null, relationship?: string | null } | null } | null } | null, expenses?: Array<{ id?: number | null, type?: string | null, userId?: string | null, rate?: number | null, sourcePrice?: number | null, referralPrice?: number | null, tax?: number | null, finalPrice?: number | null, fillPrice?: number | null, registrationDate?: any | null, contractId?: string | null, comment?: string | null, user?: { id: string, name?: string | null } | null } | null> | null, realPrice?: { registrationNumber?: string | null, completedDate?: any | null, hostRegistrationNumber?: string | null, hostCompletedDate?: any | null, completedSigner?: boolean | null } | null, photos?: Array<{ id?: string | null, subject?: string | null, body?: string | null, fileId?: string | null, file?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null> | null, signatures?: { secretary?: { signature?: string | null, date?: any | null } | null, supervisor?: { signature?: string | null, date?: any | null } | null } | null } | null };

export type ManagePropertyContractsQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
  query?: InputMaybe<PropertyContractSearchInput>;
}>;


export type ManagePropertyContractsQuery = { propertyContracts?: { totalCount?: number | null, nodes?: Array<{ id?: number | null, type?: number | null, status?: number | null, signDate?: any | null, propertySnapshot?: any | null, department?: { name?: string | null } | null, basicInfo?: { creator?: { id: string, name?: string | null } | null } | null, developers?: Array<{ name?: string | null } | null> | null, sellers?: Array<{ name?: string | null } | null> | null, period?: { from?: any | null, to?: any | null } | null } | null> | null, pageInfo?: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, currentPageIndex?: number | null, totalPageCount?: number | null } | null } | null };

export type ManageFullPropertyContractsQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
  query?: InputMaybe<PropertyContractSearchInput>;
}>;


export type ManageFullPropertyContractsQuery = { propertyContracts?: { totalCount?: number | null, nodes?: Array<{ id?: number | null, version?: number | null, parentId?: number | null, departmentId?: string | null, hasTax?: boolean | null, type?: number | null, customerType?: number | null, status?: number | null, completedDate?: any | null, signDate?: any | null, propertySnapshot?: any | null, propertyId?: number | null, price?: number | null, commission?: number | null, rentType?: number | null, documented?: boolean | null, uploaded?: boolean | null, uploadedInfo?: any | null, powerOfAttorney?: string | null, diplomaticMediation?: string | null, dealContractId?: string | null, dealContract?: string | null, developers?: Array<{ id: string, name?: string | null } | null> | null, sellers?: Array<{ id: string, name?: string | null } | null> | null, tenants?: Array<{ id: string, name?: string | null } | null> | null, landlord?: { id: string, name?: string | null } | null, landlords?: Array<{ id: string, name?: string | null } | null> | null, tenantsInfo?: Array<{ uid?: string | null, name?: string | null, phoneNumber?: string | null, agent?: string | null, agentPhoneNumber?: string | null, email?: string | null, commission?: { price?: number | null, way?: number | null, date?: any | null, comment?: string | null } | null, invoice?: { type?: number | null, number?: string | null, uniformNumber?: string | null, comment?: string | null, address?: string | null, price?: number | null } | null, emergencyContact?: { name?: string | null, phoneNumber?: string | null, relationship?: string | null } | null } | null> | null, landlordsInfo?: Array<{ uid?: string | null, name?: string | null, phoneNumber?: string | null, agent?: string | null, agentPhoneNumber?: string | null, email?: string | null, commission?: { price?: number | null, way?: number | null, date?: any | null, comment?: string | null } | null, invoice?: { type?: number | null, number?: string | null, uniformNumber?: string | null, comment?: string | null, address?: string | null, price?: number | null } | null, emergencyContact?: { name?: string | null, phoneNumber?: string | null, relationship?: string | null } | null } | null> | null, period?: { from?: any | null, to?: any | null } | null, companySign?: { date?: any | null, price?: number | null } | null, secretarySign?: { date?: any | null, price?: number | null } | null, referral?: { price?: number | null, rate?: number | null, owner?: string | null, name?: string | null, phoneNumber?: string | null, sign?: boolean | null, date?: any | null } | null, priceCovers?: Array<{ id?: number | null, name?: string | null } | null> | null, info?: { discountReason?: string | null, orderAttachment?: string | null, a?: { uid?: string | null, name?: string | null, phoneNumber?: string | null, agent?: string | null, agentPhoneNumber?: string | null, email?: string | null, commission?: { price?: number | null, way?: number | null, date?: any | null, comment?: string | null } | null, invoice?: { type?: number | null, number?: string | null, uniformNumber?: string | null, comment?: string | null, address?: string | null, price?: number | null } | null, emergencyContact?: { name?: string | null, phoneNumber?: string | null, relationship?: string | null } | null } | null, b?: { uid?: string | null, name?: string | null, phoneNumber?: string | null, agent?: string | null, agentPhoneNumber?: string | null, email?: string | null, commission?: { price?: number | null, way?: number | null, date?: any | null, comment?: string | null } | null, invoice?: { type?: number | null, number?: string | null, uniformNumber?: string | null, comment?: string | null, address?: string | null, price?: number | null } | null, emergencyContact?: { name?: string | null, phoneNumber?: string | null, relationship?: string | null } | null } | null } | null, expenses?: Array<{ id?: number | null, type?: string | null, userId?: string | null, rate?: number | null, sourcePrice?: number | null, referralPrice?: number | null, tax?: number | null, finalPrice?: number | null, fillPrice?: number | null, registrationDate?: any | null, contractId?: string | null, comment?: string | null, user?: { id: string, name?: string | null } | null } | null> | null, realPrice?: { registrationNumber?: string | null, completedDate?: any | null, hostRegistrationNumber?: string | null, hostCompletedDate?: any | null, completedSigner?: boolean | null } | null, photos?: Array<{ id?: string | null, subject?: string | null, body?: string | null, fileId?: string | null, file?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null> | null, signatures?: { secretary?: { signature?: string | null, date?: any | null } | null, supervisor?: { signature?: string | null, date?: any | null } | null } | null } | null> | null, pageInfo?: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, currentPageIndex?: number | null, totalPageCount?: number | null } | null } | null };

export type CreatePropertyReviewMutationVariables = Exact<{
  input: PropertyReviewInput;
}>;


export type CreatePropertyReviewMutation = { createPropertyReview?: { id?: number | null } | null };

export type UpdatePropertyReviewMutationVariables = Exact<{
  input: PropertyReviewInput;
}>;


export type UpdatePropertyReviewMutation = { updatePropertyReview?: { id?: number | null } | null };

export type DeletePropertyReviewMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeletePropertyReviewMutation = { deletePropertyReview?: { id?: string | null, affectedRows?: number | null } | null };

export type AllPropertyReviewsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPropertyReviewsQuery = { allPropertyReviews?: Array<{ id?: number | null, departmentId?: string | null, propertyId?: number | null, status?: string | null, reviewerId?: string | null } | null> | null };

export type ManagePropertyReviewQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ManagePropertyReviewQuery = { propertyReview?: { id?: number | null, departmentId?: string | null, propertyId?: number | null, data?: string | null, status?: string | null, reviewerId?: string | null } | null };

export type ManagePropertyReviewsQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
  query?: InputMaybe<PropertyReviewSearchInput>;
}>;


export type ManagePropertyReviewsQuery = { propertyReviews?: { totalCount?: number | null, nodes?: Array<{ id?: number | null, data?: string | null, status?: string | null, reviewerId?: string | null, department?: { id?: string | null, name?: string | null } | null, property?: { id?: number | null, name?: string | null } | null, reviewer?: { id: string, name?: string | null } | null, info?: { createdAt?: any | null, updatedAt?: any | null, creator?: { id: string, name?: string | null } | null } | null } | null> | null, pageInfo?: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, currentPageIndex?: number | null, totalPageCount?: number | null } | null } | null };

export type ImportPropertyMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type ImportPropertyMutation = { importProperty?: { id?: string | null, affectedRows?: number | null } | null };

export type CreatePropertyMutationVariables = Exact<{
  input: PropertyInput;
}>;


export type CreatePropertyMutation = { createProperty?: { id?: number | null } | null };

export type UpdatePropertyMutationVariables = Exact<{
  input: PropertyInput;
  enable?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdatePropertyMutation = { updateProperty?: { id?: number | null } | null };

export type DeletePropertyMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeletePropertyMutation = { deleteProperty?: { id?: string | null, affectedRows?: number | null } | null };

export type ReLaunchPropertyMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ReLaunchPropertyMutation = { reLaunchProperty?: { id?: number | null } | null };

export type PropertyQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type PropertyQuery = { property?: { id?: number | null, mrt?: string | null, communityId?: number | null, name?: string | null, buildingName?: string | null, body?: string | null, sellerId?: string | null, departmentId?: string | null, isNew?: boolean | null, featured?: boolean | null, headline?: boolean | null, rentPrice?: number | null, sellPrice?: number | null, spaceNumber?: number | null, mainSpaceNumber?: number | null, elevatorsNumber?: number | null, floorNumber?: string | null, otherData?: string | null, publicRatio?: number | null, completeDate?: any | null, categoryId?: string | null, faceId?: string | null, cityId?: number | null, districtId?: number | null, address?: string | null, fullAddress?: string | null, keyBelong?: string | null, threeDImage?: string | null, type?: number | null, kindId?: number | null, shapeId?: number | null, launchedDate?: any | null, startDate?: any | null, expiredDate?: any | null, enable?: boolean | null, state?: number | null, managementFee?: number | null, managementFeePerUnit?: number | null, referralFee?: number | null, publicUtilitiesComment?: string | null, ownerId?: string | null, builderName?: string | null, businessRegistration?: boolean | null, doorNumber?: number | null, totalDoorNumber?: number | null, includeTax?: boolean | null, internalStates?: number | null, keyBelongType?: number | null, landSpaceNumber?: number | null, mainStructure?: number | null, managementPhoneNumber?: string | null, on591Id?: string | null, securityGuard?: number | null, sourceContractType?: number | null, specialComment?: string | null, takeViewComment?: string | null, takeViewPrice?: number | null, takeViewSpecialTime?: string | null, taxPercentage?: number | null, community?: { id?: number | null, name?: string | null } | null, transportationFacilities?: Array<{ id?: string | null, name?: string | null } | null> | null, educationSchools?: Array<{ id?: number | null, name?: string | null } | null> | null, seller?: { id: string, name?: string | null } | null, developers?: Array<{ id: string, name?: string | null } | null> | null, totalFloorNumber?: { up?: number | null, down?: number | null } | null, otherData2?: { orderAttachment?: string | null, attachFloor?: number | null, deposit?: number | null, shortest?: number | null, cook?: boolean | null, pet?: boolean | null, education?: string | null, style?: string | null, smoke?: boolean | null, registered?: boolean | null, god?: boolean | null, fax?: boolean | null, notarization?: boolean | null, petComment?: string | null, smokeComment?: string | null, features?: Array<{ id?: number | null, description?: string | null } | null> | null, identities?: Array<{ id?: number | null, name?: string | null, checked?: boolean | null, initChecked?: boolean | null } | null> | null, publicUtilities?: Array<{ id?: number | null, floorNumber?: string | null } | null> | null, basePrice?: { price?: number | null, show?: boolean | null, orderAttachment?: string | null, rentAttachments?: Array<{ id?: number | null, name?: string | null } | null> | null } | null } | null, geopoint?: { latitude?: number | null, longitude?: number | null } | null, photos?: Array<{ id: string, subject?: string | null, body?: string | null, type?: string | null, sort?: number | null, file?: { id: string, targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null> | null, parkings?: Array<{ id?: number | null, amount?: number | null, type?: number | null } | null> | null, patterns?: Array<{ id?: number | null, amount?: number | null, type?: number | null } | null> | null, devices?: Array<{ id?: number | null, name?: string | null } | null> | null, furnitures?: Array<{ id?: number | null, name?: string | null } | null> | null, publicUtilities?: Array<{ id?: number | null, name?: string | null } | null> | null, lifeFunctions?: Array<{ id?: number | null, name?: string | null } | null> | null, styles?: Array<{ id?: number | null, name?: string | null } | null> | null, supportSetups?: Array<{ id?: number | null, name?: string | null } | null> | null, patternFeatures?: Array<{ id?: number | null, name?: string | null } | null> | null, rent_attachments?: Array<{ id?: number | null, name?: string | null } | null> | null, usages?: Array<{ id?: number | null, name?: string | null } | null> | null, owner?: { name?: string | null } | null, agent?: { name?: string | null, phoneNumber?: string | null, idNumber?: string | null } | null, contracts?: Array<{ id?: number | null } | null> | null, motorcycleParkingInfo?: { parkNumber?: string | null, type?: number | null, comment?: string | null } | null, otherSpaceNumber?: { underground?: number | null, arcade?: number | null, attached?: number | null, publicUtilities?: number | null, independentParking?: number | null, floors?: Array<{ name?: string | null, spaceNumber?: number | null } | null> | null } | null, parkingGarageInfo?: { type?: number | null, parkNumber?: Array<{ value?: string | null } | null> | null } | null, parkingLotInfo?: { type?: number | null } | null } | null };

export type ManagePropertiesQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
  query?: InputMaybe<PropertySearchInput>;
  orderBy?: InputMaybe<Scalars['String']>;
}>;


export type ManagePropertiesQuery = { properties?: { totalCount?: number | null, nodes?: Array<{ id?: number | null, name?: string | null, type?: number | null, headline?: boolean | null, featured?: boolean | null, price?: string | null, fullAddress?: string | null, address?: string | null, age?: string | null, launched?: boolean | null, state?: number | null, department?: { name?: string | null } | null, photo?: { file?: { targetPath?: string | null } | null } | null, geopoint?: { latitude?: number | null, longitude?: number | null } | null, category?: { name?: string | null } | null, seller?: { name?: string | null } | null, contracts?: Array<{ id?: number | null, status?: number | null, type?: number | null } | null> | null } | null> | null, pageInfo?: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, currentPageIndex?: number | null, totalPageCount?: number | null } | null } | null };

export type CreatePropertyCategoryMutationVariables = Exact<{
  input: PropertyCategoryInput;
}>;


export type CreatePropertyCategoryMutation = { createPropertyCategory?: { id?: string | null } | null };

export type UpdatePropertyCategoryMutationVariables = Exact<{
  input: PropertyCategoryInput;
}>;


export type UpdatePropertyCategoryMutation = { updatePropertyCategory?: { id?: string | null } | null };

export type DeletePropertyCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeletePropertyCategoryMutation = { deletePropertyCategory?: { id?: string | null, affectedRows?: number | null } | null };

export type AllPropertyCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPropertyCategoriesQuery = { allPropertyCategories?: Array<{ id?: string | null, name?: string | null } | null> | null };

export type PropertyCategoryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PropertyCategoryQuery = { propertyCategory?: { id?: string | null, name?: string | null } | null };

export type PropertyCategoriesQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
}>;


export type PropertyCategoriesQuery = { propertyCategories?: { totalCount?: number | null, nodes?: Array<{ id?: string | null, name?: string | null } | null> | null, pageInfo?: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, currentPageIndex?: number | null, totalPageCount?: number | null } | null } | null };

export type DeletePropertyOrderMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeletePropertyOrderMutation = { deletePropertyOrder?: { id?: string | null, affectedRows?: number | null } | null };

export type PropertyOrderQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type PropertyOrderQuery = { propertyOrder?: { id: number, sellerId?: string | null, ownerId?: string | null, fullAddress?: string | null, rentPrice?: number | null, sellPrice?: number | null, managementFee?: number | null, floorNumber?: number | null, comment?: string | null, orderPeriod?: number | null, otherData?: string | null, totalFloorNumber?: { up?: number | null, down?: number | null } | null, agent?: { name?: string | null, phoneNumber?: string | null, idNumber?: string | null } | null, owner?: { name?: string | null, account?: string | null, profile?: { idNumber?: string | null, phoneNumber?: string | null, homeNumber?: string | null, fullAddress?: string | null, email?: string | null } | null } | null, seller?: { name?: string | null } | null, parkings?: Array<{ amount?: number | null, type?: number | null } | null> | null, patterns?: Array<{ amount?: number | null, type?: number | null } | null> | null, rent_attachments?: Array<{ name?: string | null } | null> | null, usages?: Array<{ name?: string | null } | null> | null, info?: { createdAt?: any | null } | null } | null };

export type PropertyOrdersQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
  query?: InputMaybe<PropertyOrderSearchInput>;
}>;


export type PropertyOrdersQuery = { propertyOrders?: { totalCount?: number | null, nodes?: Array<{ id: number, fullAddress?: string | null, address?: string | null, seller?: { name?: string | null, department?: { name?: string | null } | null } | null, owner?: { name?: string | null } | null, info?: { createdAt?: any | null } | null } | null> | null, pageInfo?: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, currentPageIndex?: number | null, totalPageCount?: number | null } | null } | null };

export type CreateRoleMutationVariables = Exact<{
  input: RoleInput;
}>;


export type CreateRoleMutation = { createRole?: { id?: string | null } | null };

export type UpdateRoleMutationVariables = Exact<{
  input: RoleInput;
}>;


export type UpdateRoleMutation = { updateRole?: { id?: string | null } | null };

export type DeleteRoleMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteRoleMutation = { deleteRole?: { id?: string | null, affectedRows?: number | null } | null };

export type ManageAllRolesQueryVariables = Exact<{
  department: Scalars['String'];
}>;


export type ManageAllRolesQuery = { allRoles?: Array<{ id?: string | null, name?: string | null, level?: number | null } | null> | null };

export type ManageRoleQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ManageRoleQuery = { role?: { id?: string | null, name?: string | null, enable?: boolean | null, level?: number | null, departmentId?: string | null } | null };

export type ManageRolesQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
}>;


export type ManageRolesQuery = { roles?: { totalCount?: number | null, nodes?: Array<{ id?: string | null, name?: string | null, enable?: boolean | null, level?: number | null, departmentId?: string | null } | null> | null, pageInfo?: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, currentPageIndex?: number | null, totalPageCount?: number | null } | null } | null };

export type ManageSystemQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ManageSystemQuery = { system?: { id?: string | null, type?: string | null, data?: string | null, dataJSON?: any | null } | null };

export type UpdateSystemMutationVariables = Exact<{
  input: SystemInput;
}>;


export type UpdateSystemMutation = { updateSystem?: { id?: string | null } | null };

export type UserProfileFieldsFragment = { email?: string | null, gender?: boolean | null, idNumber?: string | null, description?: string | null, phoneNumber?: string | null, homeNumber?: string | null, cityId?: number | null, districtId?: number | null, address?: string | null, position?: string | null, birthday?: any | null, emergencyContact?: { name?: string | null, phoneNumber?: string | null, relationship?: string | null } | null };

export type CreateUserMutationVariables = Exact<{
  input: UserInput;
}>;


export type CreateUserMutation = { createUser?: { id: string, name?: string | null } | null };

export type UpdateUserMutationVariables = Exact<{
  input: UserInput;
}>;


export type UpdateUserMutation = { updateUser?: { id: string, name?: string | null } | null };

export type SortUserMutationVariables = Exact<{
  input: Array<UserInput> | UserInput;
}>;


export type SortUserMutation = { sortUser?: { affectedRows?: number | null } | null };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteUserMutation = { deleteUser?: { id?: string | null, affectedRows?: number | null } | null };

export type TransferUserMutationVariables = Exact<{
  from: Scalars['ID'];
  to: Scalars['ID'];
  type: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  propertyIds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  expenseIds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type TransferUserMutation = { transferUser?: { id?: string | null } | null };

export type AllUserQueryVariables = Exact<{ [key: string]: never; }>;


export type AllUserQuery = { allUsers?: Array<{ id: string, account?: string | null, name?: string | null, roleId?: string | null, departmentId?: string | null, cover?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null> | null };

export type GetUserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetUserQuery = { user?: { id: string, account?: string | null, sort?: number | null, firstName?: string | null, lastName?: string | null, roleId?: string | null, departmentId?: string | null, info?: { creatorId?: string | null, creator?: { name?: string | null } | null } | null, cover?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null, profile?: { email?: string | null, gender?: boolean | null, idNumber?: string | null, description?: string | null, phoneNumber?: string | null, homeNumber?: string | null, cityId?: number | null, districtId?: number | null, address?: string | null, position?: string | null, birthday?: any | null, emergencyContact?: { name?: string | null, phoneNumber?: string | null, relationship?: string | null } | null } | null, socials?: Array<{ id?: string | null, type?: string | null, customId?: string | null, path?: string | null, imgId?: string | null, img?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null> | null, photos?: Array<{ id?: string | null, subject?: string | null, body?: string | null, file?: { id: string, targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null> | null } | null };

export type GetUserPageQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
  query?: InputMaybe<UserSearchInput>;
  search?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetUserPageQuery = { users?: { totalCount?: number | null, nodes?: Array<{ id: string, account?: string | null, name?: string | null, roleId?: string | null, sort?: number | null, role?: { name?: string | null } | null, department?: { name?: string | null } | null } | null> | null, pageInfo?: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, currentPageIndex?: number | null, totalPageCount?: number | null } | null } | null };

export type CheckUserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CheckUserQuery = { user?: { id: string, account?: string | null, properties?: { all?: Array<{ id?: number | null } | null> | null } | null } | null };

export type GetClientUserPageQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
  query?: InputMaybe<UserSearchInput>;
  search?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetClientUserPageQuery = { users?: { totalCount?: number | null, nodes?: Array<{ id: string, account?: string | null, name?: string | null, roleId?: string | null, sort?: number | null, role?: { name?: string | null } | null, department?: { name?: string | null } | null, profile?: { phoneNumber?: string | null } | null, ownerProperties?: Array<{ id?: number | null } | null> | null, landlordPropertyContracts?: Array<{ id?: number | null } | null> | null, tenantPropertyContracts?: Array<{ id?: number | null } | null> | null, info?: { creatorId?: string | null, creator?: { name?: string | null } | null } | null } | null> | null, pageInfo?: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, currentPageIndex?: number | null, totalPageCount?: number | null } | null } | null };

export type CityFieldFragment = { city?: { name?: string | null } | null, district?: { name?: string | null } | null };

export type FileInfoFragment = { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null };

export type GeoPointFieldFragment = { geopoint?: { longitude?: number | null, latitude?: number | null } | null };

export type InfoFieldsFragment = { updatedAt?: any | null, createdAt?: any | null, creator?: { id: string, name?: string | null } | null, updater?: { name?: string | null, cover?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null };

export type PropertyFieldFragment = { id?: number | null, name?: string | null, type?: number | null, featured?: boolean | null, isNew?: boolean | null, price?: string | null, age?: string | null, state?: number | null, body_short?: string | null, spaceNumber?: number | null, mainSpaceNumber?: number | null, photo?: { file?: { targetPath?: string | null, watermark?: boolean | null, path?: { default?: string | null, sd?: string | null, mq?: string | null, hq?: string | null, maxresde?: string | null } | null } | null } | null, patterns?: Array<{ amount?: number | null, type?: number | null } | null> | null, category?: { id?: string | null, name?: string | null } | null, city?: { name?: string | null } | null, district?: { name?: string | null } | null };

export type UserFieldFragment = { id: string, account?: string | null, profile?: { idNumber?: string | null, email?: string | null, phoneNumber?: string | null, homeNumber?: string | null, address?: string | null, cityId?: number | null, position?: string | null, districtId?: number | null, birthday?: any | null, emergencyContact?: { name?: string | null, phoneNumber?: string | null, relationship?: string | null } | null, company?: { name?: string | null, phoneNumber?: string | null, taxIDNumber?: string | null } | null } | null };

export type UserFullNameFieldFragment = { firstName?: string | null, lastName?: string | null };

export type UserNameFieldFragment = { name?: string | null };

export const FileInfoFragmentDoc = gql`
    fragment FileInfo on FileDetail {
  targetPath
  path {
    default
    sd
    mq
    hq
    maxresde
  }
  watermark
}
    `;
export const BlogFieldsFragmentDoc = gql`
    fragment BlogFields on Blog {
  id
  subject
  description
  category {
    id
    name
    type
  }
  cover {
    ...FileInfo
  }
  info {
    createdAt
    updatedAt
  }
}
    ${FileInfoFragmentDoc}`;
export const CommunityFieldsFragmentDoc = gql`
    fragment CommunityFields on Community {
  id
  name
  body
  cityId
  districtId
  address
  builderName
  mainStructure
  completeDate
  doorNumber
  elevatorsNumber
  managementPhoneNumber
  securityGuard
  takeViewPrice
  takeViewComment
  takeViewSpecialTime
  publicUtilitiesComment
}
    `;
export const CompanyFieldsFragmentDoc = gql`
    fragment CompanyFields on Company {
  id
  name
  description
  category {
    id
    name
  }
  cover {
    ...FileInfo
  }
  info {
    createdAt
    updatedAt
  }
}
    ${FileInfoFragmentDoc}`;
export const InfoFieldFragmentDoc = gql`
    fragment InfoField on Department {
  info {
    logo {
      ...FileInfo
    }
    phoneNumber
    homeNumber
    fullAddress
  }
}
    ${FileInfoFragmentDoc}`;
export const NearbyFacilityFieldFragmentDoc = gql`
    fragment NearbyFacilityField on Mrt {
  id
  name
  lifeFunctionId
  url
}
    `;
export const NearByFieldFragmentDoc = gql`
    fragment NearByField on LiveArea {
  nearbyFacilities {
    massTransit {
      ...NearbyFacilityField
    }
    majorConstruction {
      ...NearbyFacilityField
    }
    departmentStore {
      ...NearbyFacilityField
    }
    medicalInformation {
      ...NearbyFacilityField
    }
    leisureFacilities {
      ...NearbyFacilityField
    }
    supermarket {
      ...NearbyFacilityField
    }
    traditionalMarket {
      ...NearbyFacilityField
    }
    shoppingDistrict {
      ...NearbyFacilityField
    }
    educationSchools {
      ...NearbyFacilityField
    }
  }
}
    ${NearbyFacilityFieldFragmentDoc}`;
export const LiveAreaFieldsFragmentDoc = gql`
    fragment LiveAreaFields on LiveArea {
  id
  name
  photo {
    file {
      ...FileInfo
    }
  }
  fullAddressShort
  ...NearByField
}
    ${FileInfoFragmentDoc}
${NearByFieldFragmentDoc}`;
export const ExpenseFieldsFragmentDoc = gql`
    fragment ExpenseFields on Expense {
  id
  user {
    id
    name
  }
  type
  userId
  rate
  sourcePrice
  referralPrice
  tax
  finalPrice
  fillPrice
  registrationDate
  contractId
  comment
}
    `;
export const PayslipFieldsFragmentDoc = gql`
    fragment PayslipFields on Payslip {
  id
  comment
  userId
  expenses {
    ...ExpenseFields
  }
  user {
    departmentId
    name
    department {
      name
    }
  }
  status
  completedDate
  period {
    from
    to
  }
  snapshot
}
    ${ExpenseFieldsFragmentDoc}`;
export const PropertyContractFieldsFragmentDoc = gql`
    fragment PropertyContractFields on PropertyContract {
  id
  type
  completedDate
  signDate
  propertyId
  price
  priceCovers {
    id
    name
  }
  commission
  documented
  uploaded
}
    `;
export const PropertyReviewFieldsFragmentDoc = gql`
    fragment PropertyReviewFields on PropertyReview {
  id
  departmentId
  propertyId
  status
  reviewerId
}
    `;
export const CityFieldFragmentDoc = gql`
    fragment CityField on Property {
  city {
    name
  }
  district {
    name
  }
}
    `;
export const PropertyFieldFragmentDoc = gql`
    fragment PropertyField on Property {
  id
  name
  type
  featured
  isNew
  price
  photo {
    file {
      ...FileInfo
    }
  }
  age
  state
  body_short
  spaceNumber
  mainSpaceNumber
  patterns {
    amount
    type
  }
  category {
    id
    name
  }
  ...CityField
}
    ${FileInfoFragmentDoc}
${CityFieldFragmentDoc}`;
export const PropertyFullFieldsFragmentDoc = gql`
    fragment PropertyFullFields on Property {
  id
  name
  isNew
  startDate
  expiredDate
  state
  classification
  nears {
    ...PropertyField
    fullAddressShort
    geopoint {
      longitude
      latitude
    }
  }
  transportationFacilities {
    id
    name
    category {
      id
      type
    }
  }
  body
  seller {
    id
    name
    cover {
      ...FileInfo
    }
    department {
      id
      name
      info {
        homeNumber
      }
    }
    profile {
      phoneNumber
      description
    }
    socials {
      type
      customId
      path
      img {
        ...FileInfo
      }
    }
  }
  featured
  price
  spaceNumber
  mainSpaceNumber
  floorNumber
  totalFloorNumber {
    up
    down
  }
  otherData
  otherData2 {
    orderAttachment
    education
    attachFloor
    deposit
    shortest
    cook
    pet
    style
    petComment
    smokeComment
    features {
      id
      description
    }
    identities {
      id
      name
      checked
      initChecked
    }
    publicUtilities {
      id
      floorNumber
    }
    basePrice {
      price
      show
      rentAttachments {
        name
      }
      orderAttachment
    }
  }
  publicRatio
  completeDate
  age
  buildingName
  devices {
    id
    name
  }
  furnitures {
    id
    name
  }
  publicUtilities {
    id
    name
  }
  lifeFunctions {
    id
    name
  }
  styles {
    name
  }
  patternFeatures {
    name
  }
  supportSetups {
    name
  }
  educationSchools {
    name
  }
  kind {
    name
  }
  shape {
    name
  }
  category {
    id
    name
  }
  face {
    name
  }
  elevatorsNumber
  fullAddressShort
  fullAddress
  geopoint {
    latitude
    longitude
  }
  keyBelong
  threeDImage
  photos {
    id
    subject
    body
    type
    file {
      ...FileInfo
    }
  }
  parkings {
    id
    amount
    type
  }
  patterns {
    amount
    type
  }
  type
  launchedDate
  enable
  managementFee
  managementFeePerUnit
  referralFee
  rent_attachments {
    id
    name
  }
  usages {
    name
  }
  builderName
  community {
    id
    name
  }
  businessRegistration
  doorNumber
  totalDoorNumber
  includeTax
  internalStates
  keyBelongType
  landSpaceNumber
  mainStructure
  managementPhoneNumber
  motorcycleParkingInfo {
    parkNumber
    type
    comment
  }
  on591Id
  otherSpaceNumber {
    underground
    arcade
    attached
    publicUtilities
    independentParking
    floors {
      name
      spaceNumber
    }
  }
  parkingGarageInfo {
    type
    parkNumber {
      value
    }
  }
  parkingLotInfo {
    type
  }
  securityGuard
  sourceContractType
  specialComment
  takeViewComment
  takeViewPrice
  takeViewSpecialTime
  taxPercentage
}
    ${PropertyFieldFragmentDoc}
${FileInfoFragmentDoc}`;
export const ContractInfoFieldFragmentDoc = gql`
    fragment ContractInfoField on ContractInfo {
  uid
  name
  phoneNumber
  agent
  agentPhoneNumber
  commission {
    price
    way
    date
    comment
  }
  invoice {
    type
    number
    uniformNumber
    comment
    address
    price
  }
  emergencyContact {
    name
    phoneNumber
    relationship
  }
  email
}
    `;
export const InfoPhotoFieldsFragmentDoc = gql`
    fragment InfoPhotoFields on InfoPhoto {
  id
  subject
  body
  fileId
}
    `;
export const SignatureItemFieldFragmentDoc = gql`
    fragment SignatureItemField on SignatureItem {
  signature
  date
}
    `;
export const PropertyContractFieldFragmentDoc = gql`
    fragment PropertyContractField on PropertyContract {
  id
  version
  parentId
  departmentId
  hasTax
  type
  customerType
  status
  developers {
    id
    name
  }
  sellers {
    id
    name
  }
  tenants {
    id
    name
  }
  landlord {
    id
    name
  }
  landlords {
    id
    name
  }
  tenantsInfo {
    ...ContractInfoField
  }
  landlordsInfo {
    ...ContractInfoField
  }
  completedDate
  signDate
  period {
    from
    to
  }
  propertySnapshot
  propertyId
  companySign {
    date
    price
  }
  secretarySign {
    date
    price
  }
  referral {
    price
    rate
    owner
    name
    phoneNumber
    sign
    date
  }
  price
  priceCovers {
    id
    name
  }
  info {
    a {
      ...ContractInfoField
    }
    b {
      ...ContractInfoField
    }
    discountReason
    orderAttachment
  }
  commission
  expenses {
    ...ExpenseFields
  }
  rentType
  realPrice {
    registrationNumber
    completedDate
    hostRegistrationNumber
    hostCompletedDate
    completedSigner
  }
  documented
  uploaded
  uploadedInfo
  photos {
    ...InfoPhotoFields
    file {
      ...FileInfo
    }
  }
  signatures {
    secretary {
      ...SignatureItemField
    }
    supervisor {
      ...SignatureItemField
    }
  }
  powerOfAttorney
  diplomaticMediation
  dealContractId
  dealContract
}
    ${ContractInfoFieldFragmentDoc}
${ExpenseFieldsFragmentDoc}
${InfoPhotoFieldsFragmentDoc}
${FileInfoFragmentDoc}
${SignatureItemFieldFragmentDoc}`;
export const UserProfileFieldsFragmentDoc = gql`
    fragment UserProfileFields on UserProfile {
  email
  gender
  idNumber
  description
  phoneNumber
  homeNumber
  cityId
  districtId
  address
  position
  birthday
  emergencyContact {
    name
    phoneNumber
    relationship
  }
}
    `;
export const GeoPointFieldFragmentDoc = gql`
    fragment GeoPointField on Mrt {
  geopoint {
    longitude
    latitude
  }
}
    `;
export const InfoFieldsFragmentDoc = gql`
    fragment InfoFields on InfoType {
  creator {
    id
    name
  }
  updater {
    name
    cover {
      ...FileInfo
    }
  }
  updatedAt
  createdAt
}
    ${FileInfoFragmentDoc}`;
export const UserFieldFragmentDoc = gql`
    fragment UserField on User {
  id
  account
  profile {
    idNumber
    email
    phoneNumber
    homeNumber
    address
    cityId
    position
    districtId
    birthday
    emergencyContact {
      name
      phoneNumber
      relationship
    }
    company {
      name
      phoneNumber
      taxIDNumber
    }
  }
}
    `;
export const UserFullNameFieldFragmentDoc = gql`
    fragment UserFullNameField on User {
  firstName
  lastName
}
    `;
export const UserNameFieldFragmentDoc = gql`
    fragment UserNameField on User {
  name
}
    `;
export const GetFullAboutDocument = gql`
    query getFullAbout {
  about {
    info {
      title
      logo {
        ...FileInfo
      }
      bannerLogo {
        ...FileInfo
      }
      description
      email
      homeNumber
      phoneNumber
      fullAddress
    }
    story
    relations {
      title
      link
      logo {
        ...FileInfo
      }
    }
  }
}
    ${FileInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFullAboutGQL extends Apollo.Query<GetFullAboutQuery, GetFullAboutQueryVariables> {
    document = GetFullAboutDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAboutCoverAndStoryQueryDocument = gql`
    query getAboutCoverAndStoryQuery {
  about {
    info {
      aboutCover {
        ...FileInfo
      }
    }
    story
  }
}
    ${FileInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAboutCoverAndStoryQueryGQL extends Apollo.Query<GetAboutCoverAndStoryQueryQuery, GetAboutCoverAndStoryQueryQueryVariables> {
    document = GetAboutCoverAndStoryQueryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDepartmentMembersDocument = gql`
    query getDepartmentMembers($id: ID!) {
  user(id: $id) {
    id
    name
    cover {
      ...FileInfo
    }
    role {
      name
    }
    department {
      id
      name
    }
    profile {
      description
      phoneNumber
      homeNumber
      fullAddress
      address
      email
    }
    socials {
      type
      customId
      path
      img {
        ...FileInfo
      }
    }
    photos {
      subject
      body
      file {
        ...FileInfo
      }
    }
    properties {
      headline {
        ...PropertyField
      }
    }
  }
}
    ${FileInfoFragmentDoc}
${PropertyFieldFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDepartmentMembersGQL extends Apollo.Query<GetDepartmentMembersQuery, GetDepartmentMembersQueryVariables> {
    document = GetDepartmentMembersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BlogDocument = gql`
    query blog($id: Int!) {
  blog(id: $id) {
    subject
    description
    body
    cover {
      ...FileInfo
    }
    category {
      id
      name
      type
    }
    info {
      creator {
        id
        name
        role {
          level
        }
        cover {
          ...FileInfo
        }
      }
      createdAt
      updater {
        name
      }
      updatedAt
    }
    related {
      ...BlogFields
    }
  }
}
    ${FileInfoFragmentDoc}
${BlogFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class BlogGQL extends Apollo.Query<BlogQuery, BlogQueryVariables> {
    document = BlogDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BlogsDocument = gql`
    query blogs($skip: Int!, $take: Int!, $query: BlogSearchInput, $orderBy: String, $reverse: Boolean) {
  blogs(
    skip: $skip
    reverse: $reverse
    take: $take
    query: $query
    orderBy: $orderBy
  ) {
    totalCount
    nodes {
      ...BlogFields
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      currentPageIndex
      totalPageCount
    }
  }
}
    ${BlogFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class BlogsGQL extends Apollo.Query<BlogsQuery, BlogsQueryVariables> {
    document = BlogsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllBlogCategoriesDocument = gql`
    query allBlogCategories {
  allBlogCategories {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllBlogCategoriesGQL extends Apollo.Query<AllBlogCategoriesQuery, AllBlogCategoriesQueryVariables> {
    document = AllBlogCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllCitiesDocument = gql`
    query allCities($onlyProperty: Boolean) {
  allCities(onlyProperty: $onlyProperty) {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllCitiesGQL extends Apollo.Query<AllCitiesQuery, AllCitiesQueryVariables> {
    document = AllCitiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CommunityDocument = gql`
    query community($id: Int!) {
  community(id: $id) {
    id
    name
    body
    photos {
      id
      subject
      body
      file {
        id
        ...FileInfo
      }
    }
    cityId
    districtId
    address
    builderName
    mainStructure
    completeDate
    doorNumber
    elevatorsNumber
    managementPhoneNumber
    securityGuard
    takeViewPrice
    takeViewComment
    takeViewSpecialTime
    publicUtilitiesComment
  }
}
    ${FileInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CommunityGQL extends Apollo.Query<CommunityQuery, CommunityQueryVariables> {
    document = CommunityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CommunitiesDocument = gql`
    query communities($skip: Int!, $take: Int!, $query: CommunitySearchInput) {
  communities(skip: $skip, take: $take, query: $query) {
    totalCount
    nodes {
      ...CommunityFields
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      currentPageIndex
      totalPageCount
    }
  }
}
    ${CommunityFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CommunitiesGQL extends Apollo.Query<CommunitiesQuery, CommunitiesQueryVariables> {
    document = CommunitiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompanyDocument = gql`
    query company($id: Int!) {
  company(id: $id) {
    name
    description
    url
    body
    location {
      fullAddress
    }
    cover {
      ...FileInfo
    }
    category {
      id
      name
    }
    info {
      creator {
        id
        role {
          level
        }
        name
        cover {
          ...FileInfo
        }
      }
      createdAt
      updater {
        name
      }
      updatedAt
    }
    related {
      ...CompanyFields
    }
  }
}
    ${FileInfoFragmentDoc}
${CompanyFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CompanyGQL extends Apollo.Query<CompanyQuery, CompanyQueryVariables> {
    document = CompanyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompaniesDocument = gql`
    query companies($skip: Int!, $take: Int!, $query: CompanySearchInput) {
  companies(skip: $skip, take: $take, query: $query) {
    totalCount
    nodes {
      ...CompanyFields
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      currentPageIndex
      totalPageCount
    }
  }
}
    ${CompanyFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CompaniesGQL extends Apollo.Query<CompaniesQuery, CompaniesQueryVariables> {
    document = CompaniesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllCompanyCategoriesDocument = gql`
    query allCompanyCategories {
  allCompanyCategories {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllCompanyCategoriesGQL extends Apollo.Query<AllCompanyCategoriesQuery, AllCompanyCategoriesQueryVariables> {
    document = AllCompanyCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDepartmentDocument = gql`
    query getDepartment($id: ID!) {
  department(id: $id) {
    id
    name
    enable
    level
    info {
      logo {
        ...FileInfo
      }
      aboutCover {
        ...FileInfo
      }
      description
      story
      email
      phoneNumber
      homeNumber
      cityId
      districtId
      fullAddress
    }
  }
}
    ${FileInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDepartmentGQL extends Apollo.Query<GetDepartmentQuery, GetDepartmentQueryVariables> {
    document = GetDepartmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllDepartmentDocument = gql`
    query getAllDepartment($root: Boolean, $withInfo: Boolean!) {
  allDepartments(root: $root) {
    id
    name
    ...InfoField @include(if: $withInfo)
  }
}
    ${InfoFieldFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllDepartmentGQL extends Apollo.Query<GetAllDepartmentQuery, GetAllDepartmentQueryVariables> {
    document = GetAllDepartmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllDistrictsDocument = gql`
    query allDistricts($city: Int!, $onlyProperty: Boolean) {
  allDistricts(city: $city, onlyProperty: $onlyProperty) {
    id
    name
    zip
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllDistrictsGQL extends Apollo.Query<AllDistrictsQuery, AllDistrictsQueryVariables> {
    document = AllDistrictsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExpenseDocument = gql`
    query expense($id: Int!) {
  expense(id: $id) {
    id
    userId
    rate
    sourcePrice
    referralPrice
    tax
    finalPrice
    fillPrice
    contractId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExpenseGQL extends Apollo.Query<ExpenseQuery, ExpenseQueryVariables> {
    document = ExpenseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExpensesDocument = gql`
    query expenses($skip: Int!, $take: Int!, $query: ExpenseSearchInput) {
  expenses(skip: $skip, take: $take, query: $query) {
    totalCount
    nodes {
      ...ExpenseFields
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      currentPageIndex
      totalPageCount
    }
  }
}
    ${ExpenseFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ExpensesGQL extends Apollo.Query<ExpensesQuery, ExpensesQueryVariables> {
    document = ExpensesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InfoPhotoDocument = gql`
    query infoPhoto($id: Int!) {
  infoPhoto(id: $id) {
    id
    subject
    body
    fileId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InfoPhotoGQL extends Apollo.Query<InfoPhotoQuery, InfoPhotoQueryVariables> {
    document = InfoPhotoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InfoPhotosDocument = gql`
    query infoPhotos($skip: Int!, $take: Int!, $query: InfoPhotoSearchInput) {
  infoPhotos(skip: $skip, take: $take, query: $query) {
    totalCount
    nodes {
      ...InfoPhotoFields
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      currentPageIndex
      totalPageCount
    }
  }
}
    ${InfoPhotoFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InfoPhotosGQL extends Apollo.Query<InfoPhotosQuery, InfoPhotosQueryVariables> {
    document = InfoPhotosDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LiveAreaDocument = gql`
    query liveArea($id: Int!) {
  liveArea(id: $id) {
    id
    name
    fullAddressShort
    ...NearByField
    communities {
      id
      name
    }
    body
    photos {
      file {
        ...FileInfo
      }
    }
  }
}
    ${NearByFieldFragmentDoc}
${FileInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LiveAreaGQL extends Apollo.Query<LiveAreaQuery, LiveAreaQueryVariables> {
    document = LiveAreaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LiveAreasDocument = gql`
    query liveAreas($skip: Int!, $take: Int!, $query: LiveAreaSearchInput) {
  liveAreas(skip: $skip, take: $take, query: $query) {
    totalCount
    nodes {
      ...LiveAreaFields
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      currentPageIndex
      totalPageCount
    }
  }
}
    ${LiveAreaFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LiveAreasGQL extends Apollo.Query<LiveAreasQuery, LiveAreasQueryVariables> {
    document = LiveAreasDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllMrtCategoriesDocument = gql`
    query allMrtCategories($onlyProperty: Boolean) {
  allMrtCategories(onlyProperty: $onlyProperty) {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllMrtCategoriesGQL extends Apollo.Query<AllMrtCategoriesQuery, AllMrtCategoriesQueryVariables> {
    document = AllMrtCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllMrtsDocument = gql`
    query allMrts($category: String, $onlyProperty: Boolean) {
  allMrts(category: $category, onlyProperty: $onlyProperty) {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllMrtsGQL extends Apollo.Query<AllMrtsQuery, AllMrtsQueryVariables> {
    document = AllMrtsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchLocationsDocument = gql`
    query searchLocations($query: MrtCategorySearchInput, $onlyProperty: Boolean) {
  mrtCategories(skip: 0, take: 999, query: $query, onlyProperty: $onlyProperty) {
    nodes {
      id
      name
      mrts {
        id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchLocationsGQL extends Apollo.Query<SearchLocationsQuery, SearchLocationsQueryVariables> {
    document = SearchLocationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllMembersDocument = gql`
    query allMembers($roleLevel: Int, $departmentId: String) {
  allUsers(roleLevel: $roleLevel, withSocials: true, departmentId: $departmentId) {
    id
    name
    cover {
      ...FileInfo
    }
    profile {
      phoneNumber
    }
    socials {
      type
      customId
      path
      img {
        ...FileInfo
      }
    }
  }
}
    ${FileInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AllMembersGQL extends Apollo.Query<AllMembersQuery, AllMembersQueryVariables> {
    document = AllMembersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllRentAttachmentsDocument = gql`
    query allRentAttachments {
  allRentAttachments {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllRentAttachmentsGQL extends Apollo.Query<AllRentAttachmentsQuery, AllRentAttachmentsQueryVariables> {
    document = AllRentAttachmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllPropertyShapesDocument = gql`
    query allPropertyShapes {
  allPropertyShapes {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllPropertyShapesGQL extends Apollo.Query<AllPropertyShapesQuery, AllPropertyShapesQueryVariables> {
    document = AllPropertyShapesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllPropertyShapesValueDocument = gql`
    query allPropertyShapesValue {
  allPropertyShapes {
    value: id
    title: name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllPropertyShapesValueGQL extends Apollo.Query<AllPropertyShapesValueQuery, AllPropertyShapesValueQueryVariables> {
    document = AllPropertyShapesValueDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllPropertyKindsDocument = gql`
    query allPropertyKinds {
  allPropertyKinds {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllPropertyKindsGQL extends Apollo.Query<AllPropertyKindsQuery, AllPropertyKindsQueryVariables> {
    document = AllPropertyKindsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllPropertyKindsValueDocument = gql`
    query allPropertyKindsValue {
  allPropertyKinds {
    value: id
    title: name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllPropertyKindsValueGQL extends Apollo.Query<AllPropertyKindsValueQuery, AllPropertyKindsValueQueryVariables> {
    document = AllPropertyKindsValueDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllPropertyUsagesDocument = gql`
    query allPropertyUsages {
  allPropertyUsages {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllPropertyUsagesGQL extends Apollo.Query<AllPropertyUsagesQuery, AllPropertyUsagesQueryVariables> {
    document = AllPropertyUsagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePropertyOrderDocument = gql`
    mutation createPropertyOrder($input: PropertyOrderInput!) {
  createPropertyOrder(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePropertyOrderGQL extends Apollo.Mutation<CreatePropertyOrderMutation, CreatePropertyOrderMutationVariables> {
    document = CreatePropertyOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllPropertyFacesDocument = gql`
    query allPropertyFaces {
  allPropertyFaces {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllPropertyFacesGQL extends Apollo.Query<AllPropertyFacesQuery, AllPropertyFacesQueryVariables> {
    document = AllPropertyFacesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllPropertyFurnituresDocument = gql`
    query allPropertyFurnitures {
  allPropertyFurnitures {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllPropertyFurnituresGQL extends Apollo.Query<AllPropertyFurnituresQuery, AllPropertyFurnituresQueryVariables> {
    document = AllPropertyFurnituresDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllPropertyPublicUtilitiesDocument = gql`
    query allPropertyPublicUtilities {
  allPropertyPublicUtilities {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllPropertyPublicUtilitiesGQL extends Apollo.Query<AllPropertyPublicUtilitiesQuery, AllPropertyPublicUtilitiesQueryVariables> {
    document = AllPropertyPublicUtilitiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllLifeFunctionsDocument = gql`
    query allLifeFunctions {
  allLifeFunctions {
    id
    name
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllLifeFunctionsGQL extends Apollo.Query<AllLifeFunctionsQuery, AllLifeFunctionsQueryVariables> {
    document = AllLifeFunctionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllPropertyDevicesDocument = gql`
    query allPropertyDevices {
  allPropertyDevices {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllPropertyDevicesGQL extends Apollo.Query<AllPropertyDevicesQuery, AllPropertyDevicesQueryVariables> {
    document = AllPropertyDevicesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPageDocument = gql`
    query getPage($id: ID!, $withBody: Boolean!) {
  page(id: $id) {
    id
    title
    cover {
      ...FileInfo
    }
    description
    breadCrumb {
      url
      title
    }
    body @include(if: $withBody)
  }
}
    ${FileInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPageGQL extends Apollo.Query<GetPageQuery, GetPageQueryVariables> {
    document = GetPageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PayslipDocument = gql`
    query payslip($id: Int!) {
  payslip(id: $id) {
    id
    userId
    status
    completedDate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PayslipGQL extends Apollo.Query<PayslipQuery, PayslipQueryVariables> {
    document = PayslipDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PayslipsDocument = gql`
    query payslips($skip: Int!, $take: Int!, $query: PayslipSearchInput) {
  payslips(skip: $skip, take: $take, query: $query) {
    totalCount
    nodes {
      ...PayslipFields
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      currentPageIndex
      totalPageCount
    }
  }
}
    ${PayslipFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PayslipsGQL extends Apollo.Query<PayslipsQuery, PayslipsQueryVariables> {
    document = PayslipsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PropertyContractDocument = gql`
    query propertyContract($id: Int!) {
  propertyContract(id: $id) {
    id
    type
    completedDate
    signDate
    propertyId
    price
    priceCovers {
      id
      name
    }
    commission
    documented
    uploaded
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PropertyContractGQL extends Apollo.Query<PropertyContractQuery, PropertyContractQueryVariables> {
    document = PropertyContractDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PropertyContractsDocument = gql`
    query propertyContracts($skip: Int!, $take: Int!, $query: PropertyContractSearchInput) {
  propertyContracts(skip: $skip, take: $take, query: $query) {
    totalCount
    nodes {
      ...PropertyContractFields
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      currentPageIndex
      totalPageCount
    }
  }
}
    ${PropertyContractFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PropertyContractsGQL extends Apollo.Query<PropertyContractsQuery, PropertyContractsQueryVariables> {
    document = PropertyContractsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PropertyReviewDocument = gql`
    query propertyReview($id: Int!) {
  propertyReview(id: $id) {
    id
    departmentId
    propertyId
    status
    reviewerId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PropertyReviewGQL extends Apollo.Query<PropertyReviewQuery, PropertyReviewQueryVariables> {
    document = PropertyReviewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PropertyReviewsDocument = gql`
    query propertyReviews($skip: Int!, $take: Int!, $query: PropertyReviewSearchInput) {
  propertyReviews(skip: $skip, take: $take, query: $query) {
    totalCount
    nodes {
      ...PropertyReviewFields
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      currentPageIndex
      totalPageCount
    }
  }
}
    ${PropertyReviewFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PropertyReviewsGQL extends Apollo.Query<PropertyReviewsQuery, PropertyReviewsQueryVariables> {
    document = PropertyReviewsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPropertyDocument = gql`
    query getProperty($id: Int!, $isManage: Boolean) {
  property(id: $id, isManage: $isManage) {
    ...PropertyFullFields
  }
}
    ${PropertyFullFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPropertyGQL extends Apollo.Query<GetPropertyQuery, GetPropertyQueryVariables> {
    document = GetPropertyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPropertyPageDocument = gql`
    query getPropertyPage($skip: Int!, $take: Int!, $orderBy: String, $reverse: Boolean, $query: PropertySearchInput) {
  properties(
    skip: $skip
    take: $take
    patterns: true
    query: $query
    orderBy: $orderBy
    reverse: $reverse
  ) {
    totalCount
    nodes {
      ...PropertyField
      fullAddressShort
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      currentPageIndex
      totalPageCount
    }
  }
}
    ${PropertyFieldFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPropertyPageGQL extends Apollo.Query<GetPropertyPageQuery, GetPropertyPageQueryVariables> {
    document = GetPropertyPageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SystemPropertyFilesDocument = gql`
    query systemPropertyFiles($id: ID!) {
  system(id: $id) {
    dataJSON
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SystemPropertyFilesGQL extends Apollo.Query<SystemPropertyFilesQuery, SystemPropertyFilesQueryVariables> {
    document = SystemPropertyFilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoginDocument = gql`
    query login($account: String!, $password: String!) {
  login(account: $account, password: $password) {
    token
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoginGQL extends Apollo.Query<LoginQuery, LoginQueryVariables> {
    document = LoginDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AuthorizationDocument = gql`
    query authorization {
  authorization {
    id
    name
    department {
      name
      id
    }
    role {
      level
      name
    }
    cover {
      ...FileInfo
    }
  }
}
    ${FileInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AuthorizationGQL extends Apollo.Query<AuthorizationQuery, AuthorizationQueryVariables> {
    document = AuthorizationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllRolesDocument = gql`
    query allRoles($department: String, $withUser: Boolean, $withProfile: Boolean) {
  allRoles(
    department: $department
    withUser: $withUser
    withProfile: $withProfile
  ) {
    name
    department {
      id
      name
    }
    users {
      id
      name
      cover {
        ...FileInfo
      }
      profile {
        phoneNumber
        description
      }
      socials {
        type
        customId
        path
        img {
          ...FileInfo
        }
      }
      properties {
        all {
          id
        }
      }
    }
  }
}
    ${FileInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AllRolesGQL extends Apollo.Query<AllRolesQuery, AllRolesQueryVariables> {
    document = AllRolesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAboutDocument = gql`
    mutation updateAbout($input: AboutInput!) {
  updateAbout(input: $input) {
    affectedRows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAboutGQL extends Apollo.Mutation<UpdateAboutMutation, UpdateAboutMutationVariables> {
    document = UpdateAboutDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AboutDocument = gql`
    query about {
  about {
    info {
      title
      logo {
        ...FileInfo
      }
      logoId
      bannerLogo {
        ...FileInfo
      }
      bannerLogoId
      watermark {
        ...FileInfo
      }
      watermarkId
      aboutCover {
        ...FileInfo
      }
      aboutCoverId
      description
      email
      homeNumber
      phoneNumber
      story
      cityId
      districtId
      city {
        name
      }
      district {
        name
      }
      address
    }
    story
    relations {
      title
      link
      logoId
      logo {
        ...FileInfo
      }
    }
  }
}
    ${FileInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AboutGQL extends Apollo.Query<AboutQuery, AboutQueryVariables> {
    document = AboutDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAnnouncementCategoryDocument = gql`
    mutation createAnnouncementCategory($input: AnnouncementCategoryInput!) {
  createAnnouncementCategory(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAnnouncementCategoryGQL extends Apollo.Mutation<CreateAnnouncementCategoryMutation, CreateAnnouncementCategoryMutationVariables> {
    document = CreateAnnouncementCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAnnouncementCategoryDocument = gql`
    mutation updateAnnouncementCategory($input: AnnouncementCategoryInput!) {
  updateAnnouncementCategory(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAnnouncementCategoryGQL extends Apollo.Mutation<UpdateAnnouncementCategoryMutation, UpdateAnnouncementCategoryMutationVariables> {
    document = UpdateAnnouncementCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteAnnouncementCategoryDocument = gql`
    mutation deleteAnnouncementCategory($id: ID!) {
  deleteAnnouncementCategory(id: $id) {
    id
    affectedRows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteAnnouncementCategoryGQL extends Apollo.Mutation<DeleteAnnouncementCategoryMutation, DeleteAnnouncementCategoryMutationVariables> {
    document = DeleteAnnouncementCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllAnnouncementCategoriesDocument = gql`
    query allAnnouncementCategories {
  allAnnouncementCategories {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllAnnouncementCategoriesGQL extends Apollo.Query<AllAnnouncementCategoriesQuery, AllAnnouncementCategoriesQueryVariables> {
    document = AllAnnouncementCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AnnouncementCategoryDocument = gql`
    query announcementCategory($id: ID!) {
  announcementCategory(id: $id) {
    id
    name
    type
    color
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AnnouncementCategoryGQL extends Apollo.Query<AnnouncementCategoryQuery, AnnouncementCategoryQueryVariables> {
    document = AnnouncementCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AnnouncementCategoriesDocument = gql`
    query announcementCategories($skip: Int!, $take: Int!, $query: AnnouncementCategorySearchInput) {
  announcementCategories(skip: $skip, take: $take, query: $query) {
    totalCount
    nodes {
      id
      name
      color
      type
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      currentPageIndex
      totalPageCount
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AnnouncementCategoriesGQL extends Apollo.Query<AnnouncementCategoriesQuery, AnnouncementCategoriesQueryVariables> {
    document = AnnouncementCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAnnouncementDocument = gql`
    mutation createAnnouncement($input: AnnouncementInput!) {
  createAnnouncement(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAnnouncementGQL extends Apollo.Mutation<CreateAnnouncementMutation, CreateAnnouncementMutationVariables> {
    document = CreateAnnouncementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAnnouncementDocument = gql`
    mutation updateAnnouncement($input: AnnouncementInput!) {
  updateAnnouncement(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAnnouncementGQL extends Apollo.Mutation<UpdateAnnouncementMutation, UpdateAnnouncementMutationVariables> {
    document = UpdateAnnouncementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteAnnouncementDocument = gql`
    mutation deleteAnnouncement($id: Int!) {
  deleteAnnouncement(id: $id) {
    id
    affectedRows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteAnnouncementGQL extends Apollo.Mutation<DeleteAnnouncementMutation, DeleteAnnouncementMutationVariables> {
    document = DeleteAnnouncementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllAnnouncementsDocument = gql`
    query allAnnouncements {
  allAnnouncements {
    id
    subject
    description
    body
    category {
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllAnnouncementsGQL extends Apollo.Query<AllAnnouncementsQuery, AllAnnouncementsQueryVariables> {
    document = AllAnnouncementsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AnnouncementDocument = gql`
    query announcement($id: Int!) {
  announcement(id: $id) {
    id
    subject
    description
    body
    categoryId
    enable
    toUsers {
      id
      name
      departmentId
    }
    toDepartments {
      id
      name
    }
    category {
      name
      color
    }
    info {
      ...InfoFields
    }
    period {
      from
      to
    }
  }
}
    ${InfoFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AnnouncementGQL extends Apollo.Query<AnnouncementQuery, AnnouncementQueryVariables> {
    document = AnnouncementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AnnouncementsDocument = gql`
    query announcements($skip: Int!, $take: Int!, $query: AnnouncementSearchInput) {
  announcements(skip: $skip, take: $take, query: $query, isManage: true) {
    totalCount
    nodes {
      id
      subject
      enable
      category {
        name
        color
        id
      }
      info {
        ...InfoFields
      }
      toUsers {
        id
        name
      }
      toDepartments {
        id
        name
      }
      period {
        from
        to
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      currentPageIndex
      totalPageCount
    }
  }
}
    ${InfoFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AnnouncementsGQL extends Apollo.Query<AnnouncementsQuery, AnnouncementsQueryVariables> {
    document = AnnouncementsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateBlogDocument = gql`
    mutation createBlog($input: BlogInput!) {
  createBlog(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateBlogGQL extends Apollo.Mutation<CreateBlogMutation, CreateBlogMutationVariables> {
    document = CreateBlogDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateBlogDocument = gql`
    mutation updateBlog($input: BlogInput!) {
  updateBlog(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateBlogGQL extends Apollo.Mutation<UpdateBlogMutation, UpdateBlogMutationVariables> {
    document = UpdateBlogDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteBlogDocument = gql`
    mutation deleteBlog($id: Int!) {
  deleteBlog(id: $id) {
    id
    affectedRows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteBlogGQL extends Apollo.Mutation<DeleteBlogMutation, DeleteBlogMutationVariables> {
    document = DeleteBlogDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllBlogsDocument = gql`
    query allBlogs {
  allBlogs {
    id
    subject
    description
    body
    category {
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllBlogsGQL extends Apollo.Query<AllBlogsQuery, AllBlogsQueryVariables> {
    document = AllBlogsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ManageBlogDocument = gql`
    query ManageBlog($id: Int!) {
  blog(id: $id) {
    id
    subject
    description
    body
    categoryId
    enable
    cover {
      ...FileInfo
    }
    info {
      ...InfoFields
      creator {
        id
        departmentId
      }
    }
    photos {
      ...InfoPhotoFields
      file {
        ...FileInfo
      }
    }
  }
}
    ${FileInfoFragmentDoc}
${InfoFieldsFragmentDoc}
${InfoPhotoFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ManageBlogGQL extends Apollo.Query<ManageBlogQuery, ManageBlogQueryVariables> {
    document = ManageBlogDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ManageBlogsDocument = gql`
    query ManageBlogs($skip: Int!, $take: Int!, $orderBy: String, $query: BlogSearchInput, $reverse: Boolean) {
  blogs(
    skip: $skip
    take: $take
    query: $query
    reverse: $reverse
    orderBy: $orderBy
    isManage: true
  ) {
    totalCount
    nodes {
      id
      subject
      description
      enable
      body
      category {
        name
      }
      info {
        ...InfoFields
      }
      sort
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      currentPageIndex
      totalPageCount
    }
  }
}
    ${InfoFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ManageBlogsGQL extends Apollo.Query<ManageBlogsQuery, ManageBlogsQueryVariables> {
    document = ManageBlogsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateBlogCategoryDocument = gql`
    mutation createBlogCategory($input: BlogCategoryInput!) {
  createBlogCategory(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateBlogCategoryGQL extends Apollo.Mutation<CreateBlogCategoryMutation, CreateBlogCategoryMutationVariables> {
    document = CreateBlogCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateBlogCategoryDocument = gql`
    mutation updateBlogCategory($input: BlogCategoryInput!) {
  updateBlogCategory(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateBlogCategoryGQL extends Apollo.Mutation<UpdateBlogCategoryMutation, UpdateBlogCategoryMutationVariables> {
    document = UpdateBlogCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteBlogCategoryDocument = gql`
    mutation deleteBlogCategory($id: ID!) {
  deleteBlogCategory(id: $id) {
    id
    affectedRows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteBlogCategoryGQL extends Apollo.Mutation<DeleteBlogCategoryMutation, DeleteBlogCategoryMutationVariables> {
    document = DeleteBlogCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ManageAllBlogCategoriesDocument = gql`
    query manageAllBlogCategories {
  allBlogCategories(isManage: true) {
    id
    name
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ManageAllBlogCategoriesGQL extends Apollo.Query<ManageAllBlogCategoriesQuery, ManageAllBlogCategoriesQueryVariables> {
    document = ManageAllBlogCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BlogCategoryDocument = gql`
    query blogCategory($id: ID!) {
  blogCategory(id: $id) {
    id
    name
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BlogCategoryGQL extends Apollo.Query<BlogCategoryQuery, BlogCategoryQueryVariables> {
    document = BlogCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BlogCategoriesDocument = gql`
    query blogCategories($skip: Int!, $take: Int!, $reverse: Boolean, $orderBy: String, $query: BlogCategorySearchInput) {
  blogCategories(
    skip: $skip
    take: $take
    reverse: $reverse
    orderBy: $orderBy
    query: $query
  ) {
    totalCount
    nodes {
      id
      name
      type
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      currentPageIndex
      totalPageCount
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BlogCategoriesGQL extends Apollo.Query<BlogCategoriesQuery, BlogCategoriesQueryVariables> {
    document = BlogCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCommunityDocument = gql`
    mutation createCommunity($input: CommunityInput!) {
  createCommunity(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCommunityGQL extends Apollo.Mutation<CreateCommunityMutation, CreateCommunityMutationVariables> {
    document = CreateCommunityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCommunityDocument = gql`
    mutation updateCommunity($input: CommunityInput!) {
  updateCommunity(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCommunityGQL extends Apollo.Mutation<UpdateCommunityMutation, UpdateCommunityMutationVariables> {
    document = UpdateCommunityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCommunityDocument = gql`
    mutation deleteCommunity($id: Int!) {
  deleteCommunity(id: $id) {
    id
    affectedRows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCommunityGQL extends Apollo.Mutation<DeleteCommunityMutation, DeleteCommunityMutationVariables> {
    document = DeleteCommunityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllCommunitiesDocument = gql`
    query allCommunities {
  allCommunities {
    id
    name
    body
    cityId
    districtId
    address
    builderName
    mainStructure
    completeDate
    doorNumber
    elevatorsNumber
    managementPhoneNumber
    securityGuard
    takeViewPrice
    takeViewComment
    takeViewSpecialTime
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllCommunitiesGQL extends Apollo.Query<AllCommunitiesQuery, AllCommunitiesQueryVariables> {
    document = AllCommunitiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ManageCommunityDocument = gql`
    query manageCommunity($id: Int!) {
  community(id: $id) {
    id
    name
    body
    photos {
      id
      subject
      body
      file {
        id
        ...FileInfo
      }
    }
    cityId
    districtId
    address
    geopoint {
      latitude
      longitude
    }
    builderName
    mainStructure
    completeDate
    totalDoorNumber
    totalFloorNumber {
      up
      down
    }
    doorNumber
    elevatorsNumber
    managementPhoneNumber
    securityGuard
    takeViewPrice
    takeViewComment
    takeViewSpecialTime
    publicUtilitiesComment
    publicUtilities {
      id
      name
    }
    lifeFunctions {
      id
      name
    }
    overrideLiveAreaId
    liveAreas {
      id
      name
    }
    transportationFacilities {
      id
      name
    }
    educationSchools {
      id
      name
    }
    otherData {
      publicUtilities {
        id
        floorNumber
      }
      education
    }
  }
}
    ${FileInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ManageCommunityGQL extends Apollo.Query<ManageCommunityQuery, ManageCommunityQueryVariables> {
    document = ManageCommunityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ManageCommunitiesDocument = gql`
    query manageCommunities($skip: Int!, $take: Int!, $query: CommunitySearchInput) {
  communities(skip: $skip, take: $take, query: $query, isManage: true) {
    totalCount
    nodes {
      id
      name
      fullAddress
      info {
        ...InfoFields
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      currentPageIndex
      totalPageCount
    }
  }
}
    ${InfoFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ManageCommunitiesGQL extends Apollo.Query<ManageCommunitiesQuery, ManageCommunitiesQueryVariables> {
    document = ManageCommunitiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCompanyDocument = gql`
    mutation createCompany($input: CompanyInput!) {
  createCompany(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCompanyGQL extends Apollo.Mutation<CreateCompanyMutation, CreateCompanyMutationVariables> {
    document = CreateCompanyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCompanyDocument = gql`
    mutation updateCompany($input: CompanyInput!, $nameUpdate: Boolean) {
  updateCompany(input: $input, nameUpdate: $nameUpdate) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCompanyGQL extends Apollo.Mutation<UpdateCompanyMutation, UpdateCompanyMutationVariables> {
    document = UpdateCompanyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCompanyDocument = gql`
    mutation deleteCompany($id: Int!) {
  deleteCompany(id: $id) {
    id
    affectedRows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCompanyGQL extends Apollo.Mutation<DeleteCompanyMutation, DeleteCompanyMutationVariables> {
    document = DeleteCompanyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllCompaniesDocument = gql`
    query allCompanies {
  allCompanies {
    id
    name
    description
    body
    category {
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllCompaniesGQL extends Apollo.Query<AllCompaniesQuery, AllCompaniesQueryVariables> {
    document = AllCompaniesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ManageCompanyDocument = gql`
    query ManageCompany($id: Int!) {
  company(id: $id) {
    id
    name
    description
    body
    url
    categoryId
    enable
    location {
      id
      cityId
      overseas
      districtId
      address
    }
    cover {
      ...FileInfo
    }
    info {
      ...InfoFields
      creator {
        id
        departmentId
      }
    }
  }
}
    ${FileInfoFragmentDoc}
${InfoFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ManageCompanyGQL extends Apollo.Query<ManageCompanyQuery, ManageCompanyQueryVariables> {
    document = ManageCompanyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ManageCompaniesDocument = gql`
    query ManageCompanies($skip: Int!, $take: Int!, $query: CompanySearchInput) {
  companies(skip: $skip, take: $take, query: $query, isManage: true) {
    totalCount
    nodes {
      id
      name
      enable
      category {
        name
      }
      info {
        ...InfoFields
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      currentPageIndex
      totalPageCount
    }
  }
}
    ${InfoFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ManageCompaniesGQL extends Apollo.Query<ManageCompaniesQuery, ManageCompaniesQueryVariables> {
    document = ManageCompaniesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCompanyCategoryDocument = gql`
    mutation createCompanyCategory($input: CompanyCategoryInput!) {
  createCompanyCategory(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCompanyCategoryGQL extends Apollo.Mutation<CreateCompanyCategoryMutation, CreateCompanyCategoryMutationVariables> {
    document = CreateCompanyCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCompanyCategoryDocument = gql`
    mutation updateCompanyCategory($input: CompanyCategoryInput!) {
  updateCompanyCategory(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCompanyCategoryGQL extends Apollo.Mutation<UpdateCompanyCategoryMutation, UpdateCompanyCategoryMutationVariables> {
    document = UpdateCompanyCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCompanyCategoryDocument = gql`
    mutation deleteCompanyCategory($id: ID!) {
  deleteCompanyCategory(id: $id) {
    id
    affectedRows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCompanyCategoryGQL extends Apollo.Mutation<DeleteCompanyCategoryMutation, DeleteCompanyCategoryMutationVariables> {
    document = DeleteCompanyCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ManageAllCompanyCategoriesDocument = gql`
    query manageAllCompanyCategories {
  allCompanyCategories(isManage: true) {
    id
    name
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ManageAllCompanyCategoriesGQL extends Apollo.Query<ManageAllCompanyCategoriesQuery, ManageAllCompanyCategoriesQueryVariables> {
    document = ManageAllCompanyCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompanyCategoryDocument = gql`
    query companyCategory($id: ID!) {
  companyCategory(id: $id) {
    id
    name
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompanyCategoryGQL extends Apollo.Query<CompanyCategoryQuery, CompanyCategoryQueryVariables> {
    document = CompanyCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompanyCategoriesDocument = gql`
    query companyCategories($skip: Int!, $take: Int!) {
  companyCategories(skip: $skip, take: $take) {
    totalCount
    nodes {
      id
      name
      type
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      currentPageIndex
      totalPageCount
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompanyCategoriesGQL extends Apollo.Query<CompanyCategoriesQuery, CompanyCategoriesQueryVariables> {
    document = CompanyCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDepartmentDocument = gql`
    mutation createDepartment($input: DepartmentInput!) {
  createDepartment(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDepartmentGQL extends Apollo.Mutation<CreateDepartmentMutation, CreateDepartmentMutationVariables> {
    document = CreateDepartmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDepartmentDocument = gql`
    mutation updateDepartment($input: DepartmentInput!) {
  updateDepartment(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDepartmentGQL extends Apollo.Mutation<UpdateDepartmentMutation, UpdateDepartmentMutationVariables> {
    document = UpdateDepartmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteDepartmentDocument = gql`
    mutation deleteDepartment($id: ID!) {
  deleteDepartment(id: $id) {
    id
    affectedRows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDepartmentGQL extends Apollo.Mutation<DeleteDepartmentMutation, DeleteDepartmentMutationVariables> {
    document = DeleteDepartmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DepartmentDocument = gql`
    query department($id: ID!) {
  department(id: $id) {
    id
    name
    enable
    level
    info {
      id
      logo {
        id
        ...FileInfo
      }
      aboutCover {
        id
        ...FileInfo
      }
      watermark {
        id
        ...FileInfo
      }
      description
      story
      email
      phoneNumber
      homeNumber
      address
      cityId
      districtId
      fullAddress
    }
  }
}
    ${FileInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DepartmentGQL extends Apollo.Query<DepartmentQuery, DepartmentQueryVariables> {
    document = DepartmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DepartmentsDocument = gql`
    query departments($skip: Int!, $take: Int!) {
  departments(skip: $skip, take: $take) {
    totalCount
    nodes {
      id
      name
      info {
        fullAddress
        phoneNumber
        homeNumber
        email
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      currentPageIndex
      totalPageCount
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DepartmentsGQL extends Apollo.Query<DepartmentsQuery, DepartmentsQueryVariables> {
    document = DepartmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllDepartmentsDocument = gql`
    query allDepartments {
  allDepartments {
    id
    name
    info {
      fullAddress
      phoneNumber
      homeNumber
      email
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllDepartmentsGQL extends Apollo.Query<AllDepartmentsQuery, AllDepartmentsQueryVariables> {
    document = AllDepartmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateExpenseDocument = gql`
    mutation createExpense($input: ExpenseInput!) {
  createExpense(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateExpenseGQL extends Apollo.Mutation<CreateExpenseMutation, CreateExpenseMutationVariables> {
    document = CreateExpenseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateExpenseDocument = gql`
    mutation updateExpense($input: ExpenseInput!) {
  updateExpense(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateExpenseGQL extends Apollo.Mutation<UpdateExpenseMutation, UpdateExpenseMutationVariables> {
    document = UpdateExpenseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteExpenseDocument = gql`
    mutation deleteExpense($id: Int!) {
  deleteExpense(id: $id) {
    id
    affectedRows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteExpenseGQL extends Apollo.Mutation<DeleteExpenseMutation, DeleteExpenseMutationVariables> {
    document = DeleteExpenseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllExpensesDocument = gql`
    query allExpenses {
  allExpenses {
    id
    userId
    rate
    sourcePrice
    referralPrice
    tax
    finalPrice
    contractId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllExpensesGQL extends Apollo.Query<AllExpensesQuery, AllExpensesQueryVariables> {
    document = AllExpensesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ManageExpenseDocument = gql`
    query manageExpense($id: Int!) {
  expense(id: $id) {
    id
    type
    user {
      departmentId
    }
    userId
    rate
    sourcePrice
    referralPrice
    tax
    finalPrice
    fillPrice
    status
    registrationDate
    completedDate
    separate
    sourceExpenseId
    comment
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ManageExpenseGQL extends Apollo.Query<ManageExpenseQuery, ManageExpenseQueryVariables> {
    document = ManageExpenseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ManageExpensesDocument = gql`
    query manageExpenses($skip: Int!, $take: Int!, $query: ExpenseSearchInput) {
  expenses(skip: $skip, take: $take, query: $query, isManage: true) {
    totalCount
    nodes {
      id
      type
      comment
      user {
        name
        department {
          name
        }
      }
      info {
        creator {
          id
          name
        }
      }
      rate
      finalPrice
      status
      registrationDate
      completedDate
      separate
      sourceExpenseId
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      currentPageIndex
      totalPageCount
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ManageExpensesGQL extends Apollo.Query<ManageExpensesQuery, ManageExpensesQueryVariables> {
    document = ManageExpensesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateFileDocument = gql`
    mutation createFile($files: [FileInput], $target: String!, $options: CreateImageOptionsInput) {
  createFile(files: $files, target: $target, options: $options) {
    id
    ...FileInfo
  }
}
    ${FileInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateFileGQL extends Apollo.Mutation<CreateFileMutation, CreateFileMutationVariables> {
    document = CreateFileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProcessFilesDocument = gql`
    mutation processFiles($filePaths: [String]) {
  processFiles(filePaths: $filePaths) {
    id
    ...FileInfo
  }
}
    ${FileInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ProcessFilesGQL extends Apollo.Mutation<ProcessFilesMutation, ProcessFilesMutationVariables> {
    document = ProcessFilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateInfoPhotoDocument = gql`
    mutation createInfoPhoto($input: InfoPhotoInput!) {
  createInfoPhoto(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateInfoPhotoGQL extends Apollo.Mutation<CreateInfoPhotoMutation, CreateInfoPhotoMutationVariables> {
    document = CreateInfoPhotoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateInfoPhotoDocument = gql`
    mutation updateInfoPhoto($input: InfoPhotoInput!) {
  updateInfoPhoto(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateInfoPhotoGQL extends Apollo.Mutation<UpdateInfoPhotoMutation, UpdateInfoPhotoMutationVariables> {
    document = UpdateInfoPhotoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteInfoPhotoDocument = gql`
    mutation deleteInfoPhoto($id: Int!) {
  deleteInfoPhoto(id: $id) {
    id
    affectedRows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteInfoPhotoGQL extends Apollo.Mutation<DeleteInfoPhotoMutation, DeleteInfoPhotoMutationVariables> {
    document = DeleteInfoPhotoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllInfoPhotosDocument = gql`
    query allInfoPhotos {
  allInfoPhotos {
    id
    subject
    body
    fileId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllInfoPhotosGQL extends Apollo.Query<AllInfoPhotosQuery, AllInfoPhotosQueryVariables> {
    document = AllInfoPhotosDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ManageInfoPhotoDocument = gql`
    query manageInfoPhoto($id: Int!) {
  infoPhoto(id: $id) {
    id
    subject
    body
    fileId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ManageInfoPhotoGQL extends Apollo.Query<ManageInfoPhotoQuery, ManageInfoPhotoQueryVariables> {
    document = ManageInfoPhotoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ManageInfoPhotosDocument = gql`
    query manageInfoPhotos($skip: Int!, $take: Int!, $query: InfoPhotoSearchInput) {
  infoPhotos(skip: $skip, take: $take, query: $query, isManage: true) {
    totalCount
    nodes {
      id
      subject
      body
      fileId
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      currentPageIndex
      totalPageCount
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ManageInfoPhotosGQL extends Apollo.Query<ManageInfoPhotosQuery, ManageInfoPhotosQueryVariables> {
    document = ManageInfoPhotosDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateLanguageDocument = gql`
    mutation createLanguage($input: LanguageInput) {
  createLanguage(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateLanguageGQL extends Apollo.Mutation<CreateLanguageMutation, CreateLanguageMutationVariables> {
    document = CreateLanguageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateLanguageDocument = gql`
    mutation updateLanguage($input: LanguageInput) {
  updateLanguage(input: $input) {
    id
    zh_tw
    en
    ja
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateLanguageGQL extends Apollo.Mutation<UpdateLanguageMutation, UpdateLanguageMutationVariables> {
    document = UpdateLanguageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteLanguageDocument = gql`
    mutation deleteLanguage($id: ID!) {
  deleteLanguage(id: $id) {
    id
    affectedRows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteLanguageGQL extends Apollo.Mutation<DeleteLanguageMutation, DeleteLanguageMutationVariables> {
    document = DeleteLanguageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllLanguagesDocument = gql`
    query allLanguages {
  allLanguages {
    id
    zh_tw
    en
    ja
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllLanguagesGQL extends Apollo.Query<AllLanguagesQuery, AllLanguagesQueryVariables> {
    document = AllLanguagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LanguageDocument = gql`
    query language($id: ID!) {
  language(id: $id) {
    id
    zh_tw
    en
    ja
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LanguageGQL extends Apollo.Query<LanguageQuery, LanguageQueryVariables> {
    document = LanguageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LanguagesDocument = gql`
    query languages($skip: Int!, $take: Int!, $query: LanguageSearchInput) {
  languages(skip: $skip, take: $take, query: $query) {
    totalCount
    nodes {
      id
      zh_tw
      en
      ja
      type
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      currentPageIndex
      totalPageCount
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LanguagesGQL extends Apollo.Query<LanguagesQuery, LanguagesQueryVariables> {
    document = LanguagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateLiveAreaDocument = gql`
    mutation createLiveArea($input: LiveAreaInput!) {
  createLiveArea(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateLiveAreaGQL extends Apollo.Mutation<CreateLiveAreaMutation, CreateLiveAreaMutationVariables> {
    document = CreateLiveAreaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateLiveAreaDocument = gql`
    mutation updateLiveArea($input: LiveAreaInput!) {
  updateLiveArea(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateLiveAreaGQL extends Apollo.Mutation<UpdateLiveAreaMutation, UpdateLiveAreaMutationVariables> {
    document = UpdateLiveAreaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteLiveAreaDocument = gql`
    mutation deleteLiveArea($id: Int!) {
  deleteLiveArea(id: $id) {
    id
    affectedRows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteLiveAreaGQL extends Apollo.Mutation<DeleteLiveAreaMutation, DeleteLiveAreaMutationVariables> {
    document = DeleteLiveAreaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllLiveAreasDocument = gql`
    query allLiveAreas {
  allLiveAreas {
    id
    name
    body
    cityId
    districtId
    address
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllLiveAreasGQL extends Apollo.Query<AllLiveAreasQuery, AllLiveAreasQueryVariables> {
    document = AllLiveAreasDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ManageLiveAreaDocument = gql`
    query manageLiveArea($id: Int!) {
  liveArea(id: $id) {
    id
    name
    body
    photos {
      id
      subject
      body
      file {
        id
        ...FileInfo
      }
    }
    cityId
    districtId
    address
    nearbyFacilities {
      massTransit {
        ...NearbyFacilityField
      }
      majorConstruction {
        ...NearbyFacilityField
      }
      departmentStore {
        ...NearbyFacilityField
      }
      medicalInformation {
        ...NearbyFacilityField
      }
      leisureFacilities {
        ...NearbyFacilityField
      }
      supermarket {
        ...NearbyFacilityField
      }
      traditionalMarket {
        ...NearbyFacilityField
      }
      shoppingDistrict {
        ...NearbyFacilityField
      }
      educationSchools {
        ...NearbyFacilityField
      }
    }
  }
}
    ${FileInfoFragmentDoc}
${NearbyFacilityFieldFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ManageLiveAreaGQL extends Apollo.Query<ManageLiveAreaQuery, ManageLiveAreaQueryVariables> {
    document = ManageLiveAreaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ManageLiveAreasDocument = gql`
    query manageLiveAreas($skip: Int!, $take: Int!, $query: LiveAreaSearchInput) {
  liveAreas(skip: $skip, take: $take, query: $query, isManage: true) {
    totalCount
    nodes {
      id
      name
      fullAddress
      info {
        ...InfoFields
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      currentPageIndex
      totalPageCount
    }
  }
}
    ${InfoFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ManageLiveAreasGQL extends Apollo.Query<ManageLiveAreasQuery, ManageLiveAreasQueryVariables> {
    document = ManageLiveAreasDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateMrtCategoryDocument = gql`
    mutation createMrtCategory($input: MrtCategoryInput!) {
  createMrtCategory(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateMrtCategoryGQL extends Apollo.Mutation<CreateMrtCategoryMutation, CreateMrtCategoryMutationVariables> {
    document = CreateMrtCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateMrtCategoryDocument = gql`
    mutation updateMrtCategory($input: MrtCategoryInput!) {
  updateMrtCategory(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateMrtCategoryGQL extends Apollo.Mutation<UpdateMrtCategoryMutation, UpdateMrtCategoryMutationVariables> {
    document = UpdateMrtCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteMrtCategoryDocument = gql`
    mutation deleteMrtCategory($id: ID!) {
  deleteMrtCategory(id: $id) {
    id
    affectedRows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteMrtCategoryGQL extends Apollo.Mutation<DeleteMrtCategoryMutation, DeleteMrtCategoryMutationVariables> {
    document = DeleteMrtCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ManageAllMrtCategoriesDocument = gql`
    query manageAllMrtCategories {
  allMrtCategories {
    id
    name
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ManageAllMrtCategoriesGQL extends Apollo.Query<ManageAllMrtCategoriesQuery, ManageAllMrtCategoriesQueryVariables> {
    document = ManageAllMrtCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MrtCategoryDocument = gql`
    query mrtCategory($id: ID!) {
  mrtCategory(id: $id, mrts: true) {
    id
    name
    type
    system
    mrts {
      id
      name
      cityId
      districtId
      address
      ...GeoPointField
    }
  }
}
    ${GeoPointFieldFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MrtCategoryGQL extends Apollo.Query<MrtCategoryQuery, MrtCategoryQueryVariables> {
    document = MrtCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MrtCategoriesDocument = gql`
    query mrtCategories($skip: Int!, $take: Int!) {
  mrtCategories(skip: $skip, take: $take) {
    totalCount
    nodes {
      id
      name
      type
      system
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      currentPageIndex
      totalPageCount
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MrtCategoriesGQL extends Apollo.Query<MrtCategoriesQuery, MrtCategoriesQueryVariables> {
    document = MrtCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateMrtDocument = gql`
    mutation createMrt($input: MrtInput!) {
  createMrt(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateMrtGQL extends Apollo.Mutation<CreateMrtMutation, CreateMrtMutationVariables> {
    document = CreateMrtDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateMrtDocument = gql`
    mutation updateMrt($input: MrtInput!) {
  updateMrt(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateMrtGQL extends Apollo.Mutation<UpdateMrtMutation, UpdateMrtMutationVariables> {
    document = UpdateMrtDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteMrtDocument = gql`
    mutation deleteMrt($id: ID!) {
  deleteMrt(id: $id) {
    id
    affectedRows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteMrtGQL extends Apollo.Mutation<DeleteMrtMutation, DeleteMrtMutationVariables> {
    document = DeleteMrtDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ManageAllMrtsDocument = gql`
    query manageAllMrts($category: String) {
  allMrts(category: $category) {
    id
    name
    cityId
    districtId
    address
    ...GeoPointField
  }
}
    ${GeoPointFieldFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ManageAllMrtsGQL extends Apollo.Query<ManageAllMrtsQuery, ManageAllMrtsQueryVariables> {
    document = ManageAllMrtsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MrtDocument = gql`
    query mrt($id: ID!) {
  mrt(id: $id) {
    id
    name
    cityId
    districtId
    overseas
    url
    lifeFunctionId
    address
    ...GeoPointField
    categoryId
  }
}
    ${GeoPointFieldFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MrtGQL extends Apollo.Query<MrtQuery, MrtQueryVariables> {
    document = MrtDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MrtsDocument = gql`
    query mrts($skip: Int!, $take: Int!, $query: MrtSearchInput) {
  mrts(skip: $skip, take: $take, query: $query) {
    totalCount
    nodes {
      id
      name
      address
      cityId
      districtId
      overseas
      url
      fullAddress
      ...GeoPointField
      lifeFunctionId
      lifeFunction {
        id
        name
      }
      category {
        id
        name
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      currentPageIndex
      totalPageCount
    }
  }
}
    ${GeoPointFieldFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MrtsGQL extends Apollo.Query<MrtsQuery, MrtsQueryVariables> {
    document = MrtsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePageDocument = gql`
    mutation createPage($input: PageInput!) {
  createPage(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePageGQL extends Apollo.Mutation<CreatePageMutation, CreatePageMutationVariables> {
    document = CreatePageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePageDocument = gql`
    mutation updatePage($input: PageInput!) {
  updatePage(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePageGQL extends Apollo.Mutation<UpdatePageMutation, UpdatePageMutationVariables> {
    document = UpdatePageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePageDocument = gql`
    mutation deletePage($id: ID!) {
  deletePage(id: $id) {
    id
    affectedRows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePageGQL extends Apollo.Mutation<DeletePageMutation, DeletePageMutationVariables> {
    document = DeletePageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ManageGetPageDocument = gql`
    query manageGetPage($id: ID!) {
  page(id: $id) {
    id
    title
    cover {
      ...FileInfo
    }
    description
    body
    defaultPage
  }
}
    ${FileInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ManageGetPageGQL extends Apollo.Query<ManageGetPageQuery, ManageGetPageQueryVariables> {
    document = ManageGetPageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPageExistDocument = gql`
    query getPageExist($id: ID!) {
  page(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPageExistGQL extends Apollo.Query<GetPageExistQuery, GetPageExistQueryVariables> {
    document = GetPageExistDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPagePageDocument = gql`
    query getPagePage($skip: Int!, $take: Int!) {
  pages(skip: $skip, take: $take) {
    totalCount
    nodes {
      id
      title
      defaultPage
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      currentPageIndex
      totalPageCount
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPagePageGQL extends Apollo.Query<GetPagePageQuery, GetPagePageQueryVariables> {
    document = GetPagePageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePayslipDocument = gql`
    mutation createPayslip($input: PayslipInput!) {
  createPayslip(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePayslipGQL extends Apollo.Mutation<CreatePayslipMutation, CreatePayslipMutationVariables> {
    document = CreatePayslipDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePayslipsDocument = gql`
    mutation createPayslips($input: [PayslipInput]!) {
  createPayslips(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePayslipsGQL extends Apollo.Mutation<CreatePayslipsMutation, CreatePayslipsMutationVariables> {
    document = CreatePayslipsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateMultiplePayslipDocument = gql`
    mutation createMultiplePayslip($input: PayslipSearchInput!) {
  createMultiplePayslip(input: $input) {
    user {
      id
      name
      department {
        id
        name
      }
      payment {
        healthInsurance {
          checked
          price
        }
        laborProtection {
          checked
          price
        }
        withholding
      }
    }
    expenses {
      id
      rate
      type
      sourcePrice
      referralPrice
      tax
      finalPrice
      fillPrice
      registrationDate
      status
      comment
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateMultiplePayslipGQL extends Apollo.Mutation<CreateMultiplePayslipMutation, CreateMultiplePayslipMutationVariables> {
    document = CreateMultiplePayslipDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePayslipDocument = gql`
    mutation updatePayslip($input: PayslipInput!) {
  updatePayslip(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePayslipGQL extends Apollo.Mutation<UpdatePayslipMutation, UpdatePayslipMutationVariables> {
    document = UpdatePayslipDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePayslipDocument = gql`
    mutation deletePayslip($id: Int!) {
  deletePayslip(id: $id) {
    id
    affectedRows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePayslipGQL extends Apollo.Mutation<DeletePayslipMutation, DeletePayslipMutationVariables> {
    document = DeletePayslipDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllPayslipsDocument = gql`
    query allPayslips {
  allPayslips {
    id
    userId
    status
    completedDate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllPayslipsGQL extends Apollo.Query<AllPayslipsQuery, AllPayslipsQueryVariables> {
    document = AllPayslipsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ManagePayslipDocument = gql`
    query managePayslip($id: Int!) {
  payslip(id: $id) {
    ...PayslipFields
  }
}
    ${PayslipFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ManagePayslipGQL extends Apollo.Query<ManagePayslipQuery, ManagePayslipQueryVariables> {
    document = ManagePayslipDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ManagePayslipsDocument = gql`
    query managePayslips($skip: Int!, $take: Int!, $query: PayslipSearchInput) {
  payslips(skip: $skip, take: $take, query: $query, isManage: true) {
    totalCount
    nodes {
      id
      comment
      user {
        name
        department {
          name
        }
      }
      userId
      status
      completedDate
      period {
        from
        to
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      currentPageIndex
      totalPageCount
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ManagePayslipsGQL extends Apollo.Query<ManagePayslipsQuery, ManagePayslipsQueryVariables> {
    document = ManagePayslipsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ManageFullPayslipsDocument = gql`
    query manageFullPayslips($skip: Int!, $take: Int!, $query: PayslipSearchInput) {
  payslips(skip: $skip, take: $take, query: $query, isManage: true) {
    totalCount
    nodes {
      ...PayslipFields
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      currentPageIndex
      totalPageCount
    }
  }
}
    ${PayslipFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ManageFullPayslipsGQL extends Apollo.Query<ManageFullPayslipsQuery, ManageFullPayslipsQueryVariables> {
    document = ManageFullPayslipsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePropertyContractDocument = gql`
    mutation createPropertyContract($input: PropertyContractInput!) {
  createPropertyContract(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePropertyContractGQL extends Apollo.Mutation<CreatePropertyContractMutation, CreatePropertyContractMutationVariables> {
    document = CreatePropertyContractDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePropertyContractDocument = gql`
    mutation updatePropertyContract($input: PropertyContractInput!) {
  updatePropertyContract(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePropertyContractGQL extends Apollo.Mutation<UpdatePropertyContractMutation, UpdatePropertyContractMutationVariables> {
    document = UpdatePropertyContractDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePropertyContractDocument = gql`
    mutation deletePropertyContract($id: Int!) {
  deletePropertyContract(id: $id) {
    id
    affectedRows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePropertyContractGQL extends Apollo.Mutation<DeletePropertyContractMutation, DeletePropertyContractMutationVariables> {
    document = DeletePropertyContractDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ManagePropertyContractDocument = gql`
    query managePropertyContract($id: Int!) {
  propertyContract(id: $id) {
    ...PropertyContractField
  }
}
    ${PropertyContractFieldFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ManagePropertyContractGQL extends Apollo.Query<ManagePropertyContractQuery, ManagePropertyContractQueryVariables> {
    document = ManagePropertyContractDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ManagePropertyContractsDocument = gql`
    query managePropertyContracts($skip: Int!, $take: Int!, $query: PropertyContractSearchInput) {
  propertyContracts(skip: $skip, take: $take, query: $query, isManage: true) {
    totalCount
    nodes {
      id
      department {
        name
      }
      basicInfo {
        creator {
          id
          name
        }
      }
      type
      status
      developers {
        name
      }
      sellers {
        name
      }
      period {
        from
        to
      }
      signDate
      propertySnapshot
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      currentPageIndex
      totalPageCount
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ManagePropertyContractsGQL extends Apollo.Query<ManagePropertyContractsQuery, ManagePropertyContractsQueryVariables> {
    document = ManagePropertyContractsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ManageFullPropertyContractsDocument = gql`
    query manageFullPropertyContracts($skip: Int!, $take: Int!, $query: PropertyContractSearchInput) {
  propertyContracts(skip: $skip, take: $take, query: $query, isManage: true) {
    totalCount
    nodes {
      ...PropertyContractField
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      currentPageIndex
      totalPageCount
    }
  }
}
    ${PropertyContractFieldFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ManageFullPropertyContractsGQL extends Apollo.Query<ManageFullPropertyContractsQuery, ManageFullPropertyContractsQueryVariables> {
    document = ManageFullPropertyContractsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePropertyReviewDocument = gql`
    mutation createPropertyReview($input: PropertyReviewInput!) {
  createPropertyReview(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePropertyReviewGQL extends Apollo.Mutation<CreatePropertyReviewMutation, CreatePropertyReviewMutationVariables> {
    document = CreatePropertyReviewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePropertyReviewDocument = gql`
    mutation updatePropertyReview($input: PropertyReviewInput!) {
  updatePropertyReview(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePropertyReviewGQL extends Apollo.Mutation<UpdatePropertyReviewMutation, UpdatePropertyReviewMutationVariables> {
    document = UpdatePropertyReviewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePropertyReviewDocument = gql`
    mutation deletePropertyReview($id: Int!) {
  deletePropertyReview(id: $id) {
    id
    affectedRows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePropertyReviewGQL extends Apollo.Mutation<DeletePropertyReviewMutation, DeletePropertyReviewMutationVariables> {
    document = DeletePropertyReviewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllPropertyReviewsDocument = gql`
    query allPropertyReviews {
  allPropertyReviews {
    id
    departmentId
    propertyId
    status
    reviewerId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllPropertyReviewsGQL extends Apollo.Query<AllPropertyReviewsQuery, AllPropertyReviewsQueryVariables> {
    document = AllPropertyReviewsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ManagePropertyReviewDocument = gql`
    query managePropertyReview($id: Int!) {
  propertyReview(id: $id) {
    id
    departmentId
    propertyId
    data
    status
    reviewerId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ManagePropertyReviewGQL extends Apollo.Query<ManagePropertyReviewQuery, ManagePropertyReviewQueryVariables> {
    document = ManagePropertyReviewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ManagePropertyReviewsDocument = gql`
    query managePropertyReviews($skip: Int!, $take: Int!, $query: PropertyReviewSearchInput) {
  propertyReviews(skip: $skip, take: $take, query: $query, isManage: true) {
    totalCount
    nodes {
      id
      department {
        id
        name
      }
      property {
        id
        name
      }
      data
      status
      reviewer {
        id
        name
      }
      reviewerId
      info {
        creator {
          id
          name
        }
        createdAt
        updatedAt
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      currentPageIndex
      totalPageCount
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ManagePropertyReviewsGQL extends Apollo.Query<ManagePropertyReviewsQuery, ManagePropertyReviewsQueryVariables> {
    document = ManagePropertyReviewsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ImportPropertyDocument = gql`
    mutation importProperty($file: Upload!) {
  importProperty(file: $file) {
    id
    affectedRows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ImportPropertyGQL extends Apollo.Mutation<ImportPropertyMutation, ImportPropertyMutationVariables> {
    document = ImportPropertyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePropertyDocument = gql`
    mutation createProperty($input: PropertyInput!) {
  createProperty(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePropertyGQL extends Apollo.Mutation<CreatePropertyMutation, CreatePropertyMutationVariables> {
    document = CreatePropertyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePropertyDocument = gql`
    mutation updateProperty($input: PropertyInput!, $enable: Boolean) {
  updateProperty(input: $input, enable: $enable) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePropertyGQL extends Apollo.Mutation<UpdatePropertyMutation, UpdatePropertyMutationVariables> {
    document = UpdatePropertyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePropertyDocument = gql`
    mutation deleteProperty($id: Int!) {
  deleteProperty(id: $id) {
    id
    affectedRows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePropertyGQL extends Apollo.Mutation<DeletePropertyMutation, DeletePropertyMutationVariables> {
    document = DeletePropertyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReLaunchPropertyDocument = gql`
    mutation reLaunchProperty($id: Int!) {
  reLaunchProperty(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReLaunchPropertyGQL extends Apollo.Mutation<ReLaunchPropertyMutation, ReLaunchPropertyMutationVariables> {
    document = ReLaunchPropertyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PropertyDocument = gql`
    query property($id: Int!) {
  property(id: $id, isManage: true) {
    id
    mrt
    communityId
    community {
      id
      name
    }
    transportationFacilities {
      id
      name
    }
    educationSchools {
      id
      name
    }
    name
    buildingName
    body
    sellerId
    seller {
      id
      name
    }
    developers {
      id
      name
    }
    departmentId
    isNew
    featured
    headline
    rentPrice
    sellPrice
    spaceNumber
    mainSpaceNumber
    elevatorsNumber
    floorNumber
    totalFloorNumber {
      up
      down
    }
    otherData
    otherData2 {
      orderAttachment
      attachFloor
      deposit
      shortest
      cook
      pet
      education
      style
      features {
        id
        description
      }
      identities {
        id
        name
        checked
        initChecked
      }
      publicUtilities {
        id
        floorNumber
      }
      basePrice {
        price
        show
        rentAttachments {
          id
          name
        }
        orderAttachment
      }
      smoke
      registered
      god
      fax
      notarization
      petComment
      smokeComment
    }
    publicRatio
    completeDate
    categoryId
    faceId
    cityId
    districtId
    address
    fullAddress
    geopoint {
      latitude
      longitude
    }
    keyBelong
    threeDImage
    photos {
      id
      subject
      body
      type
      file {
        id
        ...FileInfo
      }
      sort
    }
    parkings {
      id
      amount
      type
    }
    patterns {
      id
      amount
      type
    }
    type
    kindId
    shapeId
    launchedDate
    startDate
    expiredDate
    enable
    state
    managementFee
    managementFeePerUnit
    referralFee
    devices {
      id
      name
    }
    furnitures {
      id
      name
    }
    publicUtilities {
      id
      name
    }
    publicUtilitiesComment
    lifeFunctions {
      id
      name
    }
    styles {
      id
      name
    }
    supportSetups {
      id
      name
    }
    patternFeatures {
      id
      name
    }
    rent_attachments {
      id
      name
    }
    usages {
      id
      name
    }
    ownerId
    owner {
      name
    }
    agent {
      name
      phoneNumber
      idNumber
    }
    contracts {
      id
    }
    builderName
    businessRegistration
    doorNumber
    totalDoorNumber
    includeTax
    internalStates
    keyBelongType
    landSpaceNumber
    mainStructure
    managementPhoneNumber
    motorcycleParkingInfo {
      parkNumber
      type
      comment
    }
    on591Id
    otherSpaceNumber {
      underground
      arcade
      attached
      publicUtilities
      independentParking
      floors {
        name
        spaceNumber
      }
    }
    parkingGarageInfo {
      type
      parkNumber {
        value
      }
    }
    parkingLotInfo {
      type
    }
    securityGuard
    sourceContractType
    specialComment
    takeViewComment
    takeViewPrice
    takeViewSpecialTime
    taxPercentage
  }
}
    ${FileInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PropertyGQL extends Apollo.Query<PropertyQuery, PropertyQueryVariables> {
    document = PropertyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ManagePropertiesDocument = gql`
    query manageProperties($skip: Int!, $take: Int!, $query: PropertySearchInput, $orderBy: String) {
  properties(
    skip: $skip
    take: $take
    query: $query
    isManage: true
    orderBy: $orderBy
  ) {
    totalCount
    nodes {
      id
      name
      type
      headline
      featured
      department {
        name
      }
      price
      photo {
        file {
          targetPath
        }
      }
      geopoint {
        latitude
        longitude
      }
      category {
        name
      }
      fullAddress
      seller {
        name
      }
      address
      age
      launched
      state
      contracts {
        id
        status
        type
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      currentPageIndex
      totalPageCount
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ManagePropertiesGQL extends Apollo.Query<ManagePropertiesQuery, ManagePropertiesQueryVariables> {
    document = ManagePropertiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePropertyCategoryDocument = gql`
    mutation createPropertyCategory($input: PropertyCategoryInput!) {
  createPropertyCategory(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePropertyCategoryGQL extends Apollo.Mutation<CreatePropertyCategoryMutation, CreatePropertyCategoryMutationVariables> {
    document = CreatePropertyCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePropertyCategoryDocument = gql`
    mutation updatePropertyCategory($input: PropertyCategoryInput!) {
  updatePropertyCategory(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePropertyCategoryGQL extends Apollo.Mutation<UpdatePropertyCategoryMutation, UpdatePropertyCategoryMutationVariables> {
    document = UpdatePropertyCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePropertyCategoryDocument = gql`
    mutation deletePropertyCategory($id: ID!) {
  deletePropertyCategory(id: $id) {
    id
    affectedRows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePropertyCategoryGQL extends Apollo.Mutation<DeletePropertyCategoryMutation, DeletePropertyCategoryMutationVariables> {
    document = DeletePropertyCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllPropertyCategoriesDocument = gql`
    query allPropertyCategories {
  allPropertyCategories {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllPropertyCategoriesGQL extends Apollo.Query<AllPropertyCategoriesQuery, AllPropertyCategoriesQueryVariables> {
    document = AllPropertyCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PropertyCategoryDocument = gql`
    query propertyCategory($id: ID!) {
  propertyCategory(id: $id) {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PropertyCategoryGQL extends Apollo.Query<PropertyCategoryQuery, PropertyCategoryQueryVariables> {
    document = PropertyCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PropertyCategoriesDocument = gql`
    query propertyCategories($skip: Int!, $take: Int!) {
  propertyCategories(skip: $skip, take: $take) {
    totalCount
    nodes {
      id
      name
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      currentPageIndex
      totalPageCount
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PropertyCategoriesGQL extends Apollo.Query<PropertyCategoriesQuery, PropertyCategoriesQueryVariables> {
    document = PropertyCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePropertyOrderDocument = gql`
    mutation deletePropertyOrder($id: Int!) {
  deletePropertyOrder(id: $id) {
    id
    affectedRows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePropertyOrderGQL extends Apollo.Mutation<DeletePropertyOrderMutation, DeletePropertyOrderMutationVariables> {
    document = DeletePropertyOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PropertyOrderDocument = gql`
    query propertyOrder($id: Int!) {
  propertyOrder(id: $id) {
    id
    sellerId
    ownerId
    fullAddress
    rentPrice
    sellPrice
    managementFee
    floorNumber
    totalFloorNumber {
      up
      down
    }
    comment
    orderPeriod
    otherData
    agent {
      name
      phoneNumber
      idNumber
    }
    owner {
      name
      account
      profile {
        idNumber
        phoneNumber
        homeNumber
        fullAddress
        email
      }
    }
    seller {
      name
    }
    parkings {
      amount
      type
    }
    patterns {
      amount
      type
    }
    rent_attachments {
      name
    }
    usages {
      name
    }
    info {
      createdAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PropertyOrderGQL extends Apollo.Query<PropertyOrderQuery, PropertyOrderQueryVariables> {
    document = PropertyOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PropertyOrdersDocument = gql`
    query propertyOrders($skip: Int!, $take: Int!, $query: PropertyOrderSearchInput) {
  propertyOrders(skip: $skip, take: $take, query: $query) {
    totalCount
    nodes {
      id
      seller {
        name
        department {
          name
        }
      }
      owner {
        name
      }
      fullAddress
      address
      info {
        createdAt
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      currentPageIndex
      totalPageCount
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PropertyOrdersGQL extends Apollo.Query<PropertyOrdersQuery, PropertyOrdersQueryVariables> {
    document = PropertyOrdersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateRoleDocument = gql`
    mutation createRole($input: RoleInput!) {
  createRole(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateRoleGQL extends Apollo.Mutation<CreateRoleMutation, CreateRoleMutationVariables> {
    document = CreateRoleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateRoleDocument = gql`
    mutation updateRole($input: RoleInput!) {
  updateRole(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateRoleGQL extends Apollo.Mutation<UpdateRoleMutation, UpdateRoleMutationVariables> {
    document = UpdateRoleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteRoleDocument = gql`
    mutation deleteRole($id: ID!) {
  deleteRole(id: $id) {
    id
    affectedRows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteRoleGQL extends Apollo.Mutation<DeleteRoleMutation, DeleteRoleMutationVariables> {
    document = DeleteRoleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ManageAllRolesDocument = gql`
    query manageAllRoles($department: String!) {
  allRoles(department: $department) {
    id
    name
    level
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ManageAllRolesGQL extends Apollo.Query<ManageAllRolesQuery, ManageAllRolesQueryVariables> {
    document = ManageAllRolesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ManageRoleDocument = gql`
    query manageRole($id: ID!) {
  role(id: $id) {
    id
    name
    enable
    level
    departmentId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ManageRoleGQL extends Apollo.Query<ManageRoleQuery, ManageRoleQueryVariables> {
    document = ManageRoleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ManageRolesDocument = gql`
    query manageRoles($skip: Int!, $take: Int!) {
  roles(skip: $skip, take: $take) {
    totalCount
    nodes {
      id
      name
      enable
      level
      departmentId
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      currentPageIndex
      totalPageCount
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ManageRolesGQL extends Apollo.Query<ManageRolesQuery, ManageRolesQueryVariables> {
    document = ManageRolesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ManageSystemDocument = gql`
    query manageSystem($id: ID!) {
  system(id: $id) {
    id
    type
    data
    dataJSON
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ManageSystemGQL extends Apollo.Query<ManageSystemQuery, ManageSystemQueryVariables> {
    document = ManageSystemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSystemDocument = gql`
    mutation updateSystem($input: SystemInput!) {
  updateSystem(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSystemGQL extends Apollo.Mutation<UpdateSystemMutation, UpdateSystemMutationVariables> {
    document = UpdateSystemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUserDocument = gql`
    mutation createUser($input: UserInput!) {
  createUser(input: $input) {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUserGQL extends Apollo.Mutation<CreateUserMutation, CreateUserMutationVariables> {
    document = CreateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserDocument = gql`
    mutation updateUser($input: UserInput!) {
  updateUser(input: $input) {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserGQL extends Apollo.Mutation<UpdateUserMutation, UpdateUserMutationVariables> {
    document = UpdateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SortUserDocument = gql`
    mutation sortUser($input: [UserInput!]!) {
  sortUser(input: $input) {
    affectedRows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SortUserGQL extends Apollo.Mutation<SortUserMutation, SortUserMutationVariables> {
    document = SortUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteUserDocument = gql`
    mutation deleteUser($id: ID!) {
  deleteUser(id: $id) {
    id
    affectedRows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteUserGQL extends Apollo.Mutation<DeleteUserMutation, DeleteUserMutationVariables> {
    document = DeleteUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TransferUserDocument = gql`
    mutation transferUser($from: ID!, $to: ID!, $type: [String]!, $propertyIds: [String], $expenseIds: [String]) {
  transferUser(
    from: $from
    to: $to
    type: $type
    propertyIds: $propertyIds
    expenseIds: $expenseIds
  ) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TransferUserGQL extends Apollo.Mutation<TransferUserMutation, TransferUserMutationVariables> {
    document = TransferUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllUserDocument = gql`
    query allUser {
  allUsers {
    id
    account
    name
    cover {
      ...FileInfo
    }
    roleId
    departmentId
  }
}
    ${FileInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AllUserGQL extends Apollo.Query<AllUserQuery, AllUserQueryVariables> {
    document = AllUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserDocument = gql`
    query getUser($id: ID!) {
  user(id: $id) {
    id
    info {
      creatorId
      creator {
        name
      }
    }
    account
    sort
    firstName
    lastName
    cover {
      ...FileInfo
    }
    roleId
    departmentId
    profile {
      ...UserProfileFields
    }
    socials {
      id
      type
      customId
      path
      imgId
      img {
        ...FileInfo
      }
    }
    photos {
      id
      subject
      body
      file {
        id
        ...FileInfo
      }
    }
  }
}
    ${FileInfoFragmentDoc}
${UserProfileFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserGQL extends Apollo.Query<GetUserQuery, GetUserQueryVariables> {
    document = GetUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserPageDocument = gql`
    query getUserPage($skip: Int!, $take: Int!, $query: UserSearchInput, $search: Boolean) {
  users(skip: $skip, take: $take, query: $query, search: $search) {
    totalCount
    nodes {
      id
      account
      name
      roleId
      role {
        name
      }
      sort
      department {
        name
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      currentPageIndex
      totalPageCount
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserPageGQL extends Apollo.Query<GetUserPageQuery, GetUserPageQueryVariables> {
    document = GetUserPageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CheckUserDocument = gql`
    query checkUser($id: ID!) {
  user(id: $id) {
    id
    account
    properties {
      all {
        id
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CheckUserGQL extends Apollo.Query<CheckUserQuery, CheckUserQueryVariables> {
    document = CheckUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetClientUserPageDocument = gql`
    query getClientUserPage($skip: Int!, $take: Int!, $query: UserSearchInput, $search: Boolean) {
  users(skip: $skip, take: $take, query: $query, search: $search, isManage: true) {
    totalCount
    nodes {
      id
      account
      name
      roleId
      role {
        name
      }
      sort
      department {
        name
      }
      profile {
        phoneNumber
      }
      ownerProperties {
        id
      }
      landlordPropertyContracts {
        id
      }
      tenantPropertyContracts {
        id
      }
      info {
        creatorId
        creator {
          name
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      currentPageIndex
      totalPageCount
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetClientUserPageGQL extends Apollo.Query<GetClientUserPageQuery, GetClientUserPageQueryVariables> {
    document = GetClientUserPageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }